/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Ethereum address */
  Address: string;
  /** A string that cannot be passed as an empty value */
  CountryCode: string;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: string;
  /** Ethereum name service value with `.eth` suffix */
  ENS: string;
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: unknown;
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: string;
  /** A string that cannot be passed as an empty value */
  NonEmptyString: string;
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: number;
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: number;
  /** Integers that will have a value greater than 0. */
  PositiveInt: number;
  /** Semantic version string */
  SemanticVersion: string;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: number;
  /** A valid Ethereum transaction hash string */
  TransactionHash: string;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: string;
  /** UUID v4 */
  UUID: string;
  /** Represents NULL values */
  Void: null;
};

/** Mark the provided multi-part upload as aborted */
export type AbortMultipartUploadRequest = {
  /** Upload ID to use for each upload part of the final object */
  uploadId: Scalars['String'];
  /** Upload key for the final upload object */
  uploadKey: Scalars['String'];
};

/** Input options for acceptArtistApplication mutation */
export type AcceptArtistApplicationInput = {
  /** Artist application entity id */
  artistApplicationId: Scalars['UUID'];
};

/** Filter activity feed */
export type ActivityFeedFilterArgs = {
  /** Only get activity feed of certain type */
  activityFeedType?: ActivityFeedType | '%future added value';
};

/** Activity feed group component type */
export const ActivityFeedGroupComponentType = {
  ReleasesAddedToShelf: 'RELEASES_ADDED_TO_SHELF',
  ReleaseDropped: 'RELEASE_DROPPED',
  ShelfCreated: 'SHELF_CREATED',
  SongCollectedByMany: 'SONG_COLLECTED_BY_MANY',
  UserCollectedManySongs: 'USER_COLLECTED_MANY_SONGS',
  UserCreatedPost: 'USER_CREATED_POST',
  UserLikedPlaylist: 'USER_LIKED_PLAYLIST',
  UserLikedSongs: 'USER_LIKED_SONGS',
  UserPurchasedSecondaryManySongs: 'USER_PURCHASED_SECONDARY_MANY_SONGS'
} as const;

export type ActivityFeedGroupComponentType = typeof ActivityFeedGroupComponentType[keyof typeof ActivityFeedGroupComponentType];
/** Filter activity feed groups */
export type ActivityFeedGroupFilterArgs = {
  /** Only get activity feed groups of certain type */
  types?: Array<ActivityFeedGroupFilterOption | '%future added value'>;
};

/** Activity feed group filter option */
export const ActivityFeedGroupFilterOption = {
  AddedToPlaylist: 'ADDED_TO_PLAYLIST',
  All: 'ALL',
  Collected: 'COLLECTED',
  Likes: 'LIKES',
  Posts: 'POSTS',
  ReleaseDropped: 'RELEASE_DROPPED'
} as const;

export type ActivityFeedGroupFilterOption = typeof ActivityFeedGroupFilterOption[keyof typeof ActivityFeedGroupFilterOption];
/** Activity feed type */
export const ActivityFeedType = {
  Global: 'GLOBAL',
  NotableCollectors: 'NOTABLE_COLLECTORS',
  User: 'USER'
} as const;

export type ActivityFeedType = typeof ActivityFeedType[keyof typeof ActivityFeedType];
/** Input for `addReleaseToShelf` mutation */
export type AddReleaseToShelfInput = {
  /** Specify index to insert the release within the shelf */
  index?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Release identifier to be added */
  releaseId: Scalars['UUID'];
  /** Identifier of owned target shelf to receive the new release */
  shelfId: Scalars['UUID'];
};

/** Input for addUsersToDraftAllowlist mutation */
export type AddUsersToDraftAllowlistInput = {
  /** Draft info input */
  addresses: Array<AllowedAddressInput>;
  /** Draft identifier */
  draftId: Scalars['UUID'];
  /** Draft allowlist sale type */
  mintType: MintingAccessConfigMintingType | '%future added value';
};

/** Weights for determining user follow recommendations */
export type AdminUserFollowRecommendationWeights = {
  /** Weight of listen activity */
  listen: Scalars['Int'];
  /** Minimum listen duration to qualify (seconds) */
  listenDurationMin: Scalars['Int'];
  /** Aggregate listen duration that results in a single unit of activity (seconds) */
  listenDurationUnit: Scalars['Int'];
  /** Weight of purchase activity */
  purchase: Scalars['Int'];
  /** Weight of release post activity */
  releasePost: Scalars['Int'];
};

/** Input for setAffiliatePurchaseSource mutation */
export type AffiliateSourceInput = {
  /** Chain of the transaction */
  chain: ChainType | '%future added value';
  /** Param value of referral source */
  referralSource: Scalars['String'];
  /** Transaction hash associated with affiliate purchase */
  txHash: Scalars['TransactionHash'];
};

/** Pagination parameters for allCollectors */
export type AllCollectorsCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: AllCollectorsCursorConnectionSort;
};

/** Customize sort of collectors */
export type AllCollectorsCursorConnectionSort = {
  /** Sort by date of user first being connected in platform */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
};

/** Filter the allCollectors result */
export type AllCollectorsFilter = {
  /** Genre names to filter on for collector's releases */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Should it include artists as collectors */
  includeArtists?: Scalars['Boolean'];
  /** Location ids to filter on for collector's releases */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Should it only include collectors with a valid username (twitterHandle, ens or displayName) */
  onlyWithUsername?: Scalars['Boolean'];
};

/** Input for allCollectors query */
export type AllCollectorsInput = {
  /** Filter the collectors */
  filter?: AllCollectorsFilter;
  /** Pagination parameters of collectors */
  pagination?: AllCollectorsCursorConnectionArgs;
};

/** Pagination parameters for allShelves */
export type AllShelvesCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: AllShelvesCursorConnectionSort;
};

/** Customize sort of shelves */
export type AllShelvesCursorConnectionSort = {
  /** Sort by date of playlist being created */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
};

/** Filter the shelves of allShelves query */
export type AllShelvesFilter = {
  /** Genre names to filter on for shelf songs */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Filter the shelves based on the expected types */
  type?: Array<ShelfTypeFilter | '%future added value'>;
};

/** Input for allShelves query */
export type AllShelvesInput = {
  /** Filter the shelves, by default it gives all the user created shelves */
  filter?: AllShelvesFilter;
  /** Pagination parameters, by default it gives the last 10 shelves created */
  pagination?: AllShelvesCursorConnectionArgs;
};

/** Allocation input for credit split creation */
export type Allocation = {
  /** Owner address of allocation */
  ownerAddress: Scalars['Address'];
  /** Percent of allocation */
  percent: Scalars['Float'];
  /** Roles associated with credit allocation */
  roles: Array<Scalars['String']>;
};

/** Address to be added in allowlist */
export type AllowedAddressInput = {
  /** Public address included in allowlist */
  address: Scalars['Address'];
  /** Source of the address added in allowlist */
  source: AllowlistSourceType | '%future added value';
};

/** Source of allowlist address */
export const AllowlistSourceType = {
  ArtistSoundHolder: 'ARTIST_SOUND_HOLDER',
  Manual: 'MANUAL',
  Unknown: 'UNKNOWN'
} as const;

export type AllowlistSourceType = typeof AllowlistSourceType[keyof typeof AllowlistSourceType];
/** Allow list types */
export const AllowlistType = {
  ArtistCollectors: 'ARTIST_COLLECTORS',
  ManuallyAdded: 'MANUALLY_ADDED',
  ReleaseCollectors: 'RELEASE_COLLECTORS'
} as const;

export type AllowlistType = typeof AllowlistType[keyof typeof AllowlistType];
/** Possible options of role update input */
export const AlterRole = {
  /** Administrator of platform */
  Admin: 'ADMIN',
  /** Member of artist relations team */
  ArtistRelations: 'ARTIST_RELATIONS'
} as const;

export type AlterRole = typeof AlterRole[keyof typeof AlterRole];
/** Artist activity feed action type filter option */
export const ArtistActivityFeedActivityTypeFilterOption = {
  All: 'ALL',
  Collections: 'COLLECTIONS',
  Likes: 'LIKES',
  Playlists: 'PLAYLISTS',
  Posts: 'POSTS',
  Releases: 'RELEASES'
} as const;

export type ArtistActivityFeedActivityTypeFilterOption = typeof ArtistActivityFeedActivityTypeFilterOption[keyof typeof ArtistActivityFeedActivityTypeFilterOption];
/** Filter artist activity types */
export type ArtistActivityFeedFilterArgs = {
  /** Only get activity of given action type */
  activityTypes?: Array<ArtistActivityFeedActivityTypeFilterOption | '%future added value'>;
  /** Only get activity by the given group */
  types?: Array<ArtistActivityFeedTypeFilterOption | '%future added value'>;
};

/** Artist activity feed type filter option */
export const ArtistActivityFeedTypeFilterOption = {
  All: 'ALL',
  Artist: 'ARTIST',
  Collector: 'COLLECTOR',
  Release: 'RELEASE'
} as const;

export type ArtistActivityFeedTypeFilterOption = typeof ArtistActivityFeedTypeFilterOption[keyof typeof ArtistActivityFeedTypeFilterOption];
/** Artist application status */
export const ArtistApplicationStatus = {
  Accepted: 'ACCEPTED',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type ArtistApplicationStatus = typeof ArtistApplicationStatus[keyof typeof ArtistApplicationStatus];
/** Filter of Query.artistApplications paginated field */
export type ArtistApplicationsFilter = {
  /** Filters on application status */
  status?: Array<ArtistApplicationStatus | '%future added value'>;
};

/** Pagination paramaters for artist collectors */
export type ArtistCollectorCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ArtistCollectorCursorConnectionSort;
};

/** Customize sort of collectors */
export type ArtistCollectorCursorConnectionSort = {
  /** Sort by first nft collected date */
  firstNftCollectedDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by amount nfts collected, with tie-breaker of earliest collector first */
  nftsCount?: InputMaybe<SortOrder | '%future added value'>;
};

/** Input for artistCommunityCSVUrl mutation */
export type ArtistCommunityCsvUrlInput = {
  /** Artist community type */
  communityType: ArtistCommunityType | '%future added value';
};

/** Artist community types */
export const ArtistCommunityType = {
  Collectors: 'COLLECTORS'
} as const;

export type ArtistCommunityType = typeof ArtistCommunityType[keyof typeof ArtistCommunityType];
/** Filter for paginated artists */
export type ArtistCursorFilterArgs = {
  /** Genre names to filter on for artist's releases */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Specify whether artist already has at least one collector (minted release) */
  hasCollector?: InputMaybe<Scalars['Boolean']>;
  /**
   * Specify whether artist already has at least one release
   * @deprecated Use 'hasRelease' instead
   */
  hasMintedRelease?: InputMaybe<Scalars['Boolean']>;
  /** Specify whether artist already has at least one release */
  hasRelease?: InputMaybe<Scalars['Boolean']>;
  /** Location IDs from Google Places API to filter on for artist's releases */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Specify season to be filtered */
  season?: InputMaybe<ArtistSeason | '%future added value'>;
};

/** Input for artistDrafts query */
export type ArtistDraftsInput = {
  /** Cursor connection parameters */
  pagination?: DraftCursorConnectionArgs;
};

/** Artist meta configuration input */
export type ArtistMetaInput = {
  /** Gem Collection URL */
  gemCollectionUrl?: InputMaybe<Scalars['URL']>;
};

/** Artist minted releases author filter option */
export const ArtistMintedReleasesAuthorFilterOption = {
  All: 'ALL',
  OnlyAppearsOn: 'ONLY_APPEARS_ON',
  OnlyAuthoredReleases: 'ONLY_AUTHORED_RELEASES'
} as const;

export type ArtistMintedReleasesAuthorFilterOption = typeof ArtistMintedReleasesAuthorFilterOption[keyof typeof ArtistMintedReleasesAuthorFilterOption];
/** Artist minted releases credit split filter option */
export const ArtistMintedReleasesCreditSplitFilterOption = {
  All: 'ALL',
  OnlyCreditSplits: 'ONLY_CREDIT_SPLITS',
  OnlyNoCreditSplits: 'ONLY_NO_CREDIT_SPLITS'
} as const;

export type ArtistMintedReleasesCreditSplitFilterOption = typeof ArtistMintedReleasesCreditSplitFilterOption[keyof typeof ArtistMintedReleasesCreditSplitFilterOption];
/** Filter for artist minted releases. Default is only for artist sounds. */
export type ArtistMintedReleasesFilter = {
  /** Filters on release credit split status */
  creditSplit?: ArtistMintedReleasesCreditSplitFilterOption | '%future added value';
  /** Excludes specific releaseIds */
  excludeReleaseIds?: Array<Scalars['UUID']>;
  /** Filters on release with specified mint time status */
  mintTimeStatus?: Array<MintTimeStatus | '%future added value'>;
  /** Filters on whether album releases have been revealed or not */
  releaseAlbumRevealStatus?: ReleaseAlbumRevealFilterOption | '%future added value';
  /** Filters on release author status */
  releaseAuthor?: ArtistMintedReleasesAuthorFilterOption | '%future added value';
  /** Filters on release type */
  releaseType?: Array<ReleaseType | '%future added value'>;
};

/** Cursor connection parameters */
export type ArtistNotificationSubscriptionCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Sort the ArtistNotificationSubscriptions ascending or descending relative to the entity creation date */
  sort?: SortOrder | '%future added value';
};

/** Input for artistPrivateCommunityMembers query */
export type ArtistPrivateCommunityMembersInput = {
  /** Pagination parameters */
  pagination?: ArtistCollectorCursorConnectionArgs;
};

/** Artist releases author filter option */
export const ArtistReleasesAuthorFilterOption = {
  All: 'ALL',
  OnlyAppearsOn: 'ONLY_APPEARS_ON',
  OnlyAuthoredReleases: 'ONLY_AUTHORED_RELEASES'
} as const;

export type ArtistReleasesAuthorFilterOption = typeof ArtistReleasesAuthorFilterOption[keyof typeof ArtistReleasesAuthorFilterOption];
/** Artist releases credit split filter option */
export const ArtistReleasesCreditSplitFilterOption = {
  All: 'ALL',
  OnlyCreditSplits: 'ONLY_CREDIT_SPLITS',
  OnlyNoCreditSplits: 'ONLY_NO_CREDIT_SPLITS'
} as const;

export type ArtistReleasesCreditSplitFilterOption = typeof ArtistReleasesCreditSplitFilterOption[keyof typeof ArtistReleasesCreditSplitFilterOption];
/** Filter for artist releases. Default is only for artist sounds. */
export type ArtistReleasesFilter = {
  /** Filters on release credit split status */
  creditSplit?: ArtistReleasesCreditSplitFilterOption | '%future added value';
  /** Excludes specific releaseIds */
  excludeReleaseIds?: Array<Scalars['UUID']>;
  /** Filters on release with specified mint time status */
  mintTimeStatus?: Array<MintTimeStatus | '%future added value'>;
  /** Filters on whether album releases have been revealed or not */
  releaseAlbumRevealStatus?: ReleaseAlbumRevealFilterOption | '%future added value';
  /** Filters on release author status */
  releaseAuthor?: ArtistReleasesAuthorFilterOption | '%future added value';
  /** Filters on release type */
  releaseType?: Array<ReleaseType | '%future added value'>;
};

/** Filter the artists to be searched */
export type ArtistSearchFilter = {
  /** Genre names to filter on for artist's releases */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Only include artists that either have or don't have collectors */
  hasCollectors?: InputMaybe<Scalars['Boolean']>;
  /** Location IDs from Google Places API to filter on for artist's releases */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Customize sort of releases */
export type ArtistSearchSort = {
  /** Sort by creation date */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by number of mints of each release */
  totalMinted?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by total volume of all artist releases */
  totalVolume?: InputMaybe<SortOrder | '%future added value'>;
};

/** Types of seasons for artists */
export const ArtistSeason = {
  Genesis: 'GENESIS',
  SeasonFour: 'SEASON_FOUR',
  SeasonOne: 'SEASON_ONE',
  SeasonThree: 'SEASON_THREE',
  SeasonTwo: 'SEASON_TWO'
} as const;

export type ArtistSeason = typeof ArtistSeason[keyof typeof ArtistSeason];
/** Defines sort order of Artist fields, array index defines tiebreaking */
export type ArtistSortInput = {
  /** Field to be sorted */
  field: SearchArtistsSortEnum | '%future added value';
  /** Sort ascending or descending */
  order: SortOrder | '%future added value';
};

/** Draft auction configuration input values */
export type AuctionConfigurationInput = {
  /** Auction end time */
  endTime?: InputMaybe<Scalars['Timestamp']>;
  /** Auction end time in days */
  endTimeDays?: InputMaybe<Scalars['Int']>;
  /** Max mints per wallet for auction */
  maxMintsPerWallet: Scalars['PositiveInt'];
  /** Price per mint */
  price: Scalars['NonNegativeFloat'];
  /** Max supply for auction */
  quantity: Scalars['PositiveInt'];
  /** Auction start time */
  startTime: Scalars['Timestamp'];
};

/** Tiered Draft auction configurations input values */
export type AuctionConfigurationsInput = {
  /** Type of auction */
  auctionType: AuctionType | '%future added value';
  /** Toggle to enable SAM for auction */
  enabledSAM?: InputMaybe<Scalars['Boolean']>;
  /** Max mint supply of auction */
  maxMintable: Scalars['PositiveInt'];
  /** Min mint supply of auction */
  minQuantity: Scalars['PositiveInt'];
  /** Presale mint auction configurations */
  presaleMint?: InputMaybe<AuctionConfigurationInput>;
  /** Public mint auction configurations */
  publicMint: AuctionConfigurationInput;
  /** Breakdown of mint quantities */
  quantityBreakdown?: InputMaybe<Array<Scalars['PositiveInt']>>;
};

/** Customize auction options based on type of sale */
export type AuctionInputRef = {
  /** fixed sales */
  fixed?: InputMaybe<FixedAuctionInput>;
  /** open editions */
  openEdition?: InputMaybe<OpenEditionAuctionInput>;
  /** Open edition with SAM auction configurations */
  openEditionWithSam?: InputMaybe<OpenEditionAuctionWithSamInput>;
  /** Range bound sales */
  rangeBound?: InputMaybe<RangeBoundAuctionInput>;
};

/** Special meta options relation to auction */
export type AuctionMetaInput = {
  /** Allow split functionality */
  hasSplitsAccess: Scalars['Boolean'];
};

/** Types of release sales */
export const AuctionType = {
  FixedQuantity: 'FIXED_QUANTITY',
  FixedQuantityWithGa: 'FIXED_QUANTITY_WITH_GA',
  OpenEdition: 'OPEN_EDITION',
  OpenEditionWithGa: 'OPEN_EDITION_WITH_GA',
  OpenEditionWithSam: 'OPEN_EDITION_WITH_SAM',
  RangeBound: 'RANGE_BOUND'
} as const;

export type AuctionType = typeof AuctionType[keyof typeof AuctionType];
/** Chain name supported on the platform */
export const ChainType = {
  Base: 'BASE',
  BaseGoerli: 'BASE_GOERLI',
  Goerli: 'GOERLI',
  Mainnet: 'MAINNET',
  Optimism: 'OPTIMISM',
  OptimismGoerli: 'OPTIMISM_GOERLI'
} as const;

export type ChainType = typeof ChainType[keyof typeof ChainType];
/** Input of "changeRoleForUser" mutation */
export type ChangeRoleInput = {
  /** Wallet public address of user */
  publicAddress: Scalars['Address'];
  /** Role to be set for specified user */
  role: AlterRole | '%future added value';
  /** Set if specified role is going to be enabled or disabled */
  value: Scalars['Boolean'];
};

/** The role of the channel curator */
export const ChannelCuratorRole = {
  Moderator: 'MODERATOR',
  Owner: 'OWNER'
} as const;

export type ChannelCuratorRole = typeof ChannelCuratorRole[keyof typeof ChannelCuratorRole];
/** Input for "channelMembersWhoAreFollowed" query */
export type ChannelMemberFollowedInput = {
  /** Channel identifier */
  channelId: Scalars['UUID'];
};

export const ChannelNotificationStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type ChannelNotificationStatus = typeof ChannelNotificationStatus[keyof typeof ChannelNotificationStatus];
/** Name of the collection market */
export const CollectionMarketType = {
  Airdrop: 'AIRDROP',
  BondingCurveSale: 'BONDING_CURVE_SALE',
  PrimarySale: 'PRIMARY_SALE',
  SecondarySale: 'SECONDARY_SALE'
} as const;

export type CollectionMarketType = typeof CollectionMarketType[keyof typeof CollectionMarketType];
/** Filter collector feed activity types */
export type CollectorActivityFeedFilterArgs = {
  /** Only get activity of given type */
  types?: Array<CollectorActivityFeedTypeFilterOption | '%future added value'>;
};

/** Collector activity feed type filter option */
export const CollectorActivityFeedTypeFilterOption = {
  All: 'ALL',
  Collections: 'COLLECTIONS',
  Likes: 'LIKES',
  Playlists: 'PLAYLISTS',
  Posts: 'POSTS'
} as const;

export type CollectorActivityFeedTypeFilterOption = typeof CollectorActivityFeedTypeFilterOption[keyof typeof CollectorActivityFeedTypeFilterOption];
/** Pagination parameters of collector comments */
export type CollectorCommentCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: CollectorCommentCursorConnectionSort;
};

/** Customize sort of release shelves */
export type CollectorCommentCursorConnectionSort = {
  /** Sort by date of comment creation */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
};

/** Filter the releases to be searched */
export type CollectorSearchFilter = {
  /** Genre names to filter on for collector's releases */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Location ids to filter on for collector's releases */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Customize sort of collectors */
export type CollectorSearchSort = {
  /** Sort by number of distinct artists the collector backed */
  artistsBacked?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by creation date */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by number of nfts */
  nftsCount?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by number of mints of each release */
  totalMinted?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by total volume of all collector releases */
  totalVolume?: InputMaybe<SortOrder | '%future added value'>;
};

/** Defines sort order of Collector fields, array index defines tiebreaking */
export type CollectorSortInput = {
  /** Field to be sorted */
  field: SearchCollectorsSortEnum | '%future added value';
  /** Sort ascending or descending */
  order: SortOrder | '%future added value';
};

/** Mark the provided multi-part upload as complete */
export type CompleteMultipartUploadRequest = {
  /** Ordered list of uploaded multi-part parts to associate with the final object */
  parts: Array<CompletedMultipartUploadPart>;
  /** Upload ID to use for each upload part of the final object */
  uploadId: Scalars['String'];
  /** Upload key for the final upload object */
  uploadKey: Scalars['String'];
};

/** Multi-part part information */
export type CompletedMultipartUploadPart = {
  /** Opaque identifier of the part data */
  etag: Scalars['String'];
  /** Individual part number identifier */
  partNumber: Scalars['Int'];
};

/** Contract methods of transactions */
export const ContractMethod = {
  AffiliateWithdraw: 'AFFILIATE__WITHDRAW',
  ArtistBuyEdition: 'ARTIST__BUY_EDITION',
  ArtistWithdrawFunds: 'ARTIST__WITHDRAW_FUNDS',
  CollectorTransferEdition: 'COLLECTOR__TRANSFER_EDITION',
  DraftSoundCreatorCreateSoundAndMints: 'DRAFT_SOUND_CREATOR__CREATE_SOUND_AND_MINTS',
  DraftSplitMainCreateSplit: 'DRAFT_SPLIT_MAIN__CREATE_SPLIT',
  MulticallWithdraw: 'MULTICALL__WITHDRAW',
  SamBuyEdition: 'SAM__BUY_EDITION',
  SamSellEdition: 'SAM__SELL_EDITION',
  SoundCreatorCreateSoundAndMints: 'SOUND_CREATOR__CREATE_SOUND_AND_MINTS',
  SoundEditionWithdrawEth: 'SOUND_EDITION__WITHDRAW_ETH',
  SplitMainCreateSplit: 'SPLIT_MAIN__CREATE_SPLIT',
  SplitMainDistributeEth: 'SPLIT_MAIN__DISTRIBUTE_ETH',
  SplitMainWithdraw: 'SPLIT_MAIN__WITHDRAW'
} as const;

export type ContractMethod = typeof ContractMethod[keyof typeof ContractMethod];
/** Input for release by contract */
export type ContractReleaseInput = {
  /** Contract address */
  contractAddress: Scalars['Address'];
  /** Optional edition identifier */
  editionId?: InputMaybe<Scalars['String']>;
};

/** Contract type on chain */
export const ContractType = {
  Artist: 'ARTIST',
  Edition: 'EDITION',
  TieredEdition: 'TIERED_EDITION'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];
/** Input options for creating artist application */
export type CreateArtistApplicationInput = {
  /** Artist name */
  artistName: Scalars['String'];
  /** Cover image */
  coverImage: UploadedMedia;
  /** Email address */
  email: Scalars['EmailAddress'];
  /** Instagram handle */
  instagramHandle?: InputMaybe<Scalars['String']>;
  /** Sound handle */
  soundHandle: Scalars['String'];
  /** Spotify URL */
  spotifyUrl?: InputMaybe<Scalars['URL']>;
  /** Twitter handle */
  twitterHandle?: InputMaybe<Scalars['String']>;
};

/** Input for createDraft mutation */
export type CreateDraftInput = {
  /** Release info upload step inputs */
  releaseInfo?: InputMaybe<ReleaseInfoUploadStepInput>;
  /** Draft release type */
  releaseType: ReleaseType | '%future added value';
  /** Draft Title */
  title: Scalars['String'];
};

/** Input for createKeyClient mutation */
export type CreateKeyClient = {
  /** Human-readable name of Key Client to be created */
  name: Scalars['NonEmptyString'];
  /** Set the initial status of the specified Key Client */
  status?: KeyClientStatus | '%future added value';
};

/** Input for createPlaylistPost mutation */
export type CreatePlaylistPostInput = {
  /** Optional ID of the channel to post to */
  channelId?: InputMaybe<Scalars['UUID']>;
  /** Content of the post */
  content?: InputMaybe<Scalars['String']>;
  /** Lexical content of the post */
  lexicalContent?: InputMaybe<Scalars['JSON']>;
  /** ID of the shelf to associate with the post */
  shelfId: Scalars['UUID'];
};

/** Input for createPostComment mutation */
export type CreatePostCommentInput = {
  /** Content of the comment */
  content?: InputMaybe<Scalars['String']>;
  /** Lexical content of the post */
  lexicalContent?: InputMaybe<Scalars['JSON']>;
  /** ID of the post to place the comment on */
  postId: Scalars['UUID'];
};

/** Input for createReleasePost mutation */
export type CreateReleasePostInput = {
  /** Optional ID of the channel to post to */
  channelId?: InputMaybe<Scalars['UUID']>;
  /** Content of the post */
  content?: InputMaybe<Scalars['String']>;
  /** Lexical content of the post */
  lexicalContent?: InputMaybe<Scalars['JSON']>;
  /** ID of the release to associate with the post */
  releaseId: Scalars['UUID'];
};

/** Credit role type */
export const CreditRoleType = {
  Artist: 'ARTIST',
  Curator: 'CURATOR',
  Other: 'OTHER',
  Producer: 'PRODUCER',
  Remixer: 'REMIXER',
  Songwriter: 'SONGWRITER',
  VisualArtist: 'VISUAL_ARTIST'
} as const;

export type CreditRoleType = typeof CreditRoleType[keyof typeof CreditRoleType];
export const CurrentUserChannelJoinStatus = {
  Joined: 'JOINED',
  NotJoined: 'NOT_JOINED'
} as const;

export type CurrentUserChannelJoinStatus = typeof CurrentUserChannelJoinStatus[keyof typeof CurrentUserChannelJoinStatus];
export const CurrentUserPostRepostStatusType = {
  NotReposted: 'NOT_REPOSTED',
  Reposted: 'REPOSTED'
} as const;

export type CurrentUserPostRepostStatusType = typeof CurrentUserPostRepostStatusType[keyof typeof CurrentUserPostRepostStatusType];
export const CurrentUserPostVoteStatus = {
  NoVote: 'NO_VOTE',
  Upvoted: 'UPVOTED'
} as const;

export type CurrentUserPostVoteStatus = typeof CurrentUserPostVoteStatus[keyof typeof CurrentUserPostVoteStatus];
/** Base cursor connection arguments */
export type CursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Sort the connection ascending or descending */
  sort?: SortOrder | '%future added value';
};

/** Input for deleteAllUsersFromDraftAllowlist mutation */
export type DeleteAllUsersFromDraftAllowlistInput = {
  /** Draft identifier */
  draftId: Scalars['UUID'];
  /** Draft allowlist mint type */
  mintType: MintingAccessConfigMintingType | '%future added value';
};

/** Input fields to delete shelf */
export type DeleteShelfInput = {
  /** Shelf id to delete */
  shelfId: Scalars['UUID'];
};

/** Input for deleteUsersFromDraftAllowlist mutation */
export type DeleteUsersFromDraftAllowlistInput = {
  /** Public addresses to be deleted */
  addresses: Array<Scalars['Address']>;
  /** Draft identifier */
  draftId: Scalars['UUID'];
  /** Draft allowlist mint type */
  mintType: MintingAccessConfigMintingType | '%future added value';
};

/** Update info about a given device */
export type DevicePlatformInfoInput = {
  /** App build */
  appBuild: Scalars['Int'];
  /** Version identifier */
  appVersion: Scalars['String'];
  /** Device type identifier */
  deviceType: Scalars['String'];
  /** Platform identifier */
  platform: Scalars['String'];
  /** Device timezone identifier */
  timezone: Scalars['String'];
};

/** Draft allow list inputs */
export type DraftAllowListInput = {
  /** Draft collectors of artists */
  collectorsOfArtists?: InputMaybe<DraftCollectorsOfArtistsInput>;
  /** Draft collectors of releases */
  collectorsOfReleases?: InputMaybe<DraftCollectorsOfReleasesInput>;
  /** Draft manually added allowlist releases */
  manuallyAddedAllowlist?: InputMaybe<DraftManuallyAddedAllowlistInput>;
};

/** Draft allowlists configurations */
export type DraftAllowListsInput = {
  /** Presale mint draft allowlist configuration */
  presaleMint?: InputMaybe<DraftAllowListInput>;
};

/** Input for draftAllowListFromDraft query */
export type DraftAllowlistFromDraftInput = {
  /** Draft identifier */
  draftId: Scalars['UUID'];
  /** Draft allowlist mint type */
  mintType: MintingAccessConfigMintingType | '%future added value';
};

/** Input for draftAllowListFromRelease query */
export type DraftAllowlistFromReleaseInput = {
  /** Merkle tree root */
  merkleRoot: Scalars['String'];
  /** Release identifier */
  releaseId: Scalars['UUID'];
};

/** Input for draftAllowlistInput query */
export type DraftAllowlistInput = {
  /** Allowlist type */
  allowlistType: AllowlistType | '%future added value';
  /** Draft identifier */
  draftId: Scalars['String'];
  /** Draft allowlist mint type */
  mintType: MintingAccessConfigMintingType | '%future added value';
};

/** Draft allow list sale types */
export const DraftAllowlistSaleType = {
  FreeSale: 'FREE_SALE',
  Presale: 'PRESALE'
} as const;

export type DraftAllowlistSaleType = typeof DraftAllowlistSaleType[keyof typeof DraftAllowlistSaleType];
/** Different draft allow list types */
export const DraftAllowlistType = {
  ArtistCollectors: 'ARTIST_COLLECTORS',
  ManuallyAddedCollectors: 'MANUALLY_ADDED_COLLECTORS',
  ReleaseCollectors: 'RELEASE_COLLECTORS'
} as const;

export type DraftAllowlistType = typeof DraftAllowlistType[keyof typeof DraftAllowlistType];
/** Draft collectors of artists inputs */
export type DraftCollectorsOfArtistsInput = {
  /** Toggle to include or not include all artist collectors */
  allArtistCollectors?: Scalars['Boolean'];
  /** Toggle to include or not include all the collectors of all artists that given artist collaborated with */
  allCollaboratingArtists: Scalars['Boolean'];
  /** Select artist identifiers */
  selectedArtistIds: Array<Scalars['UUID']>;
};

/** Draft collectors of releases inputs */
export type DraftCollectorsOfReleasesInput = {
  /** Toggle to include or not include all artist collaborations */
  allArtistCollaborations: Scalars['Boolean'];
  /** Toggle to include or not include all artist releases */
  allArtistReleases: Scalars['Boolean'];
  /** Select release identifiers */
  selectedReleaseIds: Array<Scalars['UUID']>;
};

/** Cursor connection parameters */
export type DraftCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Sort the users ascending or descending relative to the user creation date */
  sort?: DraftCursorConnectionSort;
};

/** Customize the sort behavior of drafts pagination */
export type DraftCursorConnectionSort = {
  /** Sort by date of draft creation */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
};

/** Different upload steps for a release */
export type DraftInfoInput = {
  /** Allowlists inputs */
  allowListsInfo?: InputMaybe<DraftAllowListsInput>;
  /** Auction configuration inputs */
  auctionConfigurations?: InputMaybe<AuctionConfigurationsInput>;
  /** Release info upload step inputs */
  releaseInfo?: InputMaybe<ReleaseInfoUploadStepInput>;
  /** Rewards upload step inputs */
  rewardsInfo?: InputMaybe<RewardsUploadStepInput>;
  /** Credit allocations of credit split */
  splitsInfo?: InputMaybe<SplitsUploadStepInput>;
};

/** Draft manually added allowlist inputs */
export type DraftManuallyAddedAllowlistInput = {
  /** Draft manually added allowlist description */
  description?: InputMaybe<Scalars['String']>;
};

/** Input for draftMetadataUpload mutation */
export type DraftMetadataUploadInput = {
  /** Draft identifier */
  draftId: Scalars['UUID'];
};

/** Input for editRelease mutation */
export type EditReleaseInput = {
  /** JSON blob for release edits */
  edits: Scalars['JSON'];
  /** Release identifier */
  releaseId: Scalars['String'];
};

/** Filter the edition owned tokenIds result */
export type EditionOwnedTokenIdsFilter = {
  /** Should it include golden egg */
  includeGoldenEgg?: Scalars['Boolean'];
};

/** Input for editionOwnedTokenIds query */
export type EditionOwnedTokenIdsInput = {
  /** Edition contract address */
  editionContractAddress: Scalars['Address'];
  /** Filter the tokenIds */
  filter?: EditionOwnedTokenIdsFilter;
  /** Limit the amount of token ids to be returned. By default there is no limit */
  limit?: InputMaybe<Scalars['PositiveInt']>;
  /** Public address of owner */
  ownerPublicAddress: Scalars['Address'];
  /** Customize sort behavior */
  sort?: NftCursorConnectionSort;
};

/** Notification email verification status */
export const EmailVerificationStatus = {
  Expired: 'EXPIRED',
  NotSet: 'NOT_SET',
  Pending: 'PENDING',
  Verified: 'VERIFIED',
  VerifiedWithOtp: 'VERIFIED_WITH_OTP'
} as const;

export type EmailVerificationStatus = typeof EmailVerificationStatus[keyof typeof EmailVerificationStatus];
/** Event type */
export const EventType = {
  Airdrop: 'AIRDROP',
  EditionPurchased: 'EDITION_PURCHASED',
  OrdersMatched: 'ORDERS_MATCHED',
  OtherMinted: 'OTHER_MINTED',
  Transfer: 'TRANSFER',
  Unknown: 'UNKNOWN'
} as const;

export type EventType = typeof EventType[keyof typeof EventType];
/** Input for extendShelf mutation */
export type ExtendShelfInput = {
  /** Shelf identifier of source */
  sourceShelfId: Scalars['UUID'];
  /** Shelf identifier of target shelf to receive the releases */
  targetShelfId: Scalars['UUID'];
};

/** Type of feature to be set */
export const FeatureType = {
  Artist: 'ARTIST',
  Release: 'RELEASE',
  Splits: 'SPLITS',
  User: 'USER'
} as const;

export type FeatureType = typeof FeatureType[keyof typeof FeatureType];
/** Filter Key Clients pagination */
export type FilterKeyClients = {
  status?: InputMaybe<Array<KeyClientStatus | '%future added value'>>;
};

/** Input options to customize fixed auctions */
export type FixedAuctionInput = {
  /** List of different max mints per wallet quantity options for free sale */
  freeSaleMaxMintsPerWalletOptions?: Array<Scalars['Int']>;
  /** Maximum presale max mints per wallet */
  maxPresaleMaxMintsPerWallet?: Scalars['Int'];
  /** Maximum price for sale */
  maxPrice?: InputMaybe<Scalars['Float']>;
  /** Maximum public sale max mints per wallet */
  maxPublicSaleMaxMintsPerWallet?: Scalars['Int'];
  /** Maximum quantity option for public sale */
  maxQuantity?: InputMaybe<Scalars['Int']>;
  /** Minimum presale max mints per wallet */
  minPresaleMaxMintsPerWallet?: Scalars['Int'];
  /** Minimum price for sale */
  minPrice?: InputMaybe<Scalars['Float']>;
  /** Minimum public sale max mints per wallet */
  minPublicSaleMaxMintsPerWallet?: Scalars['Int'];
  /** Minimum quantity option for public sale */
  minQuantity?: InputMaybe<Scalars['Int']>;
  /** List of different days for public sale to start in */
  mintingStartsInDays?: InputMaybe<Array<Scalars['Int']>>;
  /** List of different max mints per wallet quantity options for presale */
  presaleMaxMintsPerWalletOptions: Array<Scalars['Int']>;
  /** Maximum price for presale */
  presaleMaxPrice?: InputMaybe<Scalars['Float']>;
  /** Minimum price for presale */
  presaleMinPrice?: InputMaybe<Scalars['Float']>;
  /** List of different eth prices options for public sale */
  priceOptions?: InputMaybe<Array<Scalars['Float']>>;
  /** List of different max mints per wallet quantity options for public sale */
  publicSaleMaxMintsPerWalletOptions: Array<Scalars['Int']>;
  /** List of different quantity options for public sale */
  quantityOptions?: Array<Scalars['Int']>;
};

/** Input fields to follow user */
export type FollowUserInput = {
  /** User id to follow */
  user: Scalars['UUID'];
};

/** List of genres available on the platform */
export const Genres = {
  Afrobeat: 'AFROBEAT',
  AlternativeRock: 'ALTERNATIVE_ROCK',
  Ambient: 'AMBIENT',
  Bounce: 'BOUNCE',
  Classical: 'CLASSICAL',
  Country: 'COUNTRY',
  Dancehall: 'DANCEHALL',
  DanceEdm: 'DANCE_EDM',
  DeepHouse: 'DEEP_HOUSE',
  Disco: 'DISCO',
  Downtempo: 'DOWNTEMPO',
  DrumBass: 'DRUM_BASS',
  Dubstep: 'DUBSTEP',
  Electronic: 'ELECTRONIC',
  Experimental: 'EXPERIMENTAL',
  FolkSingerSongwriter: 'FOLK_SINGER_SONGWRITER',
  HipHopRap: 'HIP_HOP_RAP',
  House: 'HOUSE',
  Hyperpop: 'HYPERPOP',
  Indie: 'INDIE',
  JazzBlues: 'JAZZ_BLUES',
  Latin: 'LATIN',
  Lofi: 'LOFI',
  Metal: 'METAL',
  Piano: 'PIANO',
  Pop: 'POP',
  Reggae: 'REGGAE',
  Reggaeton: 'REGGAETON',
  Rock: 'ROCK',
  RBSoul: 'R_B_SOUL',
  Soundtrack: 'SOUNDTRACK',
  Techno: 'TECHNO',
  Trance: 'TRANCE',
  Trap: 'TRAP',
  Triphop: 'TRIPHOP',
  World: 'WORLD'
} as const;

export type Genres = typeof Genres[keyof typeof Genres];
/** Geo Location input associated with google maps integration */
export type GeoLocationInput = {
  /** Label provided by user associated with place */
  label: Scalars['String'];
  /** Place identifier provided by Google Maps API */
  placeId: Scalars['String'];
};

export const HidePostsFromTrendingOption = {
  Hide: 'Hide',
  Unhide: 'Unhide'
} as const;

export type HidePostsFromTrendingOption = typeof HidePostsFromTrendingOption[keyof typeof HidePostsFromTrendingOption];
/** Input for setHidePostsFromTrendingStatus mutation */
export type HidePostsFromTrendingStatusInput = {
  /** Trending posts supression status */
  option: HidePostsFromTrendingOption | '%future added value';
  /** Public address of user */
  publicAddress: Scalars['Address'];
};

/** Customize iframe html parameters */
export type IframeHtmlParameters = {
  /** Customize height */
  height: Scalars['String'];
  /** Customize style */
  style: Scalars['String'];
  /** Customize width */
  width: Scalars['String'];
};

/** Input field to check if auth user is following */
export type IsFollowingInput = {
  /** User id to check if auth user is following */
  user: Scalars['UUID'];
};

/** Input for `isLiked` query */
export type IsLikedInput = {
  /** Identifier to be checked */
  id: Scalars['UUID'];
};

/** Cursor connection parameters */
export type KeyClientCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Sort the key clients ascending or descending relative to the entity creation date */
  sort?: SortOrder | '%future added value';
};

/** Status of Key Client */
export const KeyClientStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE'
} as const;

export type KeyClientStatus = typeof KeyClientStatus[keyof typeof KeyClientStatus];
/** Chain name supported on the platform: L2 only */
export const L2ChainType = {
  Base: 'BASE',
  BaseGoerli: 'BASE_GOERLI',
  Optimism: 'OPTIMISM',
  OptimismGoerli: 'OPTIMISM_GOERLI'
} as const;

export type L2ChainType = typeof L2ChainType[keyof typeof L2ChainType];
/** License for the release */
export const LicenseType = {
  AllRightsReserved: 'ALL_RIGHTS_RESERVED',
  CreativeCommons: 'CREATIVE_COMMONS'
} as const;

export type LicenseType = typeof LicenseType[keyof typeof LicenseType];
/** Input for `likeRelease` mutation */
export type LikeReleaseInput = {
  /** Release identifier to be liked */
  releaseId: Scalars['UUID'];
};

/** Input for `likeShelf` mutation */
export type LikeShelfInput = {
  /** Shelf identifier to be liked */
  shelfId: Scalars['UUID'];
};

/** Input used for link query */
export type LinkInput = {
  /** Link slug */
  slug: Scalars['NonEmptyString'];
};

/** Type of media entity, either Images or Audio */
export const MediaType = {
  ArtistBannerImage: 'ARTIST_BANNER_IMAGE',
  ArtistCollectorsCsv: 'ARTIST_COLLECTORS_CSV',
  ArtistFreeSaleAllowlist: 'ARTIST_FREE_SALE_ALLOWLIST',
  ArtistPresaleAllowlist: 'ARTIST_PRESALE_ALLOWLIST',
  Audio: 'AUDIO',
  Audio_128K: 'AUDIO_128K',
  Audio_192K: 'AUDIO_192K',
  Audio_256K: 'AUDIO_256K',
  AudioHls: 'AUDIO_HLS',
  AvatarImage: 'AVATAR_IMAGE',
  ChannelCoverImage: 'CHANNEL_COVER_IMAGE',
  ChannelProfileImage: 'CHANNEL_PROFILE_IMAGE',
  ChannelWebAnimatedProfileImage: 'CHANNEL_WEB_ANIMATED_PROFILE_IMAGE',
  ChannelWebStaticAutogenProfileImage: 'CHANNEL_WEB_STATIC_AUTOGEN_PROFILE_IMAGE',
  DraftAllowlistedAddressesCsv: 'DRAFT_ALLOWLISTED_ADDRESSES_CSV',
  MerkleTreeCsv: 'MERKLE_TREE_CSV',
  ReleaseBannerImage: 'RELEASE_BANNER_IMAGE',
  ReleaseCoverImage: 'RELEASE_COVER_IMAGE',
  ReleaseGaCoverImage: 'RELEASE_GA_COVER_IMAGE',
  ReleaseGaWebAnimatedImage: 'RELEASE_GA_WEB_ANIMATED_IMAGE',
  ReleaseGaWebStaticAutogenImage: 'RELEASE_GA_WEB_STATIC_AUTOGEN_IMAGE',
  ReleaseGaWebStaticImage: 'RELEASE_GA_WEB_STATIC_IMAGE',
  ReleaseGoldenEggImage: 'RELEASE_GOLDEN_EGG_IMAGE',
  ReleaseHoldersCsv: 'RELEASE_HOLDERS_CSV',
  ReleaseWebAnimatedGoldenEggImage: 'RELEASE_WEB_ANIMATED_GOLDEN_EGG_IMAGE',
  ReleaseWebAnimatedImage: 'RELEASE_WEB_ANIMATED_IMAGE',
  ReleaseWebStaticAutogenImage: 'RELEASE_WEB_STATIC_AUTOGEN_IMAGE',
  ReleaseWebStaticImage: 'RELEASE_WEB_STATIC_IMAGE',
  ShelfCoverImage: 'SHELF_COVER_IMAGE',
  TmpArtistBannerAutogenImage: 'TMP_ARTIST_BANNER_AUTOGEN_IMAGE',
  TmpAvatarAutogenImage: 'TMP_AVATAR_AUTOGEN_IMAGE',
  TmpUserBannerAutogenImage: 'TMP_USER_BANNER_AUTOGEN_IMAGE',
  UserBannerImage: 'USER_BANNER_IMAGE'
} as const;

export type MediaType = typeof MediaType[keyof typeof MediaType];
/** Mint current time status */
export const MintTimeStatus = {
  Past: 'PAST',
  Upcoming: 'UPCOMING'
} as const;

export type MintTimeStatus = typeof MintTimeStatus[keyof typeof MintTimeStatus];
/** Customize sort behavior of minted releases pagination */
export type MintedReleasesCursorConnectionSort = {
  /** Sort by createdAt of release */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by mintStartTime of release */
  mintStartTime?: InputMaybe<SortOrder | '%future added value'>;
};

/** Filter minted releases */
export type MintedReleasesCursorFilterArgs = {
  /** Specify up to 50 contracts to filter the releases */
  contracts?: InputMaybe<Array<ContractReleaseInput>>;
  /**
   * Only get releases from specified genres
   * @deprecated Use "genres" instead
   */
  genre?: InputMaybe<Array<Scalars['String']>>;
  /** Only get releases from specified genres */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /**
   * Remove currently-featured releases from results
   * @deprecated No longer relevant filter
   */
  hideFeatured?: InputMaybe<Scalars['Boolean']>;
  /** Location ids to filter on for releases */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Only get releases less or equal to than specified mint time */
  mintTimeMaxDate?: InputMaybe<Scalars['Timestamp']>;
  /** Only get releases greater than or equal to specified mint time */
  mintTimeMinDate?: InputMaybe<Scalars['Timestamp']>;
  /** Only get release with specified mint time status */
  mintTimeStatus?: InputMaybe<Array<MintTimeStatus | '%future added value'>>;
  /** Filters on whether album releases have been revealed or not */
  releaseAlbumRevealStatus?: InputMaybe<ReleaseAlbumRevealFilterOption | '%future added value'>;
  /** Only get release with specified status */
  releaseStatus?: InputMaybe<Array<ReleaseStatus | '%future added value'>>;
  /** Filters on release type */
  releaseType?: Array<ReleaseType | '%future added value'>;
  /** Only get releases from specified seasons */
  season?: InputMaybe<Array<ArtistSeason | '%future added value'>>;
};

/** Different minting types for mintingAccessConfig query */
export const MintingAccessConfigMintingType = {
  Free: 'FREE',
  Presale: 'PRESALE'
} as const;

export type MintingAccessConfigMintingType = typeof MintingAccessConfigMintingType[keyof typeof MintingAccessConfigMintingType];
/** Input for multicall withdraw */
export type MulticallArgInput = {
  /** Hex calldata */
  callData: Scalars['String'];
  /** Contract address */
  target: Scalars['Address'];
};

/** Input for signedUploadParams mutation */
export type MultipartUploadRequest = {
  /** File name of media to be uploaded */
  fileName: Scalars['String'];
  /** Media type to be uploaded */
  mediaType: MediaType | '%future added value';
  /** Number of parts to use for multi-part upload */
  totalPartsCount: Scalars['Int'];
};

export type MutationAddPostCommentReplyInput = {
  /** Content of the reply */
  content?: InputMaybe<Scalars['String']>;
  /** Lexical content of the post */
  lexicalContent?: InputMaybe<Scalars['JSON']>;
  /** ID of the post comment to reply to */
  postCommentId: Scalars['UUID'];
};

export type MutationAdminAllowUserToPostInput = {
  /** User ID */
  userId: Scalars['UUID'];
};

export type MutationAdminDeleteAllUserContentInput = {
  /** User ID */
  userId: Scalars['UUID'];
};

export type MutationAdminDeleteNftCommentInput = {
  /** NFT Comment ID */
  nftCommentId: Scalars['UUID'];
};

export type MutationAdminDeletePostCommentInput = {
  /** Post Comment ID */
  postCommentId: Scalars['UUID'];
};

export type MutationAdminDeletePostCommentReplyInput = {
  /** Post comment reply ID */
  postCommentId: Scalars['UUID'];
};

export type MutationAdminDeletePostInput = {
  /** Post ID */
  postId: Scalars['UUID'];
};

export type MutationAdminDisallowUserToPostInput = {
  /** User ID */
  userId: Scalars['UUID'];
};

/** Input for connectSpotify mutation */
export type MutationConnectSpotifyInput = {
  /** Spotify authorization code */
  code: Scalars['String'];
  /** Override existing account if spotify is currently linked to another Sound account */
  overrideAccount?: Scalars['Boolean'];
  /** Redirect URI */
  redirectUri: Scalars['URL'];
};

/** Input for createTieredDraft mutation */
export type MutationCreateTieredDraftInput = {
  /** Allowlists inputs */
  allowListsInfo: TieredDraftAllowListsInput;
  /** Auction configuration inputs */
  auctionConfigurations: TieredAuctionConfigurationsInput;
  /** Chain associated with contract */
  chain: ChainType | '%future added value';
  /** Contract address to be deployed */
  contractAddress: Scalars['Address'];
  /** Release info upload inputs */
  releaseInfo: TieredReleaseInfoUploadStepInput;
  /** Rewards upload inputs */
  rewardsInfo: TieredRewardsUploadStepInput;
  /** Should release be created */
  shouldCreateRelease?: Scalars['Boolean'];
  /** Credit allocations of credit split */
  splitsInfo?: InputMaybe<TieredSplitsUploadStepInput>;
};

export type MutationDeletePostCommentInput = {
  /** ID of the post comment to delete */
  postCommentId: Scalars['UUID'];
};

export type MutationDeletePostCommentReplyInput = {
  /** ID of the post comment's reply to delete */
  replyPostCommentId: Scalars['UUID'];
};

export type MutationDeletePostInput = {
  /** ID of the post to delete */
  postId: Scalars['UUID'];
};

/** Input of editReleaseAsync mutation */
export type MutationEditReleaseAsyncInput = {
  /** JSON blob for release edits */
  edits: Scalars['JSON'];
  /** Release identifier */
  releaseId: Scalars['UUID'];
};

/** Input for prepareMintTieredDraftAsync mutation */
export type MutationPrepareMintTieredDraftAsyncInput = {
  /** Draft identifier */
  draftId: Scalars['UUID'];
};

/** Input for presaveRelease mutation */
export type MutationPresaveReleaseInput = {
  /** Release identifier to be liked */
  releaseId: Scalars['UUID'];
};

/** Input for repost mutation */
export type MutationRepostInput = {
  /** ID of the post to be reposted */
  postId: Scalars['UUID'];
};

export type MutationSponsoredAffiliateWithdrawInput = {
  /** The chain for the transaction */
  chain: L2ChainType | '%future added value';
  /** Array of multicall entries */
  multiCallArgs: Array<MulticallArgInput>;
};

export type MutationSponsoredWithdrawInput = {
  /** The chain for the transaction */
  chain: L2ChainType | '%future added value';
  /** Array of multicall entries */
  multiCallArgs: Array<MulticallArgInput>;
};

/** Input for syncUserNftsForEditionAdmin mutation */
export type MutationSyncUserNftsForEditionAdminInput = {
  /** Chain associated with edition */
  chain: ChainType | '%future added value';
  /** Edition address */
  contractAddress: Scalars['Address'];
  /** Public address possibly owner of the edition */
  userPublicAddress: Scalars['Address'];
};

/** Input for syncUserNftsForEdition mutation */
export type MutationSyncUserNftsForEditionInput = {
  /** Chain associated with edition */
  chain: ChainType | '%future added value';
  /** Edition address */
  contractAddress: Scalars['Address'];
};

/** Input for tieredDraftMetadataUploadAsync mutation */
export type MutationTieredDraftMetadataUploadAsyncInput = {
  /** Draft identifier */
  draftId: Scalars['UUID'];
};

/** Input for tieredDraftMetadataUpload mutation */
export type MutationTieredDraftMetadataUploadInput = {
  /** Draft identifier */
  draftId: Scalars['UUID'];
};

export type MutationUpsertShelfCoverImageInput = {
  /** Uploaded cover image */
  coverImage?: InputMaybe<UploadedMedia>;
  /** Shelf Id */
  id: Scalars['String'];
};

/** Cursor connection parameters for Nft Comments */
export type NftCommentCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: NftCommentCursorConnectionSort;
};

/** Customize the sort behavior of Post Comments pagination */
export type NftCommentCursorConnectionSort = {
  /** Sort by created date */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
};

/** Cursor connection parameters for NFTs */
export type NftCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: NftCursorConnectionSort;
};

/** Customize the sort behavior of Nfts pagination */
export type NftCursorConnectionSort = {
  /** Sort by date of primary sale */
  primarySaleDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by date of last secondary sale with default value of primary sale date */
  secondarySaleDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by serial number */
  serialNumber?: InputMaybe<SortOrder | '%future added value'>;
};

/** Input for "nft" Query */
export type NftInput = {
  /** Contract address of edition */
  contractAddress: Scalars['Address'];
  /** Token unique identifier within edition */
  tokenId: Scalars['String'];
};

/** Input options to customize open edition auctions */
export type OpenEditionAuctionInput = {
  /** List of different max mints per wallet quantity options for free sale */
  freeSaleMaxMintsPerWalletOptions?: InputMaybe<Array<Scalars['Int']>>;
  /** Maximum price for sale */
  maxPrice?: InputMaybe<Scalars['Float']>;
  /** List of different options of minimum quantity for public sale */
  minOptions: Array<Scalars['Int']>;
  /** Minimum price for sale */
  minPrice?: InputMaybe<Scalars['Float']>;
  /** List of different duration in days for public sale */
  mintingPeriodDays?: InputMaybe<Array<Scalars['Int']>>;
  /** List of different days for public sale to start in */
  mintingStartsInDays?: InputMaybe<Array<Scalars['Int']>>;
  /** List of different max mints per wallet quantity options for presale */
  presaleMaxMintsPerWalletOptions?: InputMaybe<Array<Scalars['Int']>>;
  /** Maximum price for presale */
  presaleMaxPrice?: InputMaybe<Scalars['Float']>;
  /** Minimum price for presale */
  presaleMinPrice?: InputMaybe<Scalars['Float']>;
  /** List of different eth prices options for public sale */
  priceOptions?: InputMaybe<Array<Scalars['Float']>>;
  /** List of different max mints per wallet quantity options for public sale */
  publicSaleMaxMintsPerWalletOptions?: InputMaybe<Array<Scalars['Int']>>;
};

/** Input options to customize open edition auctions with SAM */
export type OpenEditionAuctionWithSamInput = {
  /** List of different max mints per wallet quantity options for free sale */
  freeSaleMaxMintsPerWalletOptions?: InputMaybe<Array<Scalars['Int']>>;
  /** Inflection count for SAM */
  inflectionCountSAM: Scalars['Int'];
  /** Inflection multiple BPS for SAM */
  inflectionMultipleBPS: Scalars['Int'];
  /** Linear price slope for SAM */
  linearPriceSlope: Scalars['String'];
  /** Maximum price for sale */
  maxPrice?: InputMaybe<Scalars['Float']>;
  /** List of different options of minimum quantity for public sale */
  minOptions: Array<Scalars['Int']>;
  /** Minimum price for sale */
  minPrice?: InputMaybe<Scalars['Float']>;
  /** List of different duration in days for public sale */
  mintingPeriodDays?: InputMaybe<Array<Scalars['Int']>>;
  /** List of different days for public sale to start in */
  mintingStartsInDays?: InputMaybe<Array<Scalars['Int']>>;
  /** List of different max mints per wallet quantity options for presale */
  presaleMaxMintsPerWalletOptions?: InputMaybe<Array<Scalars['Int']>>;
  /** Maximum price for presale */
  presaleMaxPrice?: InputMaybe<Scalars['Float']>;
  /** Minimum price for presale */
  presaleMinPrice?: InputMaybe<Scalars['Float']>;
  /** List of different eth prices options for public sale */
  priceOptions?: InputMaybe<Array<Scalars['Float']>>;
  /** List of different max mints per wallet quantity options for public sale */
  publicSaleMaxMintsPerWalletOptions?: InputMaybe<Array<Scalars['Int']>>;
};

/** Possible options for Paper Checkout */
export const PaperCheckoutType = {
  /** Checkout with Credit Card */
  CreditCard: 'CREDIT_CARD',
  /** Checkout with ETH Mainnet */
  EthMainnet: 'ETH_MAINNET'
} as const;

export type PaperCheckoutType = typeof PaperCheckoutType[keyof typeof PaperCheckoutType];
/** Input for paperMerkleMinterV2SdkClientSecret mutation */
export type PaperMerkleDropMinterV2SdkClientSecretInput = {
  /** Address of the affiliate to receive the commission. */
  affiliate?: Scalars['Address'];
  /** Merkle root of the drop */
  merkleRoot: Scalars['String'];
  /** ID from the mint schedule to mint */
  mintId: Scalars['NonNegativeInt'];
  /** Quantity of editions to mint */
  quantity: Scalars['PositiveInt'];
  /** ID of the release to mint */
  releaseId: Scalars['UUID'];
  /** Total price of the sale in Ether */
  totalPrice: Scalars['String'];
  /** Checkout option */
  type: PaperCheckoutType | '%future added value';
};

/** Input for paperMinterAdapterSdkClientSecret mutation */
export type PaperMinterAdapterSdkClientSecretInput = {
  /** Address of the affiliate to receive the commission. */
  affiliate?: Scalars['Address'];
  /** Address of the recipient of the gift */
  giftTo?: InputMaybe<Scalars['Address']>;
  /** ID from the mint schedule to mint */
  mintId: Scalars['NonNegativeInt'];
  /** Address of the minter to mint from. */
  minter: Scalars['Address'];
  /** Quantity of editions to mint */
  quantity: Scalars['PositiveInt'];
  /** ID of the release to mint */
  releaseId: Scalars['UUID'];
  /** Total price of the sale in Ether */
  totalPrice: Scalars['String'];
  /** Checkout option */
  type: PaperCheckoutType | '%future added value';
};

/** Input for paperRangeMinterV2SdkClientSecret mutation */
export type PaperRangedMinterV2SdkClientSecretInput = {
  /** Address of the affiliate to receive the commission. */
  affiliate?: Scalars['Address'];
  /** Address of the recipient of the gift */
  giftTo?: InputMaybe<Scalars['Address']>;
  /** ID from the mint schedule to mint */
  mintId: Scalars['NonNegativeInt'];
  /** Quantity of editions to mint */
  quantity: Scalars['PositiveInt'];
  /** ID of the release to mint */
  releaseId: Scalars['UUID'];
  /** Total price of the sale in Ether */
  totalPrice: Scalars['String'];
  /** Checkout option */
  type: PaperCheckoutType | '%future added value';
};

/** Input for paperSoundSwapSdkClientSecret mutation */
export type PaperSoundSwapSdkClientSecretInput = {
  /** Address of the affiliate to receive the commission. */
  affiliate?: Scalars['Address'];
  /** Address of the recipient of the gift */
  giftTo?: InputMaybe<Scalars['Address']>;
  /** Quantity of editions to mint */
  quantity: Scalars['PositiveInt'];
  /** ID of the release to mint */
  releaseId: Scalars['UUID'];
  /** Total price of the sale in Ether */
  totalPrice: Scalars['String'];
  /** Checkout option */
  type: PaperCheckoutType | '%future added value';
};

/** Input for paperSuperMinterSdkClientSecretInput mutation */
export type PaperSuperMinterSdkClientSecretInput = {
  /** Address of the affiliate to receive the commission. */
  affiliate?: Scalars['Address'];
  /** Chain of the edition to mint */
  chain: ChainType | '%future added value';
  /** Address of the edition to mint */
  editionAddress: Scalars['Address'];
  /** Address of the recipient of the gift */
  giftTo?: InputMaybe<Scalars['Address']>;
  /** Quantity of editions to mint */
  quantity: Scalars['PositiveInt'];
  /** ID of the release to mint */
  releaseId: Scalars['UUID'];
  /** Schedule number to mint */
  scheduleNumber: Scalars['NonNegativeInt'];
  /** Tier number to mint */
  tierNumber: Scalars['NonNegativeInt'];
  /** Total price of the sale in Ether */
  totalPrice: Scalars['String'];
  /** Checkout option */
  type: PaperCheckoutType | '%future added value';
};

/** Platform type */
export const PlatformType = {
  Android: 'ANDROID',
  Ios: 'IOS',
  Web: 'WEB'
} as const;

export type PlatformType = typeof PlatformType[keyof typeof PlatformType];
/** Filter PlaylistAction details */
export type PlaylistActionFilterArgs = {
  /** If set, only show artist owned releases in paginated release results. Does not apply if the playlist is owned by the artist */
  releaseArtistId?: InputMaybe<Scalars['UUID']>;
};

/** Cursor connection parameters */
export type PlaylistActionReleasesCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the number of nodes to be fetched, to be used with "after", with a maximum of 25 nodes */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the number of nodes to be fetched, to be used with "before", with a maximum of 25 nodes */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Sort the releases ascending or descending by release creation date */
  sort?: SortOrder | '%future added value';
};

/** Pagination paramaters for release chart ranks */
export type PlaylistChartRankCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: PlaylistChartRankCursorConnectionSort;
};

/** Customize sort of collectors */
export type PlaylistChartRankCursorConnectionSort = {
  /** Sort by playlist chart current rank */
  currentRank?: InputMaybe<SortOrder | '%future added value'>;
};

/** Playlist input */
export type PlaylistInput = {
  /** Association ID based on type of playlist */
  associationId?: InputMaybe<Scalars['String']>;
  /** Type of playlist */
  type: PlaylistType | '%future added value';
};

/** Currently supported playlists */
export const PlaylistType = {
  Artist: 'ARTIST',
  Holder: 'HOLDER',
  Home: 'HOME'
} as const;

export type PlaylistType = typeof PlaylistType[keyof typeof PlaylistType];
/** Cursor connection parameters for Post Comments */
export type PostCommentCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: PostCommentCursorConnectionSort;
};

/** Customize the sort behavior of Post Comments pagination */
export type PostCommentCursorConnectionSort = {
  /** Sort by created date */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
};

/** Post Comment label type */
export const PostCommentLabel = {
  ReleaseArtist: 'RELEASE_ARTIST'
} as const;

export type PostCommentLabel = typeof PostCommentLabel[keyof typeof PostCommentLabel];
/** Cursor connection parameters for Posts */
export type PostCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: PostCursorConnectionSort;
};

/** Customize the sort behavior of Posts pagination */
export type PostCursorConnectionSort = {
  /** Sort by created date */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
};

export const PostVoteChange = {
  RemoveVote: 'REMOVE_VOTE',
  Upvote: 'UPVOTE'
} as const;

export type PostVoteChange = typeof PostVoteChange[keyof typeof PostVoteChange];
/** Input for prepareMintDraftAsync mutation */
export type PrepareMintDraftAsyncInput = {
  /** Chain where the draft will be deployed */
  chain: ChainType | '%future added value';
  /** Draft identifier */
  draftId: Scalars['UUID'];
};

/** Input for prepareMintDraft mutation */
export type PrepareMintDraftInput = {
  /** Chain where the draft will be deployed */
  chain: ChainType | '%future added value';
  /** Draft identifier */
  draftId: Scalars['UUID'];
};

export type QueryAdminUserBlockStatusInput = {
  /** User ID */
  userId: Scalars['UUID'];
};

export type QueryAdminUserCommentsInput = {
  /** Pagination parameters */
  pagination?: PostCommentCursorConnectionArgs;
  /** User ID */
  userId: Scalars['UUID'];
};

export type QueryAdminUserNftCommentsInput = {
  /** Pagination parameters */
  pagination?: NftCommentCursorConnectionArgs;
  /** User ID */
  userId: Scalars['UUID'];
};

export type QueryAdminUserPostCommentsWithoutNftCommentsInput = {
  /** Pagination parameters */
  pagination?: PostCommentCursorConnectionArgs;
  /** User ID */
  userId: Scalars['UUID'];
};

export type QueryAdminUserPostsInput = {
  /** Pagination parameters */
  pagination?: PostCursorConnectionArgs;
  /** User ID */
  userId: Scalars['UUID'];
};

export type QueryChannelStatsInput = {
  /** Unique Channel identifier */
  channelIds: Array<Scalars['UUID']>;
};

export type QueryIsChannelCuratorInput = {
  /** Unique Channel identifier */
  channelIds: Array<Scalars['UUID']>;
};

export type QueryIsChannelMemberInput = {
  /** Unique Channel identifier */
  channelIds: Array<Scalars['UUID']>;
};

/** Input for postRepostedBy query */
export type QueryPostRepostedByInput = {
  /** Pagination parameters */
  pagination?: UserCursorConnectionArgs;
  /** Post identifier */
  postId: Scalars['UUID'];
};

/** Input for postUpvotedBy query */
export type QueryPostUpvotedByInput = {
  /** Pagination parameters */
  pagination?: UserCursorConnectionArgs;
  /** Post identifier */
  postId: Scalars['UUID'];
};

/** Input for userPostStatus query */
export type QueryUserPostStatusInput = {
  /** Unique Post identifier */
  postIds: Array<Scalars['UUID']>;
};

/** Input for userReleaseStatus query */
export type QueryUserReleaseStatusInput = {
  /** List of release identifiers */
  releaseIds: Array<Scalars['UUID']>;
};

export type QueryUserVoteOnPostCommentInput = {
  /** Unique Post Comment identifiers */
  postCommentIds: Array<Scalars['UUID']>;
};

export type QueryUserVoteOnPostInput = {
  /** Unique Post identifier */
  postIds: Array<Scalars['UUID']>;
};

/** Input options to customize range bound auctions */
export type RangeBoundAuctionInput = {
  /** List of different max mints per wallet quantity options for free sale */
  freeSaleMaxMintsPerWalletOptions: Array<Scalars['Int']>;
  /** List of different options of maximum quantity for public sale */
  maxOptions: Array<Scalars['Int']>;
  /** Maximum price for sale */
  maxPrice?: InputMaybe<Scalars['Float']>;
  /** List of different options of minimum quantity for public sale */
  minOptions: Array<Scalars['Int']>;
  /** Minimum price for sale */
  minPrice?: InputMaybe<Scalars['Float']>;
  /** Minting period duration in minutes for public sale */
  mintingPeriodMins: Scalars['Int'];
  /** List of different max mints per wallet quantity options for presale */
  presaleMaxMintsPerWalletOptions: Array<Scalars['Int']>;
  /** Maximum price for presale */
  presaleMaxPrice?: InputMaybe<Scalars['Float']>;
  /** Minimum price for presale */
  presaleMinPrice?: InputMaybe<Scalars['Float']>;
  /** List of different eth prices options for public sale */
  priceOptions?: InputMaybe<Array<Scalars['Float']>>;
  /** List of different max mints per wallet quantity options for public sale */
  publicSaleMaxMintsPerWalletOptions: Array<Scalars['Int']>;
};

/** Pagination parameters of referred users */
export type ReferredUsersCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 25 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 25 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ReferredUsersCursorConnectionSort;
};

/** Customize the sort behavior of release affiliates total purchases */
export type ReferredUsersCursorConnectionSort = {
  /** Sort by purchase block number */
  blockNumber?: InputMaybe<SortOrder | '%future added value'>;
};

/** Input for referred users within release affiliate total purchases */
export type ReferredUsersInput = {
  /** Pagination parameters */
  pagination?: ReferredUsersCursorConnectionArgs;
};

/** Mobile device registration input */
export type RegisterMobileDeviceInput = {
  /** Firebase device token for mobile notifications */
  firebaseToken: Scalars['String'];
  /** Indicates if the device is currently considered logged in */
  isLoggedIn: Scalars['Boolean'];
  /** Device platform info (optional) */
  platformInfo?: InputMaybe<DevicePlatformInfoInput>;
  /** Enable or disable push notification permissions */
  pushPermissionsEnabled: Scalars['Boolean'];
};

/** Input options for rejectArtistApplication mutation */
export type RejectArtistApplicationInput = {
  /** Artist application entity id */
  artistApplicationId: Scalars['UUID'];
  /** Reason for rejection */
  rejectionReason: Scalars['String'];
};

/** Filter release activity types */
export type ReleaseActivityFeedFilterArgs = {
  /** Only get activity of given type */
  types?: Array<ReleaseActivityFeedTypeFilterOption | '%future added value'>;
};

/** Release activity feed input parameters */
export type ReleaseActivityFeedInput = {
  /** Only get activities of given types */
  filter?: ReleaseActivityFeedFilterArgs;
  /** Pagination parameters */
  pagination?: CursorConnectionArgs;
};

/** Release activity feed type filter option */
export const ReleaseActivityFeedTypeFilterOption = {
  All: 'ALL',
  Collections: 'COLLECTIONS',
  Likes: 'LIKES',
  Playlists: 'PLAYLISTS',
  Posts: 'POSTS',
  Presaves: 'PRESAVES',
  Releases: 'RELEASES'
} as const;

export type ReleaseActivityFeedTypeFilterOption = typeof ReleaseActivityFeedTypeFilterOption[keyof typeof ReleaseActivityFeedTypeFilterOption];
/** Pagination parameters for release affiliates */
export type ReleaseAffiliateCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ReleaseAffiliateCursorConnectionSort;
};

/** Customize sort of release affiliates */
export type ReleaseAffiliateCursorConnectionSort = {
  /** Sort by amount nfts referred */
  nftQuantityDriven?: InputMaybe<SortOrder | '%future added value'>;
};

/** Pagination parameters for total release affiliate purchases */
export type ReleaseAffiliateTotalPurchasesCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 25 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 25 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ReleaseAffiliateTotalPurchasesCursorConnectionSort;
};

/** Customize the sort behavior of release affiliates total purchases */
export type ReleaseAffiliateTotalPurchasesCursorConnectionSort = {
  /** Sort by block number */
  blockNumber?: InputMaybe<SortOrder | '%future added value'>;
};

/** Release album reveal filter option */
export const ReleaseAlbumRevealFilterOption = {
  All: 'ALL',
  OnlyNotRevealedAlbums: 'ONLY_NOT_REVEALED_ALBUMS',
  OnlyRevealedAlbums: 'ONLY_REVEALED_ALBUMS'
} as const;

export type ReleaseAlbumRevealFilterOption = typeof ReleaseAlbumRevealFilterOption[keyof typeof ReleaseAlbumRevealFilterOption];
/** Input for releaseAllowlist query */
export type ReleaseAllowlistInput = {
  /** Merkle tree root */
  merkleRoot: Scalars['String'];
  /** Release identifier */
  releaseId: Scalars['UUID'];
};

/** Input for releaseChart query */
export type ReleaseChartByLastDayInput = {
  /** Locate chart using the last date of the period (inclusive) */
  lastDayOfChartInclusive: Scalars['DateTime'];
};

/** Pagination paramaters for release charts */
export type ReleaseChartCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ReleaseChartCursorConnectionSort;
};

/** Customize sort of release charts */
export type ReleaseChartCursorConnectionSort = {
  /** Sort by release chart period end exclusive */
  periodEndExclusive?: InputMaybe<SortOrder | '%future added value'>;
};

/** Input for releaseChart query */
export type ReleaseChartInput = {
  /** Filter on periodEnd date */
  periodEndExclusive: Scalars['DateTime'];
};

/** Pagination paramaters for release chart ranks */
export type ReleaseChartRankCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ReleaseChartRankCursorConnectionSort;
};

/** Customize sort of collectors */
export type ReleaseChartRankCursorConnectionSort = {
  /** Sort by release chart current rank */
  currentRank?: InputMaybe<SortOrder | '%future added value'>;
};

/** Input for releaseChartRank query */
export type ReleaseChartRankInput = {
  /** Release Chart Rank entity id */
  id: Scalars['UUID'];
};

/** Input for releaseChart query */
export type ReleaseChartsInput = {
  /** Cursor connection parameters */
  pagination?: ReleaseChartCursorConnectionArgs;
};

/** Pagination parameters for release collectors */
export type ReleaseCollectorCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ReleaseCollectorCursorConnectionSort;
  /** The NFT tier you want to select for ReleaseCollectors, defaults All */
  tier?: InputMaybe<TierNft | '%future added value'>;
};

/** Customize sort of collectors */
export type ReleaseCollectorCursorConnectionSort = {
  /** Sort by first nft collected date */
  firstNftCollectedDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by amount ga nfts collected, with tie-breaker of earliest collector first */
  gaNftsCount?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by lowest owned serial number */
  lowestOwnedSerialNumber?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by amount nfts collected, with tie-breaker of earliest collector first */
  nftsCount?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by vips first, then ga, tie-breaker of first nft collected date */
  priorityFirstNftDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by vips first, then ga, tie-breaker most nfts collected */
  priorityTop?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by amount vip nfts collected, with tie-breaker of earliest collector first */
  vipNftsCount?: InputMaybe<SortOrder | '%future added value'>;
};

/** Input values for release admin update */
export type ReleaseDetailsInput = {
  /** Artist story of release */
  behindTheMusic?: InputMaybe<Scalars['String']>;
  /** Description of release */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Description of golden egg
   * @deprecated No longer used
   */
  eggDescription?: InputMaybe<Scalars['String']>;
  /** Season of release */
  season?: InputMaybe<Scalars['String']>;
  /** Title of release */
  title?: InputMaybe<Scalars['String']>;
  /** Title slug of release */
  titleSlug?: InputMaybe<Scalars['String']>;
  /** E.g. Single, Album */
  type?: InputMaybe<Scalars['String']>;
};

/** Release featured status */
export const ReleaseFeaturedStatus = {
  All: 'ALL',
  Hot: 'HOT'
} as const;

export type ReleaseFeaturedStatus = typeof ReleaseFeaturedStatus[keyof typeof ReleaseFeaturedStatus];
/** Input for "releaseFromToken" query */
export type ReleaseFromTokenInput = {
  /** Contract address of release */
  contractAddress: Scalars['Address'];
  /** Token chain identifier */
  tokenId: Scalars['String'];
};

/** Release info upload step input values */
export type ReleaseInfoUploadStepInput = {
  /** Release beats per minute */
  beatsPerMinute?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Behind the music text */
  behindTheMusic: Scalars['String'];
  /** Cover image */
  coverImage: UploadedMedia;
  /** Release genre */
  genre: Scalars['String'];
  /** Release key */
  key?: InputMaybe<SongKeyType | '%future added value'>;
  /** License for the release */
  license?: InputMaybe<LicenseType | '%future added value'>;
  /** Location where the release was created */
  location?: InputMaybe<Scalars['CountryCode']>;
  /** Release lyrics */
  lyrics?: InputMaybe<Scalars['String']>;
  /** Static cover image to use in place of animated cover image */
  staticCoverImage?: InputMaybe<UploadedMedia>;
  /** Title */
  title: Scalars['String'];
  /** Token symbol */
  tokenSymbol: Scalars['String'];
  /** Uploaded tracks */
  tracks: Array<TrackUpload>;
  /** Release type */
  type: ReleaseType | '%future added value';
};

/** Meta input values for release */
export type ReleaseMetaInput = {
  /** Associated external url */
  externalUrl?: InputMaybe<Scalars['URL']>;
  /**
   * Associated laylo.com url
   * @deprecated Laylo is no longer supported
   */
  layloUrl?: InputMaybe<Scalars['URL']>;
  /** Associated opensea url */
  openseaUrl?: InputMaybe<Scalars['URL']>;
};

/** Filter the releases to be searched */
export type ReleaseSearchFilter = {
  /** Filter releases that are made by specified artists. You can only specify up to 51 artists. */
  artistIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Genre names to filter on for releases */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Only include releases that either have or don't have collectors */
  hasCollectors?: InputMaybe<Scalars['Boolean']>;
  /** Location ids to filter on for releases */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Only get release with specified status */
  releaseStatus?: InputMaybe<Array<ReleaseStatus | '%future added value'>>;
  /** Filters on release type */
  type?: InputMaybe<Array<ReleaseType | '%future added value'>>;
};

/** Customize sort of releases */
export type ReleaseSearchSort = {
  /** Sort by time the release was minted */
  mintStartTime?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by number of mints of each release */
  totalMinted?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by total volume of each release */
  totalVolume?: InputMaybe<SortOrder | '%future added value'>;
};

/** Pagination parameters of release shelves */
export type ReleaseShelvesCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ReleaseShelvesCursorConnectionSort;
};

/** Customize sort of release shelves */
export type ReleaseShelvesCursorConnectionSort = {
  /** Sort by date of release being added in the shelf */
  addedAtDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by shelf score */
  score?: InputMaybe<SortOrder | '%future added value'>;
};

/** Filter release shelves */
export type ReleaseShelvesFilter = {
  /** Filter shelves to be included by identifier. You can only specify up to 51 shelves. */
  shelfIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Filter shelves types to be included */
  type?: InputMaybe<Array<ShelfType | '%future added value'>>;
};

/** Defines sort order of Release fields, array index defines tiebreaking */
export type ReleaseSortInput = {
  /** Field to be sorted */
  field: SearchReleasesSortEnum | '%future added value';
  /** Sort ascending or descending */
  order: SortOrder | '%future added value';
};

/** Release current status type */
export const ReleaseStatus = {
  AvailableToMint: 'AVAILABLE_TO_MINT',
  SoldOut: 'SOLD_OUT',
  Upcoming: 'UPCOMING'
} as const;

export type ReleaseStatus = typeof ReleaseStatus[keyof typeof ReleaseStatus];
/** Release type, currently the platform only supports "SINGLE" */
export const ReleaseType = {
  Album: 'ALBUM',
  AlbumTrack: 'ALBUM_TRACK',
  Single: 'SINGLE'
} as const;

export type ReleaseType = typeof ReleaseType[keyof typeof ReleaseType];
/** Input for Release.webEmbed */
export type ReleaseWebEmbedInput = {
  /** Customize html parameters */
  html?: IframeHtmlParameters;
  /** Referral address */
  referralAddress?: InputMaybe<Scalars['Address']>;
};

/** Customize webapp uri parameters of release */
export type ReleaseWebappUriInput = {
  /** Referral address */
  referralAddress?: InputMaybe<Scalars['Address']>;
};

export const ReleasesCollectorSortEnum = {
  FirstNftCollectedDate: 'FIRST_NFT_COLLECTED_DATE',
  NftsCount: 'NFTS_COUNT'
} as const;

export type ReleasesCollectorSortEnum = typeof ReleasesCollectorSortEnum[keyof typeof ReleasesCollectorSortEnum];
/** Pagination parameters for releases connection */
export type ReleasesCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Start after the first "skip" entities based. It can't be specified alongside "after" or "before" */
  skip?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior of releases pagination */
  sort?: ReleasesCursorConnectionSort;
};

/** Customize sort behavior of releases pagination */
export type ReleasesCursorConnectionSort = {
  /** Sort by createdAt of release */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by mintStartTime of release */
  mintStartTime?: InputMaybe<SortOrder | '%future added value'>;
};

/** Filter releases */
export type ReleasesCursorFilterArgs = {
  /** Filter by getting releases of the artists followed by the specified user identifier */
  artistFollowedByUser?: InputMaybe<Scalars['UUID']>;
  /** Specify up to 50 contracts to filter the releases */
  contracts?: InputMaybe<Array<ContractReleaseInput>>;
  /** Filters on release featured status */
  featuredStatus?: InputMaybe<ReleaseFeaturedStatus | '%future added value'>;
  /**
   * Only get releases from specified genres
   * @deprecated Use "genres" instead
   */
  genre?: InputMaybe<Array<Scalars['String']>>;
  /** Only get releases from specified genres */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Remove currently-featured releases from results */
  hideFeatured?: InputMaybe<Scalars['Boolean']>;
  /** Location ids to filter on for releases */
  locationIds?: InputMaybe<Array<Scalars['String']>>;
  /** Only get releases less or equal to than specified mint time */
  mintTimeMaxDate?: InputMaybe<Scalars['Timestamp']>;
  /** Only get releases greater than or equal to specified mint time */
  mintTimeMinDate?: InputMaybe<Scalars['Timestamp']>;
  /** Only get release with specified mint time status */
  mintTimeStatus?: InputMaybe<Array<MintTimeStatus | '%future added value'>>;
  /** Filters on whether album releases have been revealed or not */
  releaseAlbumRevealStatus?: InputMaybe<ReleaseAlbumRevealFilterOption | '%future added value'>;
  /** Only get release with specified status */
  releaseStatus?: InputMaybe<Array<ReleaseStatus | '%future added value'>>;
  /** Filters on release type */
  releaseType?: InputMaybe<Array<ReleaseType | '%future added value'>>;
  /** Only get releases from specified seasons */
  season?: InputMaybe<Array<ArtistSeason | '%future added value'>>;
};

/** Input of "removeArtist" mutation */
export type RemoveArtistInput = {
  /** Wallet public address of the artist */
  publicAddress: Scalars['Address'];
};

/** Input for `addReleaseToShelf` mutation */
export type RemoveReleaseFromShelfInput = {
  /** Release identifier to be removed */
  releaseId: Scalars['UUID'];
  /** Identifier of owned target shelf */
  shelfId: Scalars['UUID'];
};

/** Input of "removeRelease" mutation */
export type RemoveReleaseInput = {
  /** ID of the release to remove */
  releaseId: Scalars['UUID'];
};

/** Input for reportPlayStopped mutation */
export type ReportPlayStoppedInput = {
  /** End of play session */
  finish: Scalars['Timestamp'];
  /** Duration of play in seconds */
  listenDuration: Scalars['Int'];
  /** Amount of pauses on the same session */
  pauseCount: Scalars['Int'];
  /** Start of play session */
  start: Scalars['Timestamp'];
  /** Track UUID */
  trackId: Scalars['UUID'];
  /** Random UUID generated by client-side */
  uuid: Scalars['String'];
};

/** Custom rewards input */
export type RewardInput = {
  /** Reward description */
  description: Scalars['String'];
  /** Reward name */
  title: Scalars['String'];
};

/** Release rewards upload step input values */
export type RewardsUploadStepInput = {
  /** Whether collectors can download audio */
  canCollectorsDownloadAudio?: InputMaybe<Scalars['Boolean']>;
  /** Toggle for curator rewards */
  curatorRewardsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Special golden egg images */
  goldenEggImages: Array<UploadedMedia>;
  /** Custom rewards */
  rewards?: InputMaybe<Array<RewardInput>>;
};

export const SearchArtistsSortEnum = {
  CreatedAt: 'CREATED_AT',
  TotalMinted: 'TOTAL_MINTED',
  TotalVolume: 'TOTAL_VOLUME'
} as const;

export type SearchArtistsSortEnum = typeof SearchArtistsSortEnum[keyof typeof SearchArtistsSortEnum];
export const SearchCollectorsSortEnum = {
  ArtistsBacked: 'ARTISTS_BACKED',
  CreatedAt: 'CREATED_AT',
  NftsCount: 'NFTS_COUNT',
  TotalMinted: 'TOTAL_MINTED',
  TotalVolume: 'TOTAL_VOLUME'
} as const;

export type SearchCollectorsSortEnum = typeof SearchCollectorsSortEnum[keyof typeof SearchCollectorsSortEnum];
/** Pagination arguments for search */
export type SearchConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 20 nodes. */
  first?: Scalars['PositiveInt'];
};

/** Input for "search" query */
export type SearchInput = {
  /** How many entities to be fetched for fixed lists, maximum of 20 */
  limit?: Scalars['PositiveInt'];
  /** Text search */
  text?: InputMaybe<Scalars['String']>;
};

export const SearchReleasesSortEnum = {
  MintStartTime: 'MINT_START_TIME',
  TotalMinted: 'TOTAL_MINTED',
  TotalVolume: 'TOTAL_VOLUME'
} as const;

export type SearchReleasesSortEnum = typeof SearchReleasesSortEnum[keyof typeof SearchReleasesSortEnum];
export const SearchShelvesSortEnum = {
  CreatedAt: 'CREATED_AT',
  NumLikes: 'NUM_LIKES',
  NumReferralPurchases: 'NUM_REFERRAL_PURCHASES'
} as const;

export type SearchShelvesSortEnum = typeof SearchShelvesSortEnum[keyof typeof SearchShelvesSortEnum];
/** Input for setArtistMeta mutation */
export type SetArtistMetaInput = {
  /** Artist identifier */
  artistId: Scalars['String'];
  /** Artist meta configuration data */
  metaType?: InputMaybe<ArtistMetaInput>;
};

/** Input for setArtistOnboardedByPublicAddresMeta mutation */
export type SetArtistOnboardedByPublicAddressMetaInput = {
  /** Artist identifier */
  artistId: Scalars['String'];
  /** Address of team member who onboarded this artist */
  onboardedByPublicAddress?: InputMaybe<Scalars['String']>;
};

/** Input for setReleaseMeta mutation */
export type SetAudioDownloadRewardInput = {
  /** Release identifier */
  releaseId: Scalars['String'];
  /** Toggle audio download reward for collectors */
  toggle: Scalars['Boolean'];
};

/** Input for setReleaseDetails mutation */
export type SetReleaseDetailsInput = {
  /** Release details input values */
  releaseDetails: ReleaseDetailsInput;
  /** Release identifier */
  releaseId: Scalars['String'];
};

/** Input for setReleaseMeta mutation */
export type SetReleaseMetaInput = {
  /** Meta input values */
  metaType?: InputMaybe<ReleaseMetaInput>;
  /** Release identifier */
  releaseId: Scalars['String'];
};

/** Input fields to set releases to shelf */
export type SetReleasesForShelfInput = {
  /** List of releaseIds to set to shelf */
  releaseIds: Array<Scalars['UUID']>;
  /** Shelf id to set releases to */
  shelfId: Scalars['UUID'];
};

/** Input for setSamBuyBufferBpsOverride mutation */
export type SetSamBuyBufferBpsOverrideInput = {
  /** Release identifier */
  releaseId: Scalars['String'];
  /** Buffer in bps applied to totalBuyPrice, not specifying will clear any existing overrides */
  samBuyBufferBpsOverride?: InputMaybe<Scalars['Int']>;
};

/** Input for setSamSellBufferBpsOverride mutation */
export type SetSamSellBufferBpsOverrideInput = {
  /** Release identifier */
  releaseId: Scalars['String'];
  /** Buffer in bps applied to totalSellPrice, not specifying will clear any existing overrides */
  samSellBufferBpsOverride?: InputMaybe<Scalars['Int']>;
};

/** Input for setVoteOnPostComment mutation */
export type SetVoteOnPostCommentInput = {
  /** ID of the post comment */
  postCommentId: Scalars['UUID'];
  /** New state to set the vote status to. */
  voteStatus: PostVoteChange | '%future added value';
};

/** Input for setVoteOnPost mutation */
export type SetVoteOnPostInput = {
  /** ID of the post */
  postId: Scalars['UUID'];
  /** New state to set the vote status to. */
  voteStatus: PostVoteChange | '%future added value';
};

/** Cursor connection parameters for shelves */
export type ShelfCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ShelfCursorConnectionSort;
};

/** Customize the sort behavior of shelves pagination */
export type ShelfCursorConnectionSort = {
  /** Sort by created at date */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by shelf index value */
  index?: InputMaybe<SortOrder | '%future added value'>;
};

/** Cursor connection parameters for shelf ordered releases */
export type ShelfOrderedReleaseCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
};

/** Cursor connection parameters for shelf releases */
export type ShelfReleaseCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Customize sort behavior */
  sort?: ShelfReleaseCursorConnectionSort;
};

/** Customize the sort behavior of releases within shelf pagination */
export type ShelfReleaseCursorConnectionSort = {
  /** Sort by date when the release was added into shelf */
  addedAtDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by release index value */
  index?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by shelf score */
  score?: InputMaybe<SortOrder | '%future added value'>;
};

/** Customize sort behavior of shelf releases */
export type ShelfReleasesSort = {
  /** Sort by release added to shelf date */
  addedToShelfDate?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by release index of shelf */
  index?: SortOrder | '%future added value';
};

/** Filter the shelf to be searched */
export type ShelfSearchFilter = {
  /** Genre names to filter on for shelf songs */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
};

/** Customize sorting of shelves */
export type ShelfSearchSort = {
  /** Sort by time playlist was created */
  createdAt?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by number of likes */
  numLikes?: InputMaybe<SortOrder | '%future added value'>;
  /** Sort by number of referral purchases (Mints Driven) */
  numReferralPurchases?: InputMaybe<SortOrder | '%future added value'>;
};

/** Defines sort order of Shelf fields, array index defines tiebreaking */
export type ShelfSortInput = {
  /** Field to be sorted */
  field: SearchShelvesSortEnum | '%future added value';
  /** Sort ascending or descending */
  order: SortOrder | '%future added value';
};

/** Shelf type */
export const ShelfType = {
  Default: 'DEFAULT',
  UserLikedSounds: 'USER_LIKED_SOUNDS'
} as const;

export type ShelfType = typeof ShelfType[keyof typeof ShelfType];
/** Filter based the type of shelf */
export const ShelfTypeFilter = {
  All: 'ALL',
  Liked: 'LIKED',
  UserCreated: 'USER_CREATED'
} as const;

export type ShelfTypeFilter = typeof ShelfTypeFilter[keyof typeof ShelfTypeFilter];
/** Input for Shelf.webEmbed */
export type ShelfWebEmbedInput = {
  /** Customize html parameters */
  html?: IframeHtmlParameters;
};

/** Key the release was written in */
export const SongKeyType = {
  AFlatMajor: 'A_FLAT_MAJOR',
  AMajor: 'A_MAJOR',
  AMinor: 'A_MINOR',
  BFlatMajor: 'B_FLAT_MAJOR',
  BFlatMinor: 'B_FLAT_MINOR',
  BMajor: 'B_MAJOR',
  BMinor: 'B_MINOR',
  CMajor: 'C_MAJOR',
  CMinor: 'C_MINOR',
  CSharpMinor: 'C_SHARP_MINOR',
  DFlatMajor: 'D_FLAT_MAJOR',
  DMajor: 'D_MAJOR',
  DMinor: 'D_MINOR',
  EFlatMajor: 'E_FLAT_MAJOR',
  EFlatMinor: 'E_FLAT_MINOR',
  EMajor: 'E_MAJOR',
  EMinor: 'E_MINOR',
  FMajor: 'F_MAJOR',
  FMinor: 'F_MINOR',
  FSharpMajor: 'F_SHARP_MAJOR',
  FSharpMinor: 'F_SHARP_MINOR',
  GMajor: 'G_MAJOR',
  GMinor: 'G_MINOR',
  GSharpMinor: 'G_SHARP_MINOR'
} as const;

export type SongKeyType = typeof SongKeyType[keyof typeof SongKeyType];
/** Ascending or Descending sort */
export const SortOrder = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
/** Splits upload step input values */
export type SplitsUploadStepInput = {
  /** Credit allocations of credit split */
  splits: Array<Allocation>;
};

/** Subscribe to artist updates input */
export type SubscribeArtistActivityNotificationInput = {
  /** ID of the artist to subscribe current user to */
  artist: Scalars['UUID'];
};

/** The Tier of the NFT owned by ReleaseCollector */
export const TierNft = {
  All: 'ALL',
  Ga: 'GA',
  Vip: 'VIP'
} as const;

export type TierNft = typeof TierNft[keyof typeof TierNft];
/** Mode that differentiates behavior of tier schedule */
export const TierScheduleMode = {
  Default: 'DEFAULT',
  VerifyMerkle: 'VERIFY_MERKLE',
  VerifySignature: 'VERIFY_SIGNATURE'
} as const;

export type TierScheduleMode = typeof TierScheduleMode[keyof typeof TierScheduleMode];
/** Allocation input for credit split of tiered edition */
export type TieredAllocation = {
  /** Owner address of allocation */
  ownerAddress: Scalars['Address'];
  /** Percent of allocation */
  percent: Scalars['Float'];
  /** Roles associated with credit allocation */
  roles: Array<CreditRoleType | '%future added value'>;
};

/** TieredDraft auction configuration input values */
export type TieredAuctionConfigurationInput = {
  /** Auction end time */
  endTime?: InputMaybe<Scalars['Timestamp']>;
  /** Auction end time in days */
  endTimeDays?: InputMaybe<Scalars['Int']>;
  /** Max mints per wallet for auction */
  maxMintsPerWallet: Scalars['PositiveInt'];
  /** Price per mint */
  price: Scalars['NonNegativeFloat'];
  /** Max supply for auction */
  quantity: Scalars['PositiveInt'];
  /** Auction start time */
  startTime: Scalars['Timestamp'];
};

/** Tiered Draft auction configurations input values */
export type TieredAuctionConfigurationsInput = {
  /** Type of auction */
  auctionType: TieredAuctionType | '%future added value';
  /** Max mint supply of auction */
  maxMintable: Scalars['PositiveInt'];
  /** Min mint supply of auction */
  minQuantity: Scalars['PositiveInt'];
  /** Presale mint auction configurations */
  presaleMint?: InputMaybe<TieredAuctionConfigurationInput>;
  /** Public mint auction configurations */
  publicMint: TieredAuctionConfigurationInput;
  /** Breakdown of mint quantities */
  quantityBreakdown?: InputMaybe<Array<Scalars['PositiveInt']>>;
};

/** Types of tiered release sales */
export const TieredAuctionType = {
  FixedQuantity: 'FIXED_QUANTITY',
  FixedQuantityWithGa: 'FIXED_QUANTITY_WITH_GA',
  OpenEdition: 'OPEN_EDITION',
  OpenEditionWithGa: 'OPEN_EDITION_WITH_GA'
} as const;

export type TieredAuctionType = typeof TieredAuctionType[keyof typeof TieredAuctionType];
/** TieredDraft allow list inputs */
export type TieredDraftAllowListInput = {
  /** Draft collectors of artists */
  collectorsOfArtists?: InputMaybe<TieredDraftCollectorsOfArtistsInput>;
  /** Draft collectors of releases */
  collectorsOfReleases?: InputMaybe<TieredDraftCollectorsOfReleasesInput>;
  /** Draft manually added allowlist releases */
  manuallyAddedAllowlist?: InputMaybe<TieredDraftManuallyAddedAllowlistInput>;
};

/** Tiered Draft allowlists configurations */
export type TieredDraftAllowListsInput = {
  /** Presale mint draft allowlist configuration */
  presaleMint?: InputMaybe<TieredDraftAllowListInput>;
};

/** Tiered Draft collectors of artists inputs */
export type TieredDraftCollectorsOfArtistsInput = {
  /** Toggle to include or not include all artist collectors */
  allArtistCollectors?: Scalars['Boolean'];
  /** Select artist identifiers */
  selectedArtistIds: Array<Scalars['UUID']>;
};

/** Tiered Draft collectors of releases inputs */
export type TieredDraftCollectorsOfReleasesInput = {
  /** Toggle to include or not include all artist collaborations */
  allArtistCollaborations: Scalars['Boolean'];
  /** Select release identifiers */
  selectedReleaseIds: Array<Scalars['UUID']>;
};

/** Tiered Draft manually added allowlist inputs */
export type TieredDraftManuallyAddedAllowlistInput = {
  /** Addresses manually added by artist */
  addresses?: InputMaybe<Array<Scalars['Address']>>;
  /** Tiered Draft manually added allowlist description */
  description?: InputMaybe<Scalars['String']>;
};

/** Tiered Release info upload step input values */
export type TieredReleaseInfoUploadStepInput = {
  /** Release beats per minute */
  beatsPerMinute?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Behind the music text */
  behindTheMusic: Scalars['String'];
  /** Cover image */
  coverImage: UploadedMedia;
  /** General Admission cover image */
  gaCoverImage?: InputMaybe<UploadedMedia>;
  /** General Admission static cover image */
  gaStaticCoverImage?: InputMaybe<UploadedMedia>;
  /** Release genre */
  genre: Genres | '%future added value';
  /** Special golden egg image */
  goldenEggImage?: InputMaybe<UploadedMedia>;
  /** Release key */
  key?: InputMaybe<SongKeyType | '%future added value'>;
  /** License for the release */
  license?: InputMaybe<LicenseType | '%future added value'>;
  /** Whether a listening party should be added and synchronized with the public sale's start time */
  listeningPartyPublicSaleStartTime?: Scalars['Boolean'];
  /** Location where the release was created */
  location?: InputMaybe<Scalars['CountryCode']>;
  /** Release lyrics */
  lyrics?: InputMaybe<Scalars['String']>;
  /** Spotify track id */
  spotifyTrackId?: InputMaybe<Scalars['String']>;
  /** Static cover image to use in place of animated cover image */
  staticCoverImage?: InputMaybe<UploadedMedia>;
  /** Title */
  title: Scalars['String'];
  /** Token symbol */
  tokenSymbol: Scalars['String'];
  /** Uploaded track */
  track: TrackUpload;
};

/** Release rewards upload step input values */
export type TieredRewardsUploadStepInput = {
  /** Whether collectors can download audio */
  canCollectorsDownloadAudio?: InputMaybe<Scalars['Boolean']>;
  /** Toggle for curator rewards */
  curatorRewardsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Special golden egg images */
  goldenEggImages?: InputMaybe<Array<UploadedMedia>>;
  /** Custom rewards */
  rewards?: InputMaybe<Array<RewardInput>>;
};

/** Tiered Splits upload step input values */
export type TieredSplitsUploadStepInput = {
  /** Credit allocations of credit split */
  splits: Array<TieredAllocation>;
};

/** Time period to aggregate trending table queries */
export const TimePeriodAggEnum = {
  AllTime: 'ALL_TIME',
  OneDay: 'ONE_DAY',
  OneMonth: 'ONE_MONTH',
  SevenDay: 'SEVEN_DAY'
} as const;

export type TimePeriodAggEnum = typeof TimePeriodAggEnum[keyof typeof TimePeriodAggEnum];
/** Input for top affiliate curators query */
export type TopAffiliateCuratorsInput = {
  /** Limit the amount to be returned, Up to 100 */
  limit?: Scalars['PositiveInt'];
  /** Sort logic used */
  sort: TopCuratorsSortEnum | '%future added value';
  /** For what time period the data should come from */
  timePeriod: TopChartTimePeriodEnum | '%future added value';
};

/** Input for top artists query */
export type TopArtistsInput = {
  /** Limit the amount to be returned, Up to 100 */
  limit?: Scalars['PositiveInt'];
  /** Sort logic used */
  sort: TrendingArtistsSortEnum | '%future added value';
  /** For what time period the data should come from */
  timePeriod: TopChartTimePeriodEnum | '%future added value';
};

/** Time period to aggregate top chart queries */
export const TopChartTimePeriodEnum = {
  AllTime: 'ALL_TIME',
  SevenDay: 'SEVEN_DAY',
  ThirtyDay: 'THIRTY_DAY'
} as const;

export type TopChartTimePeriodEnum = typeof TopChartTimePeriodEnum[keyof typeof TopChartTimePeriodEnum];
export const TopCuratorsSortEnum = {
  Mints: 'MINTS',
  SoundsReferred: 'SOUNDS_REFERRED',
  TotalAffiliateEarned: 'TOTAL_AFFILIATE_EARNED',
  TotalVolume: 'TOTAL_VOLUME'
} as const;

export type TopCuratorsSortEnum = typeof TopCuratorsSortEnum[keyof typeof TopCuratorsSortEnum];
/** Input for topPlaylists query */
export type TopPlaylistsInput = {
  /** Limit the amount to be returned, Up to 100 */
  limit?: Scalars['PositiveInt'];
  /** Sort logic used */
  sort: TrendingPlaylistsSortEnum | '%future added value';
  /** For what time period the data should come from */
  timePeriod: TimePeriodAggEnum | '%future added value';
};

/** Input for totalAffiliatePurchases query */
export type TotalAffiliatePurchasesInput = {
  /** Pagination parameters */
  pagination?: ReleaseAffiliateTotalPurchasesCursorConnectionArgs;
};

/** Uploaded track information */
export type TrackUpload = {
  /** Cover image */
  coverImage?: InputMaybe<UploadedMedia>;
  /** Duration of track in seconds */
  duration: Scalars['Int'];
  /** Details of uploaded track file */
  fileDetail: UploadedMedia;
  /** Normalized peaks of track */
  normalizedPeaks: Array<Scalars['Int']>;
  /** Title of track */
  title: Scalars['String'];
};

/** Type of sort parameter used for trending artists */
export const TrendingArtistsSortEnum = {
  NftsSold: 'NFTS_SOLD',
  PrimarySales: 'PRIMARY_SALES',
  SecondarySales: 'SECONDARY_SALES',
  TotalSales: 'TOTAL_SALES',
  UniqueCollectors: 'UNIQUE_COLLECTORS'
} as const;

export type TrendingArtistsSortEnum = typeof TrendingArtistsSortEnum[keyof typeof TrendingArtistsSortEnum];
/** Type of sort paratemer used for trending collectors */
export const TrendingCollectorsSortEnum = {
  CreatorsSupported: 'CREATORS_SUPPORTED',
  NftsBought: 'NFTS_BOUGHT',
  TotalSpent: 'TOTAL_SPENT'
} as const;

export type TrendingCollectorsSortEnum = typeof TrendingCollectorsSortEnum[keyof typeof TrendingCollectorsSortEnum];
/** Trending indicator type */
export const TrendingIndicator = {
  Down: 'DOWN',
  New: 'NEW',
  Same: 'SAME',
  Up: 'UP'
} as const;

export type TrendingIndicator = typeof TrendingIndicator[keyof typeof TrendingIndicator];
/** Type of sort paratemer used for trending playlists */
export const TrendingPlaylistsSortEnum = {
  Likes: 'LIKES'
} as const;

export type TrendingPlaylistsSortEnum = typeof TrendingPlaylistsSortEnum[keyof typeof TrendingPlaylistsSortEnum];
/** Type of sort paratemer used for trending releases */
export const TrendingReleasesSortEnum = {
  NftsSold: 'NFTS_SOLD',
  PrimarySales: 'PRIMARY_SALES',
  SecondarySales: 'SECONDARY_SALES',
  TotalSales: 'TOTAL_SALES',
  UniqueCollectors: 'UNIQUE_COLLECTORS'
} as const;

export type TrendingReleasesSortEnum = typeof TrendingReleasesSortEnum[keyof typeof TrendingReleasesSortEnum];
/** User relation type */
export const TypeOfRelation = {
  Following: 'FOLLOWING'
} as const;

export type TypeOfRelation = typeof TypeOfRelation[keyof typeof TypeOfRelation];
/** Input fields to unfollow user */
export type UnfollowUserInput = {
  /** User id to unfollow */
  user: Scalars['UUID'];
};

/** Input for `unlikeRelease` mutation */
export type UnlikeReleaseInput = {
  /** Release identifier to be un-liked */
  releaseId: Scalars['UUID'];
};

/** Input for `unlikeShelf` mutation */
export type UnlikeShelfInput = {
  /** Shelf identifier to be un-liked */
  shelfId: Scalars['UUID'];
};

/** Unsubscribe to artist updates input */
export type UnsubscribeArtistActivityNotificationInput = {
  /** Unsubscribe current user to up to 51 artists at a time */
  artists: Array<Scalars['UUID']>;
};

/** Input for updateChannelSettings mutation */
export type UpdateChannelSettingsInput = {
  /** ID of the channel */
  channelId: Scalars['UUID'];
  /** Uploaded cover image */
  coverImage?: InputMaybe<UploadedMedia>;
  /** Description of the channel */
  description: Scalars['String'];
  /** discord URL */
  discordUrl?: InputMaybe<Scalars['URL']>;
  /** User IDs of the channel moderators */
  moderatorUserIds: Array<Scalars['UUID']>;
  /** Name of the channel */
  name: Scalars['String'];
  /** The URL slug of the channel */
  nameSlug: Scalars['String'];
  /** Uploaded profile image */
  profileImage?: InputMaybe<UploadedMedia>;
  /** Telegram URL */
  telegramUrl?: InputMaybe<Scalars['URL']>;
  /** tiktok URL */
  tiktokUrl?: InputMaybe<Scalars['URL']>;
  /** twitter URL */
  twitterUrl?: InputMaybe<Scalars['URL']>;
  /** website URL */
  websiteUrl?: InputMaybe<Scalars['URL']>;
};

/** Input for updateDraftInfo mutation */
export type UpdateDraftInfoInput = {
  /** Draft identifier */
  draftId: Scalars['String'];
  /** Draft info input */
  info: DraftInfoInput;
  /** Step number */
  stepNumber: Scalars['PositiveInt'];
};

/** Input for updateKeyClient */
export type UpdateKeyClient = {
  /** Identifier of existing Key Client */
  id: Scalars['UUID'];
  /** Change the name of the specified Key Client */
  name?: InputMaybe<Scalars['NonEmptyString']>;
  /** Change the status of the specified Key Client */
  status?: InputMaybe<KeyClientStatus | '%future added value'>;
};

/** Input for setUploadBlockStatus mutation */
export type UploadBlockStatusInput = {
  /** Is the user going to be blocked or unblocked */
  isBlocked: Scalars['Boolean'];
  /** Public address of user */
  publicAddress: Scalars['Address'];
  /** Optional reason of the block */
  reason?: InputMaybe<Scalars['String']>;
};

/** Input for signedUploadParams mutation */
export type UploadRequest = {
  /** File name of media to be uploaded */
  fileName: Scalars['String'];
  /** Media type to be uploaded */
  mediaType: MediaType | '%future added value';
};

/** Media to be uploaded */
export type UploadedMedia = {
  /** Media type to be uploaded */
  mediaType: MediaType | '%future added value';
  /** Upload key received from Query.signedUploadParams */
  uploadKey: Scalars['String'];
};

/** Input fields to upsert shelf */
export type UpsertShelfInput = {
  /** Upsert shelf Cover image */
  coverImage?: InputMaybe<UploadedMedia>;
  /** Upsert shelf description */
  description?: InputMaybe<Scalars['String']>;
  /** Shelf id to update */
  id?: InputMaybe<Scalars['UUID']>;
  /** Upsert shelf name */
  name?: InputMaybe<Scalars['String']>;
  /** Upsert shelf type */
  type?: InputMaybe<ShelfType | '%future added value'>;
};

/** Filter of User.collectedReleases paginated field */
export type UserCollectedReleasesFilter = {
  /** Filters on a list of specified genres */
  genres?: InputMaybe<Array<Genres | '%future added value'>>;
  /** Filters on whether album releases have been revealed or not */
  releaseAlbumRevealStatus?: ReleaseAlbumRevealFilterOption | '%future added value';
  /** Filter on a list of specified release ids */
  releaseIds?: InputMaybe<Array<Scalars['UUID']>>;
  /** Text search on release title or artist's name or handle */
  text?: InputMaybe<Scalars['NonEmptyString']>;
  /** Filters on release type */
  type?: InputMaybe<Array<ReleaseType | '%future added value'>>;
};

/** Cursor connection parameters */
export type UserCursorConnectionArgs = {
  /** Start forwards pagination since "after" cursor */
  after?: InputMaybe<Scalars['String']>;
  /** Start backwards pagination since "before" cursor */
  before?: InputMaybe<Scalars['String']>;
  /** Limit the amount of nodes to be fetched, to be used with "after", with a maximum of 51 nodes. */
  first?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Limit the amount of nodes to be fetched, to be used with "before", with a maximum of 51 nodes. */
  last?: InputMaybe<Scalars['NonNegativeInt']>;
  /** Sort the users ascending or descending relative to the user creation date */
  sort?: SortOrder | '%future added value';
};

/** Filter the NFTs of User */
export type UserNftsConnectionFilters = {
  /** Only include Nfts from specified releases */
  releases?: InputMaybe<Array<Scalars['UUID']>>;
};

/** Filter the shelves of a user */
export type UserShelvesFilter = {
  /** Case-insensitive text search on shelves names */
  text?: InputMaybe<Scalars['NonEmptyString']>;
  /** Filter by different types of shelves available for users. */
  type?: ShelfTypeFilter | '%future added value';
};

/** Input of VersionSupported query */
export type VersionStatusInput = {
  /** Platform type */
  platform: PlatformType | '%future added value';
  /** Semantic version */
  version: Scalars['SemanticVersion'];
};

export type ArtistApplicationCardFragment = { id: string, status: ArtistApplicationStatus, createdAt: string, mostRecentApplicationRejectionReason: string | null, info: { artistName: string, soundHandle: string, email: string, twitterHandle: string | null, instagramHandle: string | null, spotifyUrl: string | null } | null, user: { id: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } } & { ' $fragmentName'?: 'ArtistApplicationCardFragment' };

export type ArtistApplicationsPageQueryVariables = Exact<{
  pagination?: InputMaybe<CursorConnectionArgs>;
  filter?: InputMaybe<ArtistApplicationsFilter>;
}>;


export type ArtistApplicationsPageQuery = { artistApplications: { edges: Array<{ node: (
        { id: string, createdAt: string }
        & { ' $fragmentRefs'?: { 'ArtistApplicationCardFragment': ArtistApplicationCardFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type AcceptArtistApplicationMutationVariables = Exact<{
  applicationID: Scalars['UUID'];
}>;


export type AcceptArtistApplicationMutation = { acceptArtistApplication: { __typename: 'MutationAcceptArtistApplicationSuccess', data: { id: string, status: ArtistApplicationStatus } } | { __typename: 'NotificationEmailFailedToSendError' } | { __typename: 'ValidationError', message: string } };

export type RejectArtistApplicationMutationVariables = Exact<{
  applicationID: Scalars['UUID'];
  reason: Scalars['String'];
}>;


export type RejectArtistApplicationMutation = { rejectArtistApplication: { __typename: 'MutationRejectArtistApplicationSuccess', data: { id: string, status: ArtistApplicationStatus } } | { __typename: 'NotificationEmailFailedToSendError' } | { __typename: 'ValidationError', message: string } };

export type AdminArtistDefaultMintingOptionsQueryVariables = Exact<{
  artistAddress: Scalars['Address'];
}>;


export type AdminArtistDefaultMintingOptionsQuery = { artistDefaultMintingOptions: { auction: Array<{ __typename: 'FixedAuction', priceOptions: Array<number>, quantityOptions: Array<number>, publicSaleMaxMintsPerWalletOptions: Array<number>, presaleMaxMintsPerWalletOptions: Array<number>, minPrice: number, maxPrice: number, minQuantity: number, maxQuantity: number, presaleMinPrice: number, presaleMaxPrice: number, mintingStartsInDays: Array<number>, minPublicSaleMaxMintsPerWallet: number, maxPublicSaleMaxMintsPerWallet: number, minPresaleMaxMintsPerWallet: number, maxPresaleMaxMintsPerWallet: number } | { __typename: 'OpenEditionAuction', priceOptions: Array<number>, minOptions: Array<number>, minPrice: number, maxPrice: number, presaleMinPrice: number, presaleMaxPrice: number, mintingPeriodDays: Array<number>, mintingStartsInDays: Array<number> } | { __typename: 'OpenEditionWithSAMAuction', priceOptions: Array<number>, minOptions: Array<number>, inflectionCountSAM: number, inflectionMultipleBPS: number, minPrice: number, maxPrice: number, presaleMinPrice: number, presaleMaxPrice: number, linearPriceSlope: string, mintingPeriodDays: Array<number>, mintingStartsInDays: Array<number> }> } };

export type AdminSeasonDefaultMintingOptionsQueryVariables = Exact<{
  seasonName: Scalars['String'];
}>;


export type AdminSeasonDefaultMintingOptionsQuery = { seasonDefaultMintingOptions: { auction: Array<{ __typename: 'FixedAuction', priceOptions: Array<number>, quantityOptions: Array<number>, publicSaleMaxMintsPerWalletOptions: Array<number>, presaleMaxMintsPerWalletOptions: Array<number>, minPrice: number, maxPrice: number, minQuantity: number, maxQuantity: number, presaleMinPrice: number, presaleMaxPrice: number, mintingStartsInDays: Array<number>, minPublicSaleMaxMintsPerWallet: number, maxPublicSaleMaxMintsPerWallet: number, minPresaleMaxMintsPerWallet: number, maxPresaleMaxMintsPerWallet: number } | { __typename: 'OpenEditionAuction', priceOptions: Array<number>, minOptions: Array<number>, minPrice: number, maxPrice: number, presaleMinPrice: number, presaleMaxPrice: number, mintingPeriodDays: Array<number>, mintingStartsInDays: Array<number> } | { __typename: 'OpenEditionWithSAMAuction', priceOptions: Array<number>, minOptions: Array<number>, inflectionCountSAM: number, inflectionMultipleBPS: number, minPrice: number, maxPrice: number, presaleMinPrice: number, presaleMaxPrice: number, linearPriceSlope: string, mintingPeriodDays: Array<number>, mintingStartsInDays: Array<number> }> } };

export type CustomizeHighlightedReleasesMutationVariables = Exact<{
  params: Scalars['JSON'];
}>;


export type CustomizeHighlightedReleasesMutation = { customizeHighlightedReleases: { __typename: 'MutationCustomizeHighlightedReleasesSuccess', data: { weights: unknown, viralChartsWeights: unknown | null, lastUpdatedAt: string | null } } | { __typename: 'NotAuthorizedError' } | { __typename: 'ValidationError' } };

export type MintedReleaseToChooseFromQueryVariables = Exact<{
  input: SearchInput;
}>;


export type MintedReleaseToChooseFromQuery = { search: { id: string, releasesPaginated: { edges: Array<{ node: { id: string, contractAddress: string, title: string, artist: { id: string, name: string } } }> } } };

export type AdminArtistMintingOptionMutationVariables = Exact<{
  auctionType: AuctionInputRef;
  artistAddress: Scalars['Address'];
}>;


export type AdminArtistMintingOptionMutation = { artistMintingOption: { id: string } };

export type AdminSetEnabledSplitArtistMutationVariables = Exact<{
  address: Scalars['Address'];
  metaType?: InputMaybe<AuctionMetaInput>;
}>;


export type AdminSetEnabledSplitArtistMutation = { artistAuctionMeta: { id: string, artistAddress: string } };

export type AdminSetReleaseMetaMutationVariables = Exact<{
  input: SetReleaseMetaInput;
}>;


export type AdminSetReleaseMetaMutation = { setReleaseMeta: { id: string, openseaUrl: string | null } };

export type AdminSeasonMintingOptionMutationVariables = Exact<{
  auctionType: AuctionInputRef;
  seasonName: Scalars['String'];
}>;


export type AdminSeasonMintingOptionMutation = { seasonMintingOption: { season: string, id: string } };

export type AdminSetEnabledSplitSeasonMutationVariables = Exact<{
  seasonName: Scalars['String'];
  metaType?: InputMaybe<AuctionMetaInput>;
}>;


export type AdminSetEnabledSplitSeasonMutation = { seasonAuctionMeta: { id: string, season: string } };

export type HighlightedParamsQueryVariables = Exact<{ [key: string]: never; }>;


export type HighlightedParamsQuery = { highlightedReleasesParameters: { __typename: 'NotAuthorizedError' } | { __typename: 'QueryHighlightedReleasesParametersSuccess', data: { weights: unknown, viralChartsWeights: unknown | null, pinnedReleases: unknown | null } } };

export type PinnedReleasesQueryVariables = Exact<{
  filter?: InputMaybe<ReleasesCursorFilterArgs>;
}>;


export type PinnedReleasesQuery = { releases: { edges: Array<{ cursor: string, node: { id: string, title: string, contractAddress: string, artist: { id: string, name: string } } }> } };

export type VerifyInstagramMutationVariables = Exact<{
  authCode: Scalars['String'];
  redirectURI: Scalars['String'];
}>;


export type VerifyInstagramMutation = { verifyInstagram: { __typename: 'InstagramAPIError', message: string } | { __typename: 'MutationVerifyInstagramSuccess', data: { id: string, instagramHandle: string | null } } };

export type ResetInstagramMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetInstagramMutation = { resetInstagramHandle: { __typename: 'MutationResetInstagramHandleSuccess', data: { id: string, instagramHandle: string | null } } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationError', message: string } };

export type VerifyTwitterHandleMutationVariables = Exact<{
  authCode: Scalars['String'];
  redirectURI: Scalars['String'];
}>;


export type VerifyTwitterHandleMutation = { verifyTwitterHandle: { __typename: 'MutationVerifyTwitterHandleSuccess', data: { id: string, twitterHandle: string | null } } | { __typename: 'TwitterAPIError', message: string } };

export type ResetTwitterHandleMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetTwitterHandleMutation = { resetTwitterHandle: { __typename: 'MutationResetTwitterHandleSuccess', data: { id: string, twitterHandle: string | null } } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationError', message: string } };

export type CreateArtistApplicationMutationVariables = Exact<{
  formInput: CreateArtistApplicationInput;
}>;


export type CreateArtistApplicationMutation = { createArtistApplication: { __typename: 'MutationCreateArtistApplicationSuccess', data: { id: string } } | { __typename: 'NotificationEmailFailedToSendError', message: string } | { __typename: 'ValidationError', message: string } };

export type SetArtistAvatarMutationVariables = Exact<{
  image: UploadedMedia;
}>;


export type SetArtistAvatarMutation = { uploadUserMedia: { id: string, avatar: { id: string, url: string, key: string } | null } };

export type CheckSoundHandleAvailabilityQueryVariables = Exact<{
  soundHandle: Scalars['String'];
}>;


export type CheckSoundHandleAvailabilityQuery = { isSoundHandleAvailable: boolean };

export type BackedArtistSectionFragment = (
  { id: string, webappUri: string }
  & { ' $fragmentRefs'?: { 'SeeAllUserInfoFragment': SeeAllUserInfoFragment } }
) & { ' $fragmentName'?: 'BackedArtistSectionFragment' };

export type BackedArtistsQueryVariables = Exact<{
  id: Scalars['UUID'];
  pagination?: InputMaybe<ArtistCollectorCursorConnectionArgs>;
}>;


export type BackedArtistsQuery = { user: { id: string, backedArtists: { pageInfo: { hasNextPage: boolean }, edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'CollectorCardInfoFragment': CollectorCardInfoFragment } }
        ) }> } } | null };

export type PlayerTrackInfoQueryVariables = Exact<{
  trackId: Scalars['UUID'];
}>;


export type PlayerTrackInfoQuery = { track: (
    { id: string, release: (
      { id: string, listeningParty: number | null }
      & { ' $fragmentRefs'?: { 'ReleaseTrackAudioInfoFragment': ReleaseTrackAudioInfoFragment;'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TrackAudioInfoFragment': TrackAudioInfoFragment } }
  ) | null };

export type WaveformExpandedPlayerInfoFragment = (
  { id: string, track: { id: string, normalizedPeaks: Array<number> } }
  & { ' $fragmentRefs'?: { 'WaveformCommentsReleaseInfoFragment': WaveformCommentsReleaseInfoFragment } }
) & { ' $fragmentName'?: 'WaveformExpandedPlayerInfoFragment' };

export type WaveformExpandedPlayerQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type WaveformExpandedPlayerQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'WaveformExpandedPlayerInfoFragment': WaveformExpandedPlayerInfoFragment } }
  ) | null };

export type SeeAllChannelsFragment = { id: string, name: string, webappUri: string, nameSlug: string, coverImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'SeeAllChannelsFragment' };

export type ChannelAboutFragment = { description: string | null, createdAt: string, twitterUrl: string | null, telegramUrl: string | null, discordUrl: string | null, tiktokUrl: string | null, websiteUrl: string | null } & { ' $fragmentName'?: 'ChannelAboutFragment' };

export type ChannelHeroFragment = { coverImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'ChannelHeroFragment' };

export type ChannelInfoFragment = { id: string, name: string, description: string | null, nameSlug: string, telegramUrl: string | null, tiktokUrl: string | null, twitterUrl: string | null, webappUri: string, websiteUrl: string | null, discordUrl: string | null, profileImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'ChannelInfoFragment' };

export type UpdateChannelSettingsMutationVariables = Exact<{
  input: UpdateChannelSettingsInput;
}>;


export type UpdateChannelSettingsMutation = { updateChannelSettings: { __typename: 'MutationUpdateChannelSettingsSuccess' } | { __typename: 'NotAllowedError', message: string } | { __typename: 'ValidationError', message: string } };

export type SearchChannelModeratorsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchChannelModeratorsQuery = { search: { id: string, artistsPaginated: { edges: Array<{ node: { id: string, name: string, webappUri: string, user: { id: string, publicAddress: string, avatar: { url: string, id: string } | null } } }> }, collectors: { edges: Array<{ node: { id: string, displayName: string | null, publicAddress: string, webappUri: string, avatar: { url: string, id: string } | null } }> } } };

export type ChannelSettingsQueryVariables = Exact<{
  channelSlug: Scalars['String'];
}>;


export type ChannelSettingsQuery = { channelBySlug: { id: string, name: string, description: string | null, nameSlug: string, telegramUrl: string | null, tiktokUrl: string | null, twitterUrl: string | null, websiteUrl: string | null, discordUrl: string | null, coverImage: { id: string, url: string, key: string } | null, profileImage: { id: string, url: string, key: string } | null } | null };

export type ChannelCuratorsQueryVariables = Exact<{
  channelId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
}>;


export type ChannelCuratorsQuery = { channelCurators: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, role: ChannelCuratorRole, user: { id: string, displayName: string | null, publicAddress: string, webappUri: string, avatar: { url: string, id: string } | null, artist: { id: string, name: string, webappUri: string } | null } } }> } };

export type SetUserEngagementOnChannelMutationVariables = Exact<{
  channelId: Scalars['UUID'];
}>;


export type SetUserEngagementOnChannelMutation = { setUserEngagementOnChannel: { __typename: 'MutationSetUserEngagementOnChannelSuccess' } | { __typename: 'NotFoundError', message: string } | null };

export type ChannelPageSocialProofQueryVariables = Exact<{
  channelId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
}>;


export type ChannelPageSocialProofQuery = { channelMembersWhoAreFollowed: { __typename: 'NotFoundError' } | { __typename: 'QueryChannelMembersWhoAreFollowedSuccess', data: { count: number, members: { edges: Array<{ node: { id: string, user: (
              { id: string }
              & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'UserModalRowFragment': UserModalRowFragment } }
            ) } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } } };

export type ChannelMembersQueryVariables = Exact<{
  channelId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
}>;


export type ChannelMembersQuery = { channelMembers: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, createdAt: string, user: (
          { id: string, displayName: string | null, publicAddress: string, webappUri: string, avatar: { url: string, id: string } | null, artist: { id: string, name: string, webappUri: string } | null }
          & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
        ) } }> } };

export type SetChannelNotificationsMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  status: ChannelNotificationStatus;
}>;


export type SetChannelNotificationsMutation = { setUserNotificationPreferencesOnChannel: { __typename: 'MutationSetUserNotificationPreferencesOnChannelSuccess' } | { __typename: 'NotFoundError', message: string } };

export type ChannelPostsQueryVariables = Exact<{
  channelId: Scalars['String'];
  pagination: CursorConnectionArgs;
}>;


export type ChannelPostsQuery = { channelPosts: { edges: Array<{ cursor: string, node: (
        { __typename: 'ActivityFeedGroupBackingPost', id: string, createdAt: string, webappUri: string, commentCount: number, creator: (
          { id: string }
          & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'PostGroupItem_ActivityFeedGroupBackingPost_Fragment': PostGroupItem_ActivityFeedGroupBackingPost_Fragment } }
      ) | (
        { __typename: 'ArtistDropPost', id: string, createdAt: string, webappUri: string, commentCount: number, creator: (
          { id: string }
          & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'PostGroupItem_ArtistDropPost_Fragment': PostGroupItem_ArtistDropPost_Fragment } }
      ) | (
        { __typename: 'PlaylistPost', id: string, createdAt: string, webappUri: string, commentCount: number, creator: (
          { id: string }
          & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'PostGroupItem_PlaylistPost_Fragment': PostGroupItem_PlaylistPost_Fragment } }
      ) | (
        { __typename: 'ReleasePost', id: string, createdAt: string, webappUri: string, commentCount: number, creator: (
          { id: string }
          & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'PostGroupItem_ReleasePost_Fragment': PostGroupItem_ReleasePost_Fragment } }
      ) | (
        { __typename: 'Repost', id: string, createdAt: string, webappUri: string, commentCount: number, creator: (
          { id: string }
          & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'PostGroupItem_Repost_Fragment': PostGroupItem_Repost_Fragment } }
      ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } } };

export type ChannelStatsQueryVariables = Exact<{
  input: QueryChannelStatsInput;
}>;


export type ChannelStatsQuery = { channelStats: Array<{ channelId: string, joinStatus: CurrentUserChannelJoinStatus | null, memberCount: number, postCount: number, notificationStatus: ChannelNotificationStatus | null }> };

export type AllChannelsQueryVariables = Exact<{
  pagination: CursorConnectionArgs;
}>;


export type AllChannelsQuery = { allChannels: { edges: Array<{ cursor: string, node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'SeeAllChannelsFragment': SeeAllChannelsFragment } }
      ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } } };

export type IsChannelCuratorQueryVariables = Exact<{
  input: QueryIsChannelCuratorInput;
}>;


export type IsChannelCuratorQuery = { isChannelCurator: Array<{ __typename: 'IsChannelCuratorResult', channelId: string, result: boolean, role: ChannelCuratorRole | null }> };

export type IsChannelMemberQueryVariables = Exact<{
  input: QueryIsChannelMemberInput;
}>;


export type IsChannelMemberQuery = { isChannelMember: Array<{ __typename: 'ChannelResult', channelId: string, result: boolean }> };

export type JoinOrLeaveChannelMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  join: Scalars['Boolean'];
}>;


export type JoinOrLeaveChannelMutation = { setUserJoinStatusOnChannel: { __typename: 'MutationSetUserJoinStatusOnChannelSuccess' } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationError', message: string } };

export type RecommendedChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendedChannelsQuery = { recommendedChannels: Array<{ __typename: 'RecommendedChannel', memberCount: number, hasNewContent: boolean | null, channel: { id: string, name: string, webappUri: string, staticProfileImage: { id: string, url: string } | null, profileImage: { id: string, url: string } | null } }> };

export type ChartsThreeDotReleaseInfoFragment = (
  { id: string, webappUri: string, type: ReleaseType, track: { id: string } }
  & { ' $fragmentRefs'?: { 'SongCardDropdownInfoFragment': SongCardDropdownInfoFragment } }
) & { ' $fragmentName'?: 'ChartsThreeDotReleaseInfoFragment' };

export type ChartCardDetailsQueryVariables = Exact<{
  input: ReleaseChartRankInput;
  collectorAmount: Scalars['NonNegativeInt'];
}>;


export type ChartCardDetailsQuery = { releaseChartRank: { id: string, currentRank: number, rankLast: number | null, rankPeak: number | null, trendingStreak: number, release: { id: string, webappUri: string, collectors: { edges: Array<{ node: { id: string, user: { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } }, artist: { id: string, webappUri: string }, activityFeed: { edges: Array<{ node: (
            { __typename: 'Airdrop', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_Airdrop_Fragment': ActivityReleaseAction_Airdrop_Fragment } }
          ) | (
            { __typename: 'BondingCurveSale', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_BondingCurveSale_Fragment': ActivityReleaseAction_BondingCurveSale_Fragment } }
          ) | (
            { __typename: 'BondingCurveSold', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_BondingCurveSold_Fragment': ActivityReleaseAction_BondingCurveSold_Fragment } }
          ) | (
            { __typename: 'CreatedPost', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_CreatedPost_Fragment': ActivityReleaseAction_CreatedPost_Fragment } }
          ) | (
            { __typename: 'PlaylistCreated', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_PlaylistCreated_Fragment': ActivityReleaseAction_PlaylistCreated_Fragment } }
          ) | (
            { __typename: 'PrimarySale', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_PrimarySale_Fragment': ActivityReleaseAction_PrimarySale_Fragment } }
          ) | (
            { __typename: 'ReleaseDropped', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleaseDropped_Fragment': ActivityReleaseAction_ReleaseDropped_Fragment } }
          ) | (
            { __typename: 'ReleaseLiked', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleaseLiked_Fragment': ActivityReleaseAction_ReleaseLiked_Fragment } }
          ) | (
            { __typename: 'ReleasesAddedRemovedFromPlaylist', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleasesAddedRemovedFromPlaylist_Fragment': ActivityReleaseAction_ReleasesAddedRemovedFromPlaylist_Fragment } }
          ) | (
            { __typename: 'ReleasesAddedToPlaylist', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleasesAddedToPlaylist_Fragment': ActivityReleaseAction_ReleasesAddedToPlaylist_Fragment } }
          ) | (
            { __typename: 'SecondarySale', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_SecondarySale_Fragment': ActivityReleaseAction_SecondarySale_Fragment } }
          ) | (
            { __typename: 'UserPresavedRelease', id: string, date: string }
            & { ' $fragmentRefs'?: { 'ActivityReleaseAction_UserPresavedRelease_Fragment': ActivityReleaseAction_UserPresavedRelease_Fragment } }
          ) }> } } } };

export type FullSizeChartCardFragment = { id: string, trendingIndicator: TrendingIndicator, currentRank: number, release: (
    { id: string, type: ReleaseType, title: string, webappUri: string, listeningParty: number | null, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string }, artist: { id: string, name: string, webappUri: string }, track: { id: string }, topCollectors: Array<{ nftsCount: number, user: { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } }> }
    & { ' $fragmentRefs'?: { 'StatsFragment': StatsFragment;'ChartsThreeDotReleaseInfoFragment': ChartsThreeDotReleaseInfoFragment } }
  ) } & { ' $fragmentName'?: 'FullSizeChartCardFragment' };

export type PlaylistChartCardFragment = { id: string, currentRank: number, trendingIndicator: TrendingIndicator, playlist: (
    { id: string, numReferralPurchases: number, name: string, trackIds: Array<string>, webappUri: string, coverImage: { id: string, url: string } | null, user: { id: string, username: string, webappUri: string } }
    & { ' $fragmentRefs'?: { 'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment;'PlaylistShareInfoFragment': PlaylistShareInfoFragment } }
  ) } & { ' $fragmentName'?: 'PlaylistChartCardFragment' };

export type StatsFragment = { id: string, finalQuantity: number | null, supplyCutoffTimestamp: number | null, isFirstPhaseCompleted: boolean, mintStartTimestamp: number, quantityLowerBound: number, quantityUpperBound: number, totalMinted: number, listing: { id: string, tiers: Array<{ id: string, tierNumber: number, totalMinted: number }> } | null } & { ' $fragmentName'?: 'StatsFragment' };

export type ViralSoundsDownloadQueryQueryVariables = Exact<{
  chartId: Scalars['UUID'];
  pagination: ReleaseChartRankCursorConnectionArgs;
}>;


export type ViralSoundsDownloadQueryQuery = { releaseChartById: { id: string, periodStartInclusive: string, periodEndExclusive: string, chartRanks: { edges: Array<{ node: { id: string, currentRank: number, release: { id: string, title: string, artist: { id: string, name: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null } } }> } } | null };

export type CoinbaseSoundBarReleaseFragment = (
  { id: string, title: string, type: ReleaseType, listeningParty: number | null, totalMinted: number, mintStartTimestamp: number, price: string, supplyCutoffTimestamp: number | null, webappUri: string, artist: { id: string, name: string, webappUri: string, user: { id: string } }, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string, dominantColor: string | null }, track: { id: string, normalizedPeaks: Array<number>, duration: number }, goldenEggNft: { id: string, owner: { id: string } } | null }
  & { ' $fragmentRefs'?: { 'WaveformNoCommentsFragment': WaveformNoCommentsFragment;'CollectModalFragment': CollectModalFragment;'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
) & { ' $fragmentName'?: 'CoinbaseSoundBarReleaseFragment' };

export type CollectorCardInfoFragment = { id: string, nftsCount: number, firstNftCollectedDate: string, firstNftCollected: { id: string, release: { id: string, title: string } }, artist: { id: string, name: string, webappUri: string, user: { ' $fragmentRefs'?: { 'UserForCollectorFragment': UserForCollectorFragment } } }, user: { ' $fragmentRefs'?: { 'UserForCollectorFragment': UserForCollectorFragment } } } & { ' $fragmentName'?: 'CollectorCardInfoFragment' };

export type UserForCollectorFragment = { id: string, publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'UserForCollectorFragment' };

export type CollectorSectionFragment = { id: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'SeeAllUserInfoFragment': SeeAllUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'CollectorSectionFragment' };

export type ArtistCollectorsPreviewQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  sort: ArtistCollectorCursorConnectionSort;
  first: Scalars['NonNegativeInt'];
}>;


export type ArtistCollectorsPreviewQuery = { artist: { id: string, collectors: { pageInfo: { hasNextPage: boolean }, edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'CollectorCardInfoFragment': CollectorCardInfoFragment } }
        ) }> } } | null };

export type GetTotalReleasesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalReleasesCountQuery = { totalReleasesCount: number };

export type GetCollectedReleasesCountQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type GetCollectedReleasesCountQuery = { user: { id: string, collectedReleasesCount: number, collectedReleasesIds: Array<string> | null } | null };

export type ShelfFragment = { id: string, name: string, description: string | null, webappUri: string, coverImage: { id: string, key: string } | null } & { ' $fragmentName'?: 'ShelfFragment' };

export type UploadShelfCoverImageMutationVariables = Exact<{
  input: MutationUpsertShelfCoverImageInput;
}>;


export type UploadShelfCoverImageMutation = { upsertShelfCoverImage: { __typename: 'MutationUpsertShelfCoverImageSuccess', data: { ' $fragmentRefs'?: { 'ShelfFragment': ShelfFragment } } } | { __typename: 'NotFoundError' } | null };

export type UpsertShelfMutationVariables = Exact<{
  input: UpsertShelfInput;
}>;


export type UpsertShelfMutation = { upsertShelf: (
    { coverImage: { id: string, url: string, key: string } | null, orderedReleases: { edges: Array<{ node: { ' $fragmentRefs'?: { 'SimpleShelfReleaseFragment': SimpleShelfReleaseFragment } } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } }
    & { ' $fragmentRefs'?: { 'ShelfFragment': ShelfFragment } }
  ) };

export type GetShelfQueryVariables = Exact<{
  id: Scalars['UUID'];
  pagination: ShelfOrderedReleaseCursorConnectionArgs;
}>;


export type GetShelfQuery = { shelf: (
    { id: string, type: ShelfType, webappUri: string, coverImage: { id: string, url: string } | null, orderedReleases: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'SimpleShelfReleaseFragment': SimpleShelfReleaseFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } }
    & { ' $fragmentRefs'?: { 'ShelfFragment': ShelfFragment } }
  ) };

export type SetShelfReleasesMutationVariables = Exact<{
  input: SetReleasesForShelfInput;
}>;


export type SetShelfReleasesMutation = { setShelfReleases: { __typename: 'MutationSetShelfReleasesSuccess', data: (
      { orderedReleases: { edges: Array<{ node: { ' $fragmentRefs'?: { 'SimpleShelfReleaseFragment': SimpleShelfReleaseFragment } } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } }
      & { ' $fragmentRefs'?: { 'ShelfFragment': ShelfFragment } }
    ) } | { __typename: 'NotAllowedError' } | { __typename: 'UnexpectedValueError' } | { __typename: 'UniqueConstraintError' } };

export type DeleteShelfMutationVariables = Exact<{
  input: DeleteShelfInput;
}>;


export type DeleteShelfMutation = { deleteShelf: null | null };

export type SetFeaturedSoundsMutationVariables = Exact<{
  releaseIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type SetFeaturedSoundsMutation = { setFeaturedSounds: { id: string, featuredReleases: Array<{ ' $fragmentRefs'?: { 'SimpleCollectedReleaseFragment': SimpleCollectedReleaseFragment } }> | null } };

export type GetUserFeaturedSoundsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetUserFeaturedSoundsQuery = { user: { id: string, featuredReleases: Array<{ ' $fragmentRefs'?: { 'SimpleCollectedReleaseFragment': SimpleCollectedReleaseFragment } }> | null } | null };

export type GetUserCollectedReleasesQueryVariables = Exact<{
  userId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
  filter?: InputMaybe<UserCollectedReleasesFilter>;
}>;


export type GetUserCollectedReleasesQuery = { user: { id: string, collectedReleases: { edges: Array<{ node: (
          { id: string, release: (
            { id: string, type: ReleaseType, mintStartTimestamp: number }
            & { ' $fragmentRefs'?: { 'SimpleReleaseFragment': SimpleReleaseFragment } }
          ) }
          & { ' $fragmentRefs'?: { 'SimpleCollectedReleaseFragment': SimpleCollectedReleaseFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } } | null };

export type GetAllReleasesQueryVariables = Exact<{
  input: SearchInput;
  pagination: SearchConnectionArgs;
}>;


export type GetAllReleasesQuery = { search: { id: string, releasesPaginated: { edges: Array<{ node: (
          { id: string, type: ReleaseType, mintStartTimestamp: number }
          & { ' $fragmentRefs'?: { 'SimpleReleaseFragment': SimpleReleaseFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } } };

export type GetInitialReleaseQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type GetInitialReleaseQuery = { release: { ' $fragmentRefs'?: { 'SimpleReleaseFragment': SimpleReleaseFragment } } | null };

export type GetEmptyAllReleasesQueryVariables = Exact<{
  pagination: ReleasesCursorConnectionArgs;
}>;


export type GetEmptyAllReleasesQuery = { releases: { edges: Array<{ node: (
        { id: string, createdAt: string, type: ReleaseType, mintStartTimestamp: number }
        & { ' $fragmentRefs'?: { 'SimpleReleaseFragment': SimpleReleaseFragment } }
      ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } };

export type ExtendShelfMutationVariables = Exact<{
  input: ExtendShelfInput;
}>;


export type ExtendShelfMutation = { extendShelf: { __typename: 'MutationExtendShelfSuccess', data: { id: string } } | { __typename: 'UnexpectedValueError' } | { __typename: 'UniqueConstraintError' } };

export type SimpleShelfReleaseFragment = { id: string, ownedTokens: Array<{ serialNumber: number, tierNumber: number | null }> | null, release: { id: string, type: ReleaseType, createdAt: string, title: string, mintStartTimestamp: number, listeningParty: number | null, artist: { id: string, name: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, track: { id: string } } } & { ' $fragmentName'?: 'SimpleShelfReleaseFragment' };

export type SimpleCollectedReleaseFragment = { id: string, ownedTokens: Array<{ serialNumber: number, tierNumber: number | null }> | null, release: { id: string, type: ReleaseType, createdAt: string, title: string, mintStartTimestamp: number, listeningParty: number | null, artist: { id: string, name: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, track: { id: string } } } & { ' $fragmentName'?: 'SimpleCollectedReleaseFragment' };

export type SimpleReleaseFragment = { id: string, type: ReleaseType, createdAt: string, title: string, mintStartTimestamp: number, listeningParty: number | null, artist: { id: string, name: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, track: { id: string } } & { ' $fragmentName'?: 'SimpleReleaseFragment' };

export type MemberDesktopRowInfoFragment = { id: string, nftsCount: number, firstNftCollectedDate: string, user: { id: string, instagramHandle: string | null, twitterHandle: string | null } } & { ' $fragmentName'?: 'MemberDesktopRowInfoFragment' };

export type MemberMobileRowInfoFragment = { id: string, nftsCount: number, firstNftCollectedDate: string, user: { id: string, username: string, publicAddress: string, webappUri: string, artist: { id: string } | null, avatar: { id: string, url: string } | null } } & { ' $fragmentName'?: 'MemberMobileRowInfoFragment' };

export type CommunityUserDropdownFragment = { id: string, instagramHandle: string | null, twitterHandle: string | null, publicAddress: string } & { ' $fragmentName'?: 'CommunityUserDropdownFragment' };

export type CommunityMemberInfoFragment = (
  { id: string, user: (
    { id: string, publicAddress: string, username: string, webappUri: string, artist: { id: string } | null, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'CommunityUserDropdownFragment': CommunityUserDropdownFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'MemberMobileRowInfoFragment': MemberMobileRowInfoFragment;'MemberDesktopRowInfoFragment': MemberDesktopRowInfoFragment } }
) & { ' $fragmentName'?: 'CommunityMemberInfoFragment' };

export type CommunityArtistInfoQueryVariables = Exact<{
  artistId: Scalars['UUID'];
}>;


export type CommunityArtistInfoQuery = { artist: { id: string, numCollectors: number } | null };

export type ArtistPrivateCommunityMemberInfoFragment = { id: string, subscriptionEmail: string | null, artistCollector: (
    { id: string }
    & { ' $fragmentRefs'?: { 'CommunityMemberInfoFragment': CommunityMemberInfoFragment } }
  ) } & { ' $fragmentName'?: 'ArtistPrivateCommunityMemberInfoFragment' };

export type ArtistPrivateCommunityMembersQueryVariables = Exact<{
  input: ArtistPrivateCommunityMembersInput;
}>;


export type ArtistPrivateCommunityMembersQuery = { artistPrivateCommunityMembers: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'ArtistPrivateCommunityMemberInfoFragment': ArtistPrivateCommunityMemberInfoFragment } }
      ) }> } };

export type CommunityCsvUrlQueryVariables = Exact<{
  input: ArtistCommunityCsvUrlInput;
}>;


export type CommunityCsvUrlQuery = { artistCommunityCSVUrl: string | null };

export type ArtistMintedReleasesQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination?: InputMaybe<CursorConnectionArgs>;
}>;


export type ArtistMintedReleasesQuery = { artist: { id: string, releases: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, draftId: string | null, contractAddress: string, auctionContractType: ContractType | null, mintStartTimestamp: number, title: string, webappUri: string, type: ReleaseType, numSold: number, quantityUpperBound: number, finalQuantity: number | null, isAuctionSoldOut: boolean | null, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, listing: { id: string, tiers: Array<{ id: string, tierNumber: number, totalMinted: number, maxMintableUpper: number, mintConcluded: boolean }> } | null } }> } } | null };

export type ReferralEarningsTableDesktopInfoFragment = { id: string, purchasesQuantity: number, earningsETH: string, release: (
    { id: string, title: string, webappUri: string, artist: { id: string, name: string, webappUri: string }, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string } }
    & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
  ) } & { ' $fragmentName'?: 'ReferralEarningsTableDesktopInfoFragment' };

export type ReferralEarningsTableMobileInfoFragment = { id: string, purchasesQuantity: number, earningsETH: string, release: (
    { id: string, title: string, webappUri: string, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string } }
    & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
  ) } & { ' $fragmentName'?: 'ReferralEarningsTableMobileInfoFragment' };

export type ReferralEarningsHookQueryVariables = Exact<{
  input: TotalAffiliatePurchasesInput;
}>;


export type ReferralEarningsHookQuery = { totalAffiliatePurchases: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'ReferralEarningsTableDesktopInfoFragment': ReferralEarningsTableDesktopInfoFragment;'ReferralEarningsTableMobileInfoFragment': ReferralEarningsTableMobileInfoFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type ReferralEarningsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralEarningsQuery = { cummulativeAffiliateEarned: string, claimableAffiliateEarnings: Array<{ ' $fragmentRefs'?: { 'AggregateAffiliateBalanceFragment': AggregateAffiliateBalanceFragment;'UpdateReferralWithdrawableInfoFragment': UpdateReferralWithdrawableInfoFragment } }> };

export type SponsoredAffiliateWithdrawMutationVariables = Exact<{
  input: MutationSponsoredAffiliateWithdrawInput;
}>;


export type SponsoredAffiliateWithdrawMutation = { sponsoredAffiliateWithdraw: { __typename: 'ForbiddenError', message: string } | { __typename: 'GelatoAPIError', message: string } | { __typename: 'MutationSponsoredAffiliateWithdrawSuccess', data: { gelatoTaskId: string } } | { __typename: 'RateLimitError', message: string } };

export type UpdateReferralWithdrawableInfoFragment = { id: string, amount: string } & { ' $fragmentName'?: 'UpdateReferralWithdrawableInfoFragment' };

export type ReleaseEarningRowFragment = (
  { primaryRevenue: string, secondaryRoyalties: string, ownershipPercent: number, release: { id: string, title: string, chainId: number, webappUri: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, artist: { id: string, name: string, webappUri: string }, creditSplit: { id: string, splitAddress: string | null, creditAllocations: Array<{ id: string, percent: number, owner: { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } }> } | null } }
  & { ' $fragmentRefs'?: { 'WithdrawReleaseFragment': WithdrawReleaseFragment } }
) & { ' $fragmentName'?: 'ReleaseEarningRowFragment' };

export type WithdrawReleaseFragment = (
  { totalWithdrawableForUser: string, splitMainBalanceFromRelease: string, release: { id: string, chainId: number, creditSplit: { id: string, splitAddress: string | null } | null } }
  & { ' $fragmentRefs'?: { 'ConfirmWithdrawReleaseFragment': ConfirmWithdrawReleaseFragment } }
) & { ' $fragmentName'?: 'WithdrawReleaseFragment' };

export type ExternalSplitMainBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalSplitMainBalanceQuery = { balancesAndEarnings: Array<{ chainId: number, externalSplitMainBalance: string }> };

export type ReleaseEarningsHookQueryVariables = Exact<{
  pagination: CursorConnectionArgs;
}>;


export type ReleaseEarningsHookQuery = { releaseEarnings: { edges: Array<{ node: (
        { id: string, release: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleaseEarningRowFragment': ReleaseEarningRowFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type WithdrawAllDataFragment = { chainId: number, totalAvailableToWithdraw: string, releasesAvailableToWithdraw: string, totalSplitMainBalance: string, externalSplitMainBalance: string } & { ' $fragmentName'?: 'WithdrawAllDataFragment' };

export type CreatorEarningsFragment = (
  { chainId: number, externalSplitMainBalance: string, totalAvailableToWithdraw: string }
  & { ' $fragmentRefs'?: { 'WithdrawAllDataFragment': WithdrawAllDataFragment } }
) & { ' $fragmentName'?: 'CreatorEarningsFragment' };

export type SponsoredWithdrawMutationVariables = Exact<{
  input: MutationSponsoredWithdrawInput;
}>;


export type SponsoredWithdrawMutation = { sponsoredWithdraw: { __typename: 'ForbiddenError', message: string } | { __typename: 'GelatoAPIError', message: string } | { __typename: 'MutationSponsoredWithdrawSuccess', data: { gelatoTaskId: string } } | { __typename: 'RateLimitError', message: string } };

export type WithdrawEarningsForReleaseQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type WithdrawEarningsForReleaseQuery = { withdrawableEarningsForRelease: { releaseContract: { __typename: 'ArtistContractEarning', contractAddress: string, editionId: string } | { __typename: 'EditionContractEarning', contractAddress: string } | null, splitContract: { distributorFee: number, contractAddress: string, participantAddresses: Array<string>, participantAllocations: Array<number> } | null } };

export type WithdrawableEarningsForChainQueryVariables = Exact<{
  chain: ChainType;
}>;


export type WithdrawableEarningsForChainQuery = { withdrawableEarningsForChain: { artistContracts: Array<{ contractAddress: string, editionId: string }>, editionContracts: Array<{ contractAddress: string }>, splitContracts: Array<{ distributorFee: number, contractAddress: string, participantAddresses: Array<string>, participantAllocations: Array<number> }> } };

export type EarningsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type EarningsPageQuery = { balancesAndEarnings: Array<{ ' $fragmentRefs'?: { 'AggregateBalanceAndEarningsFragment': AggregateBalanceAndEarningsFragment } }> };

export type AggregateAffiliateBalanceFragment = { id: string, amount: string, chainId: number, minterAddresses: Array<string> } & { ' $fragmentName'?: 'AggregateAffiliateBalanceFragment' };

export type AggregateBalanceAndEarningsFragment = (
  { chainId: number, cummulativeEarned: string, totalAvailableToWithdraw: string }
  & { ' $fragmentRefs'?: { 'CreatorEarningsFragment': CreatorEarningsFragment } }
) & { ' $fragmentName'?: 'AggregateBalanceAndEarningsFragment' };

export type EditReleaseAsyncMutationVariables = Exact<{
  input: MutationEditReleaseAsyncInput;
}>;


export type EditReleaseAsyncMutation = { editReleaseAsync: { __typename: 'MutationEditReleaseAsyncSuccess', data: { editReleaseAsyncRequestId: string } } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationError', message: string } };

export type EditReleaseAsyncStatusQueryVariables = Exact<{
  editReleaseAsyncRequestId: Scalars['UUID'];
}>;


export type EditReleaseAsyncStatusQuery = { editReleaseAsyncStatus: { __typename: 'DuplicatedError', message: string } | { __typename: 'EmptyMerkleTreeError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'QueryEditReleaseAsyncStatusSuccess', data: { __typename: 'EditReleaseAsyncStatusPending' } | { __typename: 'EditReleaseAsyncStatusProcessing', processingCount: number, outputs: { mainPresaleMerkleTreeRoot: string | null, arweave: { coreEditionArweaveHash: string | null, storefrontArweaveHash: string, tiers: Array<{ arweaveHash: string, tierNumber: number }> | null } | null }, release: { id: string, webappUri: string } } | { __typename: 'EditReleaseAsyncStatusSuccess', outputs: { mainPresaleMerkleTreeRoot: string | null, arweave: { coreEditionArweaveHash: string | null, storefrontArweaveHash: string, tiers: Array<{ arweaveHash: string, tierNumber: number }> | null } | null }, release: { id: string, webappUri: string } } } | { __typename: 'ValidationError', message: string } };

export type ConfirmedReleaseEditQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type ConfirmedReleaseEditQuery = { release: { id: string, webappUri: string, contractAddress: string, chainId: number } | null };

export type ReleaseForEditQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReleaseForEditQuery = { release: (
    { id: string, title: string, chainId: number, auctionType: AuctionType | null, lastUpdatedAt: string | null, behindTheMusic: string, isAuctionSoldOut: boolean | null, publicAffiliateFeeBPS: number | null, canCollectorsDownloadAudio: boolean, contractAddress: string, auctionContractType: ContractType | null, spotifyPresaveCampaign: boolean, spotifyTrackId: string | null, creditSplit: { id: string, splitAddress: string | null, creditAllocations: Array<{ id: string, percent: number, roles: Array<string>, owner: { id: string, publicAddress: string } }> } | null, genre: { id: string, name: string }, coverImage: { id: string, key: string, url: string }, gaCoverImage: { id: string, key: string, url: string } | null, staticCoverImage: { id: string, key: string, url: string } | null, goldenEggImage: { id: string, key: string, url: string }, track: { id: string, duration: number, normalizedPeaks: Array<number>, audio: { audioOriginal: { id: string, key: string, url: string } } }, metadataDetails: { bpm: number | null, key: string | null, license: string | null, location: string | null, lyrics: string | null } | null, rewards: Array<{ description: string, id: string, title: string }> }
    & { ' $fragmentRefs'?: { 'ReleaseSuperMinterV2InfoFragment': ReleaseSuperMinterV2InfoFragment } }
  ) | null };

export type ReleaseAllowlistForEditQueryVariables = Exact<{
  input: ReleaseAllowlistInput;
}>;


export type ReleaseAllowlistForEditQuery = { releaseAllowlist: { id: string, info: { allArtistCollaborations: boolean, allArtistCollectors: boolean, manuallyAddedAddresses: Array<string> | null, sourceSelectedArtistIds: Array<string> | null, sourceSelectedReleaseIds: Array<string> | null }, manuallyAddedAddresses: { id: string, description: string | null } | null } | null };

export type GetUserNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationPreferencesQuery = { userNotificationPreferences: { email: string | null, emailVerificationStatus: EmailVerificationStatus, receiveArtistUpdateEmails: boolean, receiveMentionUpdateEmails: boolean } | null };

export type SetReceiveMentionUpdateEmailsMutationVariables = Exact<{
  enable: Scalars['Boolean'];
}>;


export type SetReceiveMentionUpdateEmailsMutation = { setReceiveMentionUpdateEmails: { __typename: 'CustomerIoAPICallError', message: string } | { __typename: 'MutationSetReceiveMentionUpdateEmailsSuccess', data: { __typename: 'UserNotificationPreferences' } } };

export type SetReceiveArtistUpdateEmailsMutationVariables = Exact<{
  enable: Scalars['Boolean'];
}>;


export type SetReceiveArtistUpdateEmailsMutation = { setReceiveArtistUpdateEmails: { __typename: 'CustomerIoAPICallError', message: string } | { __typename: 'MutationSetReceiveArtistUpdateEmailsSuccess', data: { __typename: 'UserNotificationPreferences' } } };

export type UpdateNotificationEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars['EmailAddress']>;
}>;


export type UpdateNotificationEmailMutation = { updateNotificationEmail: { __typename: 'MutationUpdateNotificationEmailSuccess', data: { email: string | null, emailVerificationStatus: EmailVerificationStatus } } | { __typename: 'NotificationEmailAlreadyClaimedError', message: string } | { __typename: 'NotificationEmailFailedToSendError', message: string } };

export type EditedManuallyAddedAllowlistQueryVariables = Exact<{
  input: ReleaseAllowlistInput;
}>;


export type EditedManuallyAddedAllowlistQuery = { releaseAllowlist: { id: string, totalUsers: number, info: { allArtistCollaborations: boolean, allArtistCollectors: boolean, manuallyAddedAddresses: Array<string> | null }, manuallyAddedAddresses: { id: string, totalAddresses: number, description: string | null } | null } | null };

export type EditAddCollectorsReleaseAllowlistQueryVariables = Exact<{
  input: ReleaseAllowlistInput;
}>;


export type EditAddCollectorsReleaseAllowlistQuery = { releaseAllowlist: { id: string, info: { allArtistCollaborations: boolean, allArtistCollectors: boolean, sourceSelectedArtistIds: Array<string> | null, sourceSelectedReleaseIds: Array<string> | null } } | null };

export type SelectedArtistInfoFragment = { name: string | null, publicAddress: string | null, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'SelectedArtistInfoFragment' };

export type SelectedReleaseInfoFragment = { title: string, artistName: string, artistUserId: string, creditUserIds: Array<string>, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'SelectedReleaseInfoFragment' };

export type SelectedArtistsQueryVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type SelectedArtistsQuery = { multiSelectArtists: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'SelectedArtistInfoFragment': SelectedArtistInfoFragment } }
  )> };

export type SelectedReleasesQueryVariables = Exact<{
  ids: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type SelectedReleasesQuery = { multiSelectReleases: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'SelectedReleaseInfoFragment': SelectedReleaseInfoFragment } }
  )> };

export type AddUsersToAllowlistMutationVariables = Exact<{
  input: AddUsersToDraftAllowlistInput;
}>;


export type AddUsersToAllowlistMutation = { addUsersToDraftAllowlist: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'MutationAddUsersToDraftAllowlistSuccess', data: { softErrorMessages: Array<string> | null, allowList: { id: string } } } };

export type DeleteUsersFromAllowlistMutationVariables = Exact<{
  input: DeleteUsersFromDraftAllowlistInput;
}>;


export type DeleteUsersFromAllowlistMutation = { deleteUsersFromDraftAllowlist: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'MutationDeleteUsersFromDraftAllowlistSuccess', data: { id: string } } | { __typename: 'NotFoundError', message: string } };

export type DeleteAllUsersFromAllowlistMutationVariables = Exact<{
  input: DeleteAllUsersFromDraftAllowlistInput;
}>;


export type DeleteAllUsersFromAllowlistMutation = { deleteAllUsersFromDraftAllowlist: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'MutationDeleteAllUsersFromDraftAllowlistSuccess', data: { id: string } } | { __typename: 'NotFoundError', message: string } };

export type GetDraftAllowlistQueryVariables = Exact<{
  input: DraftAllowlistInput;
  pagination: UserCursorConnectionArgs;
}>;


export type GetDraftAllowlistQuery = { draftAllowList: { id: string, totalUsers: number, users: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } }> } } | null };

export type ReleasesForAllowlistPaginatedQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination?: InputMaybe<CursorConnectionArgs>;
  filter?: InputMaybe<ArtistReleasesFilter>;
}>;


export type ReleasesForAllowlistPaginatedQuery = { artist: { id: string, releases: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ cursor: string, node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'ReleaseForAllowlistFragment': ReleaseForAllowlistFragment } }
        ) }> } } | null };

export type ReleaseForAllowlistFragment = { mintStartTime: number, title: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, artist: { id: string, name: string } } & { ' $fragmentName'?: 'ReleaseForAllowlistFragment' };

export type GetDraftQueryVariables = Exact<{
  draftId: Scalars['UUID'];
}>;


export type GetDraftQuery = { draft: { id: string, contractAddressSalt: string, artist: { id: string, name: string }, release: { id: string, contractAddress: string, auctionContractType: ContractType | null, chainId: number, webappUri: string, isFirstPhaseCompleted: boolean, auctionType: AuctionType | null } | null, info: { numUploadStepsComplete: number, releaseInfo: { title: string, tokenSymbol: string, genre: string, type: string, behindTheMusic: string, beatsPerMinute: number | null, lyrics: string | null, key: SongKeyType | null, license: LicenseType | null, location: string | null, tracks: Array<{ title: string, normalizedPeaks: Array<number>, duration: number, fileDetail: { mediaType: MediaType, uploadKey: string }, coverImage: { mediaType: MediaType, uploadKey: string } | null }>, coverImage: { mediaType: MediaType, uploadKey: string }, staticCoverImage: { mediaType: MediaType, uploadKey: string } | null } | null, rewardsInfo: { canCollectorsDownloadAudio: boolean, curatorRewardsEnabled: boolean, goldenEggImages: Array<{ mediaType: MediaType, uploadKey: string }>, rewards: Array<{ title: string, description: string }> } | null, auctionConfigurations: { auctionType: AuctionType, maxMintable: number, minQuantity: number, quantityBreakdown: Array<number> | null, presaleMint: { startTime: number, endTime: number | null, price: number, quantity: number, maxMintsPerWallet: number } | null, publicMint: { startTime: number, endTime: number | null, price: number, quantity: number, maxMintsPerWallet: number } } | null, splitsInfo: { splits: Array<{ ownerAddress: string, percent: number, roles: Array<CreditRoleType> }> } | null, allowListInfo: { presaleMint: { collectorsOfReleases: { allArtistCollaborations: boolean, allArtistReleases: boolean, selectedReleases: Array<{ id: string }> } | null, collectorsOfArtists: { allArtistCollectors: boolean, allCollaboratingArtists: boolean, selectedArtists: Array<{ id: string }> } | null, manuallyAddedAllowlist: { description: string | null } | null } | null } | null } | null } };

export type CreateDraftMutationVariables = Exact<{
  input: CreateDraftInput;
}>;


export type CreateDraftMutation = { createDraft: { __typename: 'DuplicatedError', message: string } | { __typename: 'MutationCreateDraftSuccess', data: { id: string } } | { __typename: 'ValidationError', message: string } };

export type UpdateDraftInfoMutationVariables = Exact<{
  input: UpdateDraftInfoInput;
}>;


export type UpdateDraftInfoMutation = { updateDraftInfo: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'DuplicatedError', message: string } | { __typename: 'EmptyMerkleTreeError', message: string } | { __typename: 'MutationUpdateDraftInfoSuccess', data: { id: string } } | { __typename: 'ValidationError', message: string } | { __typename: 'ZodValidationError', message: string } };

export type GetDraftDataQueryVariables = Exact<{
  draftId: Scalars['UUID'];
}>;


export type GetDraftDataQuery = { draft: { id: string, createdAt: string, slug: string, info: { releaseInfo: { title: string, coverImage: { uploadKey: string } } | null, auctionConfigurations: { presaleMint: { startTime: number } | null } | null } | null, release: (
      { id: string, chainId: number, title: string, coverImage: { id: string, url: string } }
      & { ' $fragmentRefs'?: { 'EditReleaseTopBarFragment': EditReleaseTopBarFragment } }
    ) | null } };

export type FeatureFlagQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type FeatureFlagQuery = { featureFlag: { id: string, value: string } | null };

export type DraftPreviewInfoQueryVariables = Exact<{
  draftId: Scalars['UUID'];
}>;


export type DraftPreviewInfoQuery = { draft: { id: string, artist: { id: string, name: string }, info: { releaseInfo: { title: string, coverImage: { uploadKey: string }, tracks: Array<{ fileDetail: { uploadKey: string } }> } | null } | null, release: { id: string, contractAddress: string } | null } };

export type EditReleaseTopBarFragment = { id: string, lastUpdatedAt: string | null, title: string, coverImage: { id: string, url: string } } & { ' $fragmentName'?: 'EditReleaseTopBarFragment' };

export type ReleaseByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReleaseByIdQuery = { release: { id: string, contractAddress: string, auctionContractType: ContractType | null, behindTheMusic: string, canCollectorsDownloadAudio: boolean, chainId: number, draftId: string | null, publicAffiliateFeeBPS: number | null, title: string, coverImage: { id: string, key: string }, creditSplit: { id: string, splitAddress: string | null, creditAllocations: Array<{ id: string, percent: number, roles: Array<string>, owner: { id: string, publicAddress: string } }> } | null, genre: { id: string, name: string }, goldenEggImage: { id: string, key: string }, metadataDetails: { bpm: number | null, key: string | null, license: string | null, location: string | null, lyrics: string | null } | null, rewards: Array<{ description: string, id: string, title: string }>, staticCoverImage: { id: string, key: string } | null, track: { duration: number, id: string, normalizedPeaks: Array<number>, title: string, audio: { audio192k: { id: string, key: string } | null, audioOriginal: { id: string, key: string } } } } | null };

export type EditReleaseMutationVariables = Exact<{
  input: EditReleaseInput;
}>;


export type EditReleaseMutation = { editRelease: { __typename: 'ArweavePerUserBudgetExceededError', message: string } | { __typename: 'DuplicatedError', message: string } | { __typename: 'EmptyMerkleTreeError', message: string } | { __typename: 'MutationEditReleaseSuccess', data: { draft: { id: string, edit: { id: string, info: { arweaveHash: string | null, storefrontArweaveHash: string | null, allowlistInfo: { presaleMint: { merkleRoot: string | null } | null } | null, rewardsInfo: { curatorRewardsEnabled: boolean | null } | null } | null } | null } | null } } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedValueError', message: string } | { __typename: 'ValidationError', message: string } };

export type ExistingContractQueryVariables = Exact<{
  contractAddress: Scalars['Address'];
}>;


export type ExistingContractQuery = { releaseFromContract: { id: string } | null };

export type CreateTieredDraftMutationVariables = Exact<{
  input: MutationCreateTieredDraftInput;
}>;


export type CreateTieredDraftMutation = { createTieredDraft: { __typename: 'AuthorizationError', message: string } | { __typename: 'DuplicatedError', message: string } | { __typename: 'MutationCreateTieredDraftSuccess', data: { id: string } } | { __typename: 'ValidationError', message: string } };

export type TieredDraftMetadataUploadMutationVariables = Exact<{
  input: MutationTieredDraftMetadataUploadAsyncInput;
}>;


export type TieredDraftMetadataUploadMutation = { tieredDraftMetadataUploadAsync: { __typename: 'ArweavePerUserBudgetExceededError', message: string } | { __typename: 'MutationTieredDraftMetadataUploadAsyncSuccess', data: { tieredDraftMetadataUploadAsyncRequestId: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationError', message: string } };

export type TieredDraftMetadataStatusQueryVariables = Exact<{
  tieredDraftMetadataUploadAsyncRequestId: Scalars['String'];
}>;


export type TieredDraftMetadataStatusQuery = { tieredDraftMetadataUploadAsyncStatus: { __typename: 'NotFoundError', message: string } | { __typename: 'QueryTieredDraftMetadataUploadAsyncStatusSuccess', data: { __typename: 'TieredDraftMetadataUploadAsyncStatusPending' } | { __typename: 'TieredDraftMetadataUploadAsyncStatusSuccess', uploadResult: { storefrontArweaveHash: string, tiers: Array<{ arweaveHash: string, tierNumber: number }> } } } | { __typename: 'ValidationError', message: string } };

export type TieredDraftPrepareUploadMutationVariables = Exact<{
  input: MutationPrepareMintTieredDraftAsyncInput;
}>;


export type TieredDraftPrepareUploadMutation = { prepareMintTieredDraftAsync: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'MutationPrepareMintTieredDraftAsyncSuccess', data: { prepareMintTieredDraftAsyncRequestId: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type TieredDraftPrepareStatusQueryVariables = Exact<{
  prepareMintTieredDraftAsyncRequestId: Scalars['String'];
}>;


export type TieredDraftPrepareStatusQuery = { prepareMintTieredDraftAsyncStatus: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'EmptyMerkleTreeError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'QueryPrepareMintTieredDraftAsyncStatusSuccess', data: { __typename: 'PrepareMintTieredDraftAsyncStatusPending' } | { __typename: 'PrepareMintTieredDraftAsyncStatusSuccess', merkleTreeRoot: string | null } } | { __typename: 'ValidationError', message: string } };

export type SponsoredUploadMutationVariables = Exact<{
  chain: L2ChainType;
  data: Scalars['String'];
  editionAddress: Scalars['Address'];
  soundCreatorAddress: Scalars['Address'];
}>;


export type SponsoredUploadMutation = { sponsoredUpload: { __typename: 'ForbiddenError', message: string } | { __typename: 'GelatoAPIError', message: string } | { __typename: 'MutationSponsoredUploadSuccess', data: { gelatoTaskId: string } } | { __typename: 'RateLimitError', message: string } };

export type IsFollowingQueryVariables = Exact<{
  input: IsFollowingInput;
}>;


export type IsFollowingQuery = { isFollowing: boolean };

export type SubscribeToArtistMutationVariables = Exact<{
  input: SubscribeArtistActivityNotificationInput;
}>;


export type SubscribeToArtistMutation = { subscribeArtistActivityNotification: { __typename: 'CustomerIoAPICallError', message: string } | { __typename: 'MutationSubscribeArtistActivityNotificationSuccess', data: { id: string, artist: { id: string, name: string } } } };

export type UnsubscribeToArtistMutationVariables = Exact<{
  input: UnsubscribeArtistActivityNotificationInput;
}>;


export type UnsubscribeToArtistMutation = { unsubscribeArtistActivityNotification: { __typename: 'CustomerIoAPICallError', message: string } | { __typename: 'MutationUnsubscribeArtistActivityNotificationSuccess', data: number } };

export type TopResultsQueryVariables = Exact<{
  input: SearchInput;
  pagination?: InputMaybe<SearchConnectionArgs>;
}>;


export type TopResultsQuery = { search: { id: string, releasesPaginated: { edges: Array<{ node: (
          { __typename: 'Release', id: string, type: ReleaseType, track: { id: string } }
          & { ' $fragmentRefs'?: { 'SearchResultReleaseFragment': SearchResultReleaseFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } }, artistsPaginated: { edges: Array<{ node: (
          { __typename: 'Artist', id: string }
          & { ' $fragmentRefs'?: { 'SearchResultArtistFragment': SearchResultArtistFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } }, collectors: { edges: Array<{ node: (
          { __typename: 'User', id: string }
          & { ' $fragmentRefs'?: { 'SearchResultCollectorFragment': SearchResultCollectorFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } }, shelves: { edges: Array<{ node: (
          { __typename: 'Shelf', id: string, releaseCount: number }
          & { ' $fragmentRefs'?: { 'PlaylistCardDetailsFragment': PlaylistCardDetailsFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } } } };

export type InitialSearchResultsQueryVariables = Exact<{
  releaseFilter?: InputMaybe<ReleasesCursorFilterArgs>;
  artistFilter?: InputMaybe<ArtistCursorFilterArgs>;
  playlistFilter?: InputMaybe<AllShelvesFilter>;
  collectorFilter?: InputMaybe<AllCollectorsFilter>;
}>;


export type InitialSearchResultsQuery = { releases: { edges: Array<{ node: (
        { __typename: 'Release', id: string, track: { id: string } }
        & { ' $fragmentRefs'?: { 'SearchResultReleaseFragment': SearchResultReleaseFragment } }
      ) }> }, artists: { edges: Array<{ node: (
        { __typename: 'Artist', id: string }
        & { ' $fragmentRefs'?: { 'SearchResultArtistFragment': SearchResultArtistFragment } }
      ) }> }, allCollectors: { edges: Array<{ node: (
        { __typename: 'User', id: string }
        & { ' $fragmentRefs'?: { 'SearchResultCollectorFragment': SearchResultCollectorFragment } }
      ) }> }, allShelves: { edges: Array<{ node: (
        { __typename: 'Shelf', id: string, releaseCount: number }
        & { ' $fragmentRefs'?: { 'PlaylistCardDetailsFragment': PlaylistCardDetailsFragment } }
      ) }> } };

export type SearchQueryVariables = Exact<{
  input: SearchInput;
  pagination?: InputMaybe<SearchConnectionArgs>;
  hasReleases: Scalars['Boolean'];
  hasArtists: Scalars['Boolean'];
  hasCollectors: Scalars['Boolean'];
  hasPlaylists: Scalars['Boolean'];
  releaseFilter?: InputMaybe<ReleaseSearchFilter>;
  artistFilter?: InputMaybe<ArtistSearchFilter>;
  playlistFilter?: InputMaybe<ShelfSearchFilter>;
  collectorFilter?: InputMaybe<CollectorSearchFilter>;
  releaseSort?: InputMaybe<Array<ReleaseSortInput> | ReleaseSortInput>;
  artistSort?: InputMaybe<Array<ArtistSortInput> | ArtistSortInput>;
  collectorSort?: InputMaybe<Array<CollectorSortInput> | CollectorSortInput>;
  playlistSort?: InputMaybe<Array<ShelfSortInput> | ShelfSortInput>;
}>;


export type SearchQuery = { search: { id: string, releasesPaginated?: { edges: Array<{ node: (
          { __typename: 'Release', id: string, type: ReleaseType, track: { id: string } }
          & { ' $fragmentRefs'?: { 'SearchResultReleaseFragment': SearchResultReleaseFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } }, artistsPaginated?: { edges: Array<{ node: (
          { __typename: 'Artist', id: string }
          & { ' $fragmentRefs'?: { 'SearchResultArtistFragment': SearchResultArtistFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } }, collectors?: { edges: Array<{ node: (
          { __typename: 'User', id: string }
          & { ' $fragmentRefs'?: { 'SearchResultCollectorFragment': SearchResultCollectorFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } }, shelves?: { edges: Array<{ node: (
          { __typename: 'Shelf', id: string, releaseCount: number }
          & { ' $fragmentRefs'?: { 'PlaylistCardDetailsFragment': PlaylistCardDetailsFragment } }
        ) }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } } } };

export type FeedActivityHeaderChannelInfoFragment = { id: string, name: string, webappUri: string, staticProfileImage: { id: string, url: string } | null, profileImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'FeedActivityHeaderChannelInfoFragment' };

export type FeedActivityItemUserInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
) & { ' $fragmentName'?: 'FeedActivityItemUserInfoFragment' };

export type FeedReleaseCardFragment = (
  { id: string, title: string, mintStartTimestamp: number, webappUri: string, type: ReleaseType, listeningParty: number | null, artist: { id: string, name: string, webappUri: string, userId: string }, track: { id: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, animatedCoverImage: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'SongCardDropdownInfoFragment': SongCardDropdownInfoFragment } }
) & { ' $fragmentName'?: 'FeedReleaseCardFragment' };

export type ArtistDropReleaseFragment = (
  { id: string, artist: { id: string, user: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) } }
  & { ' $fragmentRefs'?: { 'FeedReleaseCardFragment': FeedReleaseCardFragment } }
) & { ' $fragmentName'?: 'ArtistDropReleaseFragment' };

type PostGroupItem_ActivityFeedGroupBackingPost_Fragment = { __typename: 'ActivityFeedGroupBackingPost', id: string } & { ' $fragmentName'?: 'PostGroupItem_ActivityFeedGroupBackingPost_Fragment' };

type PostGroupItem_ArtistDropPost_Fragment = { __typename: 'ArtistDropPost', id: string } & { ' $fragmentName'?: 'PostGroupItem_ArtistDropPost_Fragment' };

type PostGroupItem_PlaylistPost_Fragment = (
  { __typename: 'PlaylistPost', id: string, channel: { ' $fragmentRefs'?: { 'FeedActivityHeaderChannelInfoFragment': FeedActivityHeaderChannelInfoFragment } } | null }
  & { ' $fragmentRefs'?: { 'FeedPlaylistPostFragment': FeedPlaylistPostFragment } }
) & { ' $fragmentName'?: 'PostGroupItem_PlaylistPost_Fragment' };

type PostGroupItem_ReleasePost_Fragment = (
  { __typename: 'ReleasePost', id: string, channel: { ' $fragmentRefs'?: { 'FeedActivityHeaderChannelInfoFragment': FeedActivityHeaderChannelInfoFragment } } | null }
  & { ' $fragmentRefs'?: { 'FeedReleasePostFragment': FeedReleasePostFragment } }
) & { ' $fragmentName'?: 'PostGroupItem_ReleasePost_Fragment' };

type PostGroupItem_Repost_Fragment = { __typename: 'Repost', id: string } & { ' $fragmentName'?: 'PostGroupItem_Repost_Fragment' };

export type PostGroupItemFragment = PostGroupItem_ActivityFeedGroupBackingPost_Fragment | PostGroupItem_ArtistDropPost_Fragment | PostGroupItem_PlaylistPost_Fragment | PostGroupItem_ReleasePost_Fragment | PostGroupItem_Repost_Fragment;

export type PostItemRepostSourceFragment = (
  { id: string, creator: { id: string, publicAddress: string } }
  & { ' $fragmentRefs'?: { 'ActionButtonsRepostSourceFragment': ActionButtonsRepostSourceFragment } }
) & { ' $fragmentName'?: 'PostItemRepostSourceFragment' };

export type FeedActivityTypePostFragment = { post: (
    { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_ActivityFeedGroupBackingPost_Fragment': PostGroupItem_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { __typename: 'ArtistDropPost', id: string, webappUri: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_ArtistDropPost_Fragment': PostGroupItem_ArtistDropPost_Fragment } }
  ) | (
    { __typename: 'PlaylistPost', id: string, webappUri: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_PlaylistPost_Fragment': PostGroupItem_PlaylistPost_Fragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, webappUri: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_ReleasePost_Fragment': PostGroupItem_ReleasePost_Fragment } }
  ) | (
    { __typename: 'Repost', id: string, webappUri: string, commentCount: number, creator: (
      { id: string, username: string, webappUri: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ), originalPost: (
      { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
        { id: string }
        & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
      ) }
      & { ' $fragmentRefs'?: { 'OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment': OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment } }
    ) | (
      { __typename: 'ArtistDropPost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
        { id: string }
        & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
      ) }
      & { ' $fragmentRefs'?: { 'OriginalPostInfo_ArtistDropPost_Fragment': OriginalPostInfo_ArtistDropPost_Fragment } }
    ) | (
      { __typename: 'PlaylistPost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
        { id: string }
        & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
      ) }
      & { ' $fragmentRefs'?: { 'OriginalPostInfo_PlaylistPost_Fragment': OriginalPostInfo_PlaylistPost_Fragment } }
    ) | (
      { __typename: 'ReleasePost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
        { id: string }
        & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
      ) }
      & { ' $fragmentRefs'?: { 'OriginalPostInfo_ReleasePost_Fragment': OriginalPostInfo_ReleasePost_Fragment } }
    ) | (
      { __typename: 'Repost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
        { id: string }
        & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
      ) }
      & { ' $fragmentRefs'?: { 'PostItemRepostSourceFragment': PostItemRepostSourceFragment;'OriginalPostInfo_Repost_Fragment': OriginalPostInfo_Repost_Fragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'RepostSourceFragment': RepostSourceFragment;'OriginalPostInfo_Repost_Fragment': OriginalPostInfo_Repost_Fragment;'PostGroupItem_Repost_Fragment': PostGroupItem_Repost_Fragment } }
  ) | null } & { ' $fragmentName'?: 'FeedActivityTypePostFragment' };

export type UsersActivityDetailFragment = { numCollectors: number, featuredCollectors: Array<{ user: (
      { id: string, publicAddress: string, username: string, webappUri: string, artist: { id: string } | null, avatar: { id: string, url: string } | null }
      & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
    ) }> } & { ' $fragmentName'?: 'UsersActivityDetailFragment' };

export type ReleaseCollectedByManyActivityFragment = (
  { collectedRelease: { release: (
      { id: string, socialProofCollectors: Array<(
        { id: string }
        & { ' $fragmentRefs'?: { 'PurchaseCardCollectedByUserFragment': PurchaseCardCollectedByUserFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'PurchaseCardFragment': PurchaseCardFragment } }
    ) } }
  & { ' $fragmentRefs'?: { 'UsersActivityDetailFragment': UsersActivityDetailFragment } }
) & { ' $fragmentName'?: 'ReleaseCollectedByManyActivityFragment' };

export type RepostSourceFragment = (
  { id: string, creator: { id: string, username: string, webappUri: string } }
  & { ' $fragmentRefs'?: { 'PostItemRepostSourceFragment': PostItemRepostSourceFragment } }
) & { ' $fragmentName'?: 'RepostSourceFragment' };

type OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment = (
  { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PostGroupItem_ActivityFeedGroupBackingPost_Fragment': PostGroupItem_ActivityFeedGroupBackingPost_Fragment } }
) & { ' $fragmentName'?: 'OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment' };

type OriginalPostInfo_ArtistDropPost_Fragment = (
  { __typename: 'ArtistDropPost', id: string, webappUri: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PostGroupItem_ArtistDropPost_Fragment': PostGroupItem_ArtistDropPost_Fragment } }
) & { ' $fragmentName'?: 'OriginalPostInfo_ArtistDropPost_Fragment' };

type OriginalPostInfo_PlaylistPost_Fragment = (
  { __typename: 'PlaylistPost', id: string, webappUri: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PostGroupItem_PlaylistPost_Fragment': PostGroupItem_PlaylistPost_Fragment } }
) & { ' $fragmentName'?: 'OriginalPostInfo_PlaylistPost_Fragment' };

type OriginalPostInfo_ReleasePost_Fragment = (
  { __typename: 'ReleasePost', id: string, webappUri: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PostGroupItem_ReleasePost_Fragment': PostGroupItem_ReleasePost_Fragment } }
) & { ' $fragmentName'?: 'OriginalPostInfo_ReleasePost_Fragment' };

type OriginalPostInfo_Repost_Fragment = (
  { __typename: 'Repost', id: string, webappUri: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PostGroupItem_Repost_Fragment': PostGroupItem_Repost_Fragment } }
) & { ' $fragmentName'?: 'OriginalPostInfo_Repost_Fragment' };

export type OriginalPostInfoFragment = OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment | OriginalPostInfo_ArtistDropPost_Fragment | OriginalPostInfo_PlaylistPost_Fragment | OriginalPostInfo_ReleasePost_Fragment | OriginalPostInfo_Repost_Fragment;

export type UserCollectedManySongsActivityFragment = { numReleases: number, collectionTypes: Array<CollectionMarketType>, collectedReleases: Array<(
    { release: (
      { id: string, socialProofCollectors: Array<{ ' $fragmentRefs'?: { 'PurchaseCardCollectedByUserFragment': PurchaseCardCollectedByUserFragment } }> }
      & { ' $fragmentRefs'?: { 'PurchaseCardFragment': PurchaseCardFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'NftSaleInfoFragment': NftSaleInfoFragment } }
  )>, user: { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } } } & { ' $fragmentName'?: 'UserCollectedManySongsActivityFragment' };

export type BondingCurveSaleListFragment = { id: string, amountPaidInWei: string, fromTokenId: number, fromSerialNumber: number | null, tierNumber: number | null, toTokenId: number, toSerialNumber: number | null, quantity: number, date: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), release: (
    { id: string, goldenEggNft: { id: string, tokenId: string } | null }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ) } & { ' $fragmentName'?: 'BondingCurveSaleListFragment' };

export type PlaylistCreatedListFragment = { id: string, date: string, playlist: { id: string, name: string, webappUri: string } | null, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'PlaylistCreatedListFragment' };

export type PlaylistLikedListFragment = { id: string, date: string, playlist: { id: string, name: string, webappUri: string } | null, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'PlaylistLikedListFragment' };

export type ReleasesAddedRemovedListFragment = { id: string, date: string, numAddedReleases: number, numRemovedReleases: number, user: (
    { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), playlist: (
    { id: string }
    & { ' $fragmentRefs'?: { 'PlaylistActivityInfoFragment': PlaylistActivityInfoFragment } }
  ) | null, addedReleases: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
      ) }> } } & { ' $fragmentName'?: 'ReleasesAddedRemovedListFragment' };

export type ListPlaylistCreatedPostFragment = { id: string, optionalShelf: { id: string, name: string, webappUri: string } | null } & { ' $fragmentName'?: 'ListPlaylistCreatedPostFragment' };

export type ListReleaseCreatedPostFragment = { id: string, optionalRelease: (
    { title: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ) | null } & { ' $fragmentName'?: 'ListReleaseCreatedPostFragment' };

export type PostRepostedInfoFragment = { id: string, date: string, repost: { __typename: 'ActivityFeedGroupBackingPost', id: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'ArtistDropPost', id: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'PlaylistPost', id: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'ReleasePost', id: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'Repost', id: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | null, originalPost: { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, lexicalContent: unknown | null, content: string, creator: { id: string, username: string, webappUri: string, artist: { id: string } | null } } | { __typename: 'ArtistDropPost', id: string, webappUri: string, lexicalContent: unknown | null, content: string, creator: { id: string, username: string, webappUri: string, artist: { id: string } | null } } | (
    { __typename: 'PlaylistPost', id: string, webappUri: string, lexicalContent: unknown | null, content: string, creator: { id: string, username: string, webappUri: string, artist: { id: string } | null } }
    & { ' $fragmentRefs'?: { 'ListPlaylistCreatedPostFragment': ListPlaylistCreatedPostFragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, webappUri: string, lexicalContent: unknown | null, content: string, creator: { id: string, username: string, webappUri: string, artist: { id: string } | null } }
    & { ' $fragmentRefs'?: { 'ListReleaseCreatedPostFragment': ListReleaseCreatedPostFragment } }
  ) | { __typename: 'Repost', id: string, webappUri: string, lexicalContent: unknown | null, content: string, creator: { id: string, username: string, webappUri: string, artist: { id: string } | null } } | null } & { ' $fragmentName'?: 'PostRepostedInfoFragment' };

export type UserInfoCreatedPostFragment = { id: string, post: { __typename: 'ActivityFeedGroupBackingPost', webappUri: string, createdAt: string, id: string, creator: { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'ArtistDropPost', webappUri: string, createdAt: string, id: string, creator: { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'PlaylistPost', webappUri: string, createdAt: string, id: string, creator: { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'ReleasePost', webappUri: string, createdAt: string, id: string, creator: { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { __typename: 'Repost', webappUri: string, createdAt: string, id: string, creator: { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } } & { ' $fragmentName'?: 'UserInfoCreatedPostFragment' };

export type ProfileCreatedPostFragment = (
  { id: string, post: { __typename: 'ActivityFeedGroupBackingPost', id: string } | { __typename: 'ArtistDropPost', id: string } | (
    { __typename: 'PlaylistPost', id: string }
    & { ' $fragmentRefs'?: { 'ListPlaylistCreatedPostFragment': ListPlaylistCreatedPostFragment } }
  ) | (
    { __typename: 'ReleasePost', id: string }
    & { ' $fragmentRefs'?: { 'ListReleaseCreatedPostFragment': ListReleaseCreatedPostFragment } }
  ) | { __typename: 'Repost', id: string } }
  & { ' $fragmentRefs'?: { 'UserInfoCreatedPostFragment': UserInfoCreatedPostFragment } }
) & { ' $fragmentName'?: 'ProfileCreatedPostFragment' };

export type CreatedPlaylistPostListFragment = { id: string, date: string, post: { id: string, webappUri: string } | { id: string, webappUri: string } | { id: string, webappUri: string } | { id: string, webappUri: string } | { id: string, webappUri: string }, user: { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } & { ' $fragmentName'?: 'CreatedPlaylistPostListFragment' };

export type ReleaseCreatedPostFragment = { id: string, post: { id: string, content: string, createdAt: string, webappUri: string, creator: { publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { id: string, content: string, createdAt: string, webappUri: string, creator: { publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { id: string, content: string, createdAt: string, webappUri: string, creator: { publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { id: string, content: string, createdAt: string, webappUri: string, creator: { publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } | { id: string, content: string, createdAt: string, webappUri: string, creator: { publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } } & { ' $fragmentName'?: 'ReleaseCreatedPostFragment' };

export type PrimarySaleListFragment = { id: string, amountPaidInWei: string, fromTokenId: number, fromSerialNumber: number | null, tierNumber: number | null, toTokenId: number, toSerialNumber: number | null, quantity: number, date: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), release: (
    { id: string, goldenEggNft: { id: string, tokenId: string } | null }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ) } & { ' $fragmentName'?: 'PrimarySaleListFragment' };

export type ReleaseDroppedListFragment = { id: string, date: string, release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ), user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseDroppedListFragment' };

export type ReleaseFeedBondingCurveSaleFragment = { id: string, amountPaidInWei: string, fromTokenId: number, fromSerialNumber: number | null, tierNumber: number | null, toTokenId: number, toSerialNumber: number | null, quantity: number, date: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), release: { id: string, goldenEggNft: { id: string, tokenId: string } | null } } & { ' $fragmentName'?: 'ReleaseFeedBondingCurveSaleFragment' };

export type ReleaseFeedBondingCurveSoldFragment = { id: string, paymentInWei: string, quantity: number, firstTokenId: number, date: string, user: (
    { id: string, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseFeedBondingCurveSoldFragment' };

export type ReleaseFeedPrimarySaleFragment = { id: string, amountPaidInWei: string, quantity: number, fromTokenId: number, fromSerialNumber: number | null, tierNumber: number | null, date: string, toTokenId: number, toSerialNumber: number | null, user: (
    { id: string, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), release: { id: string, goldenEggNft: { id: string, tokenId: string } | null } } & { ' $fragmentName'?: 'ReleaseFeedPrimarySaleFragment' };

export type ReleaseFeedReleaseDroppedFragment = { id: string, date: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseFeedReleaseDroppedFragment' };

export type ReleaseFeedReleaseLikedFragment = { id: string, date: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseFeedReleaseLikedFragment' };

export type ReleaseFeedReleasePresavedFragment = { id: string, date: string, user: (
    { id: string, webappUri: string, publicAddress: string, username: string, artist: { id: string } | null, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseFeedReleasePresavedFragment' };

export type ReleaseFeedReleasesAddedFragment = { id: string, date: string, numAddedReleases: number, playlist: (
    { id: string }
    & { ' $fragmentRefs'?: { 'PlaylistActivityInfoFragment': PlaylistActivityInfoFragment } }
  ) | null, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseFeedReleasesAddedFragment' };

export type ReleaseFeedSecondarySaleFragment = { id: string, amountPaidInWei: string, fromTokenId: number, fromSerialNumber: number | null, tierNumber: number | null, toTokenId: number, toSerialNumber: number | null, quantity: number, date: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), purchasedFromUser: (
    { id: string, publicAddress: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), release: { id: string, goldenEggNft: { id: string, tokenId: string } | null } } & { ' $fragmentName'?: 'ReleaseFeedSecondarySaleFragment' };

export type ReleaseLikedListFragment = { id: string, date: string, release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ), user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseLikedListFragment' };

export type ReleaseUnlikedListFragment = { id: string, date: string, release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ), user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ReleaseUnlikedListFragment' };

export type ReleasesAddedListFragment = { id: string, date: string, numAddedReleases: number, playlist: (
    { id: string }
    & { ' $fragmentRefs'?: { 'PlaylistActivityInfoFragment': PlaylistActivityInfoFragment } }
  ) | null, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), addedReleases: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
      ) }> } } & { ' $fragmentName'?: 'ReleasesAddedListFragment' };

export type ReleasesRemovedListFragment = { id: string, date: string, numRemovedReleases: number, playlist: (
    { id: string }
    & { ' $fragmentRefs'?: { 'PlaylistActivityInfoFragment': PlaylistActivityInfoFragment } }
  ) | null, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), removedReleases: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
      ) }> } } & { ' $fragmentName'?: 'ReleasesRemovedListFragment' };

export type SecondarySaleListFragment = { id: string, amountPaidInWei: string, fromTokenId: number, fromSerialNumber: number | null, tierNumber: number | null, toTokenId: number, toSerialNumber: number | null, quantity: number, date: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), purchasedFromUser: (
    { id: string, publicAddress: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), release: (
    { id: string, goldenEggNft: { id: string, tokenId: string } | null }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ) } & { ' $fragmentName'?: 'SecondarySaleListFragment' };

export type BondingCurveSoldListFragment = { id: string, paymentInWei: string, quantity: number, firstTokenId: number, date: string, user: (
    { id: string, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ), release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleasePillFragment': ReleasePillFragment } }
  ) } & { ' $fragmentName'?: 'BondingCurveSoldListFragment' };

export type ReleasePillFragment = (
  { id: string, title: string, webappUri: string, track: { id: string }, coverImage: { id: string, url: string }, artist: { id: string, name: string, webappUri: string } }
  & { ' $fragmentRefs'?: { 'ReleasePlayButtonFragment': ReleasePlayButtonFragment } }
) & { ' $fragmentName'?: 'ReleasePillFragment' };

export type VoteOnPostMutationVariables = Exact<{
  input: SetVoteOnPostInput;
}>;


export type VoteOnPostMutation = { voteOnPostRL: { __typename: 'MutationVoteOnPostRLSuccess' } | { __typename: 'NotFoundError' } | { __typename: 'RateLimitError', message: string } | null };

export type RepostMutationVariables = Exact<{
  input: MutationRepostInput;
}>;


export type RepostMutation = { repost: { __typename: 'MutationRepostSuccess', data: { __typename: 'Repost', id: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type UndoRepostMutationVariables = Exact<{
  postId: Scalars['UUID'];
}>;


export type UndoRepostMutation = { undoRepost: { __typename: 'ActivityFeedGroupBackingPost', id: string } | { __typename: 'ArtistDropPost', id: string } | { __typename: 'PlaylistPost', id: string } | { __typename: 'ReleasePost', id: string } | { __typename: 'Repost', id: string } | null };

export type ActionButtonsRepostSourceFragment = { id: string, creator: { id: string, publicAddress: string } } & { ' $fragmentName'?: 'ActionButtonsRepostSourceFragment' };

type FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment = (
  { __typename: 'ActivityFeedGroupBackingPost', id: string, commentCount: number, upvoteCount: number, repostCount: number, webappUri: string }
  & { ' $fragmentRefs'?: { 'SharePostInfo_ActivityFeedGroupBackingPost_Fragment': SharePostInfo_ActivityFeedGroupBackingPost_Fragment;'FeedPostCommentModal_ActivityFeedGroupBackingPost_Fragment': FeedPostCommentModal_ActivityFeedGroupBackingPost_Fragment } }
) & { ' $fragmentName'?: 'FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment' };

type FeedPostActionsInfo_ArtistDropPost_Fragment = (
  { __typename: 'ArtistDropPost', id: string, commentCount: number, upvoteCount: number, repostCount: number, webappUri: string }
  & { ' $fragmentRefs'?: { 'SharePostInfo_ArtistDropPost_Fragment': SharePostInfo_ArtistDropPost_Fragment;'FeedPostCommentModal_ArtistDropPost_Fragment': FeedPostCommentModal_ArtistDropPost_Fragment } }
) & { ' $fragmentName'?: 'FeedPostActionsInfo_ArtistDropPost_Fragment' };

type FeedPostActionsInfo_PlaylistPost_Fragment = (
  { __typename: 'PlaylistPost', id: string, commentCount: number, upvoteCount: number, repostCount: number, webappUri: string }
  & { ' $fragmentRefs'?: { 'SharePostInfo_PlaylistPost_Fragment': SharePostInfo_PlaylistPost_Fragment;'FeedPostCommentModal_PlaylistPost_Fragment': FeedPostCommentModal_PlaylistPost_Fragment } }
) & { ' $fragmentName'?: 'FeedPostActionsInfo_PlaylistPost_Fragment' };

type FeedPostActionsInfo_ReleasePost_Fragment = (
  { __typename: 'ReleasePost', id: string, commentCount: number, upvoteCount: number, repostCount: number, webappUri: string }
  & { ' $fragmentRefs'?: { 'SharePostInfo_ReleasePost_Fragment': SharePostInfo_ReleasePost_Fragment;'FeedPostCommentModal_ReleasePost_Fragment': FeedPostCommentModal_ReleasePost_Fragment } }
) & { ' $fragmentName'?: 'FeedPostActionsInfo_ReleasePost_Fragment' };

type FeedPostActionsInfo_Repost_Fragment = (
  { __typename: 'Repost', id: string, commentCount: number, upvoteCount: number, repostCount: number, webappUri: string }
  & { ' $fragmentRefs'?: { 'SharePostInfo_Repost_Fragment': SharePostInfo_Repost_Fragment;'FeedPostCommentModal_Repost_Fragment': FeedPostCommentModal_Repost_Fragment } }
) & { ' $fragmentName'?: 'FeedPostActionsInfo_Repost_Fragment' };

export type FeedPostActionsInfoFragment = FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment | FeedPostActionsInfo_ArtistDropPost_Fragment | FeedPostActionsInfo_PlaylistPost_Fragment | FeedPostActionsInfo_ReleasePost_Fragment | FeedPostActionsInfo_Repost_Fragment;

export type FeedActivityFeedGroupBackingPostFragment = (
  { id: string, commentCount: number, upvoteCount: number, webappUri: string, content: string, creator: (
    { id: string, username: string, publicAddress: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
  ), activityFeedGroup: { __typename: 'ActivityFeedGroup', id: string, latestActivityOccurenceAt: number, information: { __typename: 'ReleaseDroppedAggregate', release: (
        { id: string }
        & { ' $fragmentRefs'?: { 'ArtistDropReleaseFragment': ArtistDropReleaseFragment } }
      ) } | { __typename: 'ReleasesAddedToShelfAggregate' } | { __typename: 'ShelfCreatedAggregate' } | { __typename: 'SongCollectedByManyAggregate' } | { __typename: 'UserCollectedManySongsAggregate', numReleases: number, collectionTypes: Array<CollectionMarketType>, collectedReleases: Array<(
        { release: (
          { id: string, socialProofCollectors: Array<{ ' $fragmentRefs'?: { 'PurchaseCardCollectedByUserFragment': PurchaseCardCollectedByUserFragment } }> }
          & { ' $fragmentRefs'?: { 'PurchaseCardFragment': PurchaseCardFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'NftSaleInfoFragment': NftSaleInfoFragment } }
      )>, user: { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } } } | { __typename: 'UserCreatedPostAggregate' } | { __typename: 'UserLikedPlaylistAggregate' } | { __typename: 'UserLikedSongsAggregate' } } }
  & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment': FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment } }
) & { ' $fragmentName'?: 'FeedActivityFeedGroupBackingPostFragment' };

export type PostCommentMutationVariables = Exact<{
  input: CreatePostCommentInput;
}>;


export type PostCommentMutation = { addPostComment: { __typename: 'DidNotGoThroughError' } | { __typename: 'MutationAddPostCommentSuccess', data: { id: string, content: string } } | { __typename: 'NotFoundError' } | { __typename: 'RateLimitError' } | { __typename: 'ValidationError', message: string } };

export type PostCommentsRowFragment = { id: string, content: string, lexicalContent: unknown | null, createdAt: string, upvoteCount: number, repliesCount: number, labels: Array<PostCommentLabel>, currentHolderOfRelease: boolean, author: (
    { id: string }
    & { ' $fragmentRefs'?: { 'CommentAuthorFragment': CommentAuthorFragment } }
  ), post: { __typename: 'ActivityFeedGroupBackingPost', id: string, channel: { id: string } | null } | { __typename: 'ArtistDropPost', id: string, channel: { id: string } | null } | { __typename: 'PlaylistPost', id: string, channel: { id: string } | null } | { __typename: 'ReleasePost', id: string, channel: { id: string } | null } | { __typename: 'Repost', id: string, channel: { id: string } | null } } & { ' $fragmentName'?: 'PostCommentsRowFragment' };

export type PostCommentsQueryVariables = Exact<{
  postId: Scalars['UUID'];
  pagination?: InputMaybe<PostCommentCursorConnectionArgs>;
}>;


export type PostCommentsQuery = { post: { id: string, comments: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PostCommentsRowFragment': PostCommentsRowFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | { id: string, comments: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PostCommentsRowFragment': PostCommentsRowFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | { id: string, comments: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PostCommentsRowFragment': PostCommentsRowFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | { id: string, comments: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PostCommentsRowFragment': PostCommentsRowFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | { id: string, comments: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PostCommentsRowFragment': PostCommentsRowFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type DeletePostCommentMutationVariables = Exact<{
  postCommentId: Scalars['UUID'];
}>;


export type DeletePostCommentMutation = { deletePostComment: { __typename: 'MutationDeletePostCommentSuccess' } | { __typename: 'NotFoundError' } | { __typename: 'ValidationError', message: string } };

export type AdminDeleteNftCommentMutationVariables = Exact<{
  nftCommentId: Scalars['UUID'];
}>;


export type AdminDeleteNftCommentMutation = { adminDeleteNftComment: { __typename: 'MutationAdminDeleteNftCommentSuccess' } | { __typename: 'NotFoundError' } | { __typename: 'ValidationError' } };

type FeedCountSummary_ActivityFeedGroupBackingPost_Fragment = { __typename: 'ActivityFeedGroupBackingPost', id: string, repostCount: number, commentCount: number, upvoteCount: number } & { ' $fragmentName'?: 'FeedCountSummary_ActivityFeedGroupBackingPost_Fragment' };

type FeedCountSummary_ArtistDropPost_Fragment = { __typename: 'ArtistDropPost', id: string, repostCount: number, commentCount: number, upvoteCount: number } & { ' $fragmentName'?: 'FeedCountSummary_ArtistDropPost_Fragment' };

type FeedCountSummary_PlaylistPost_Fragment = { __typename: 'PlaylistPost', id: string, repostCount: number, commentCount: number, upvoteCount: number } & { ' $fragmentName'?: 'FeedCountSummary_PlaylistPost_Fragment' };

type FeedCountSummary_ReleasePost_Fragment = { __typename: 'ReleasePost', id: string, repostCount: number, commentCount: number, upvoteCount: number } & { ' $fragmentName'?: 'FeedCountSummary_ReleasePost_Fragment' };

type FeedCountSummary_Repost_Fragment = { __typename: 'Repost', id: string, repostCount: number, commentCount: number, upvoteCount: number } & { ' $fragmentName'?: 'FeedCountSummary_Repost_Fragment' };

export type FeedCountSummaryFragment = FeedCountSummary_ActivityFeedGroupBackingPost_Fragment | FeedCountSummary_ArtistDropPost_Fragment | FeedCountSummary_PlaylistPost_Fragment | FeedCountSummary_ReleasePost_Fragment | FeedCountSummary_Repost_Fragment;

export type FeedPlaylistPostFragment = (
  { id: string, createdAt: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: (
    { id: string, username: string, publicAddress: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
  ), optionalShelf: (
    { id: string, user: { id: string, twitterHandle: string | null } }
    & { ' $fragmentRefs'?: { 'PlaylistPreviewFragment': PlaylistPreviewFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_PlaylistPost_Fragment': FeedPostActionsInfo_PlaylistPost_Fragment;'FeedCountSummary_PlaylistPost_Fragment': FeedCountSummary_PlaylistPost_Fragment } }
) & { ' $fragmentName'?: 'FeedPlaylistPostFragment' };

export type FeedReleasePostFragment = (
  { id: string, createdAt: string, commentCount: number, webappUri: string, content: string, lexicalContent: unknown | null, creator: (
    { id: string, username: string, publicAddress: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
  ), optionalRelease: (
    { id: string, artist: { id: string, user: { id: string, twitterHandle: string | null } } }
    & { ' $fragmentRefs'?: { 'SoundBarReleaseFragment': SoundBarReleaseFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ReleasePost_Fragment': FeedPostActionsInfo_ReleasePost_Fragment;'FeedCountSummary_ReleasePost_Fragment': FeedCountSummary_ReleasePost_Fragment } }
) & { ' $fragmentName'?: 'FeedReleasePostFragment' };

type SharePostInfo_ActivityFeedGroupBackingPost_Fragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'SharePostInfo_ActivityFeedGroupBackingPost_Fragment' };

type SharePostInfo_ArtistDropPost_Fragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'SharePostInfo_ArtistDropPost_Fragment' };

type SharePostInfo_PlaylistPost_Fragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'SharePostInfo_PlaylistPost_Fragment' };

type SharePostInfo_ReleasePost_Fragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'SharePostInfo_ReleasePost_Fragment' };

type SharePostInfo_Repost_Fragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'SharePostInfo_Repost_Fragment' };

export type SharePostInfoFragment = SharePostInfo_ActivityFeedGroupBackingPost_Fragment | SharePostInfo_ArtistDropPost_Fragment | SharePostInfo_PlaylistPost_Fragment | SharePostInfo_ReleasePost_Fragment | SharePostInfo_Repost_Fragment;

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['UUID'];
}>;


export type DeletePostMutation = { deletePost: { __typename: 'MutationDeletePostSuccess' } | { __typename: 'NotAuthorizedError' } | { __typename: 'NotFoundError' } };

export type UserPostStatusQueryVariables = Exact<{
  input: QueryUserPostStatusInput;
}>;


export type UserPostStatusQuery = { userPostStatus: Array<{ postId: string, voteStatus: CurrentUserPostVoteStatus, upvoteCount: number, repostCount: number, repostStatus: CurrentUserPostRepostStatusType }> };

export type UserActivityDetailFragment = { id: string, publicAddress: string, webappUri: string, username: string, artist: { id: string } | null, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'UserActivityDetailFragment' };

export type UserInfoForToolTipQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type UserInfoForToolTipQuery = { user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UserInfoToolTipFragment': UserInfoToolTipFragment } }
  ) | null };

export type UserInfoToolTipFragment = { id: string, publicAddress: string, webappUri: string, username: string, followerCount: number, followingCount: number, nftsOwned: number, artist: { id: string, numReleases: number, bannerImage: { id: string, url: string } | null } | null, avatar: { id: string, url: string } | null, creditAllocations: Array<{ id: string }>, bannerImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'UserInfoToolTipFragment' };

export type ActivityFeedHookQueryVariables = Exact<{
  pagination?: InputMaybe<CursorConnectionArgs>;
  activityFeedFilter?: InputMaybe<ActivityFeedFilterArgs>;
  activityFeedGroupFilter?: InputMaybe<ActivityFeedGroupFilterArgs>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type ActivityFeedHookQuery = { activityFeed: { id: string, activityFeedGroups: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, latestActivityOccurenceAt: number, rankingScore: number, information: { __typename: 'ReleaseDroppedAggregate', release: (
              { id: string }
              & { ' $fragmentRefs'?: { 'ArtistDropReleaseFragment': ArtistDropReleaseFragment } }
            ), post: (
              { id: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment': FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment } }
            ) | (
              { id: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ArtistDropPost_Fragment': FeedPostActionsInfo_ArtistDropPost_Fragment } }
            ) | (
              { id: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_PlaylistPost_Fragment': FeedPostActionsInfo_PlaylistPost_Fragment } }
            ) | (
              { id: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ReleasePost_Fragment': FeedPostActionsInfo_ReleasePost_Fragment } }
            ) | (
              { id: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_Repost_Fragment': FeedPostActionsInfo_Repost_Fragment } }
            ) | null } | { __typename: 'ReleasesAddedToShelfAggregate' } | { __typename: 'ShelfCreatedAggregate' } | (
            { __typename: 'SongCollectedByManyAggregate' }
            & { ' $fragmentRefs'?: { 'ReleaseCollectedByManyActivityFragment': ReleaseCollectedByManyActivityFragment } }
          ) | (
            { __typename: 'UserCollectedManySongsAggregate', post: (
              { id: string, webappUri: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment': FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment } }
            ) | (
              { id: string, webappUri: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ArtistDropPost_Fragment': FeedPostActionsInfo_ArtistDropPost_Fragment } }
            ) | (
              { id: string, webappUri: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_PlaylistPost_Fragment': FeedPostActionsInfo_PlaylistPost_Fragment } }
            ) | (
              { id: string, webappUri: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ReleasePost_Fragment': FeedPostActionsInfo_ReleasePost_Fragment } }
            ) | (
              { id: string, webappUri: string }
              & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_Repost_Fragment': FeedPostActionsInfo_Repost_Fragment } }
            ) | null }
            & { ' $fragmentRefs'?: { 'UserCollectedManySongsActivityFragment': UserCollectedManySongsActivityFragment } }
          ) | (
            { __typename: 'UserCreatedPostAggregate' }
            & { ' $fragmentRefs'?: { 'FeedActivityTypePostFragment': FeedActivityTypePostFragment } }
          ) | { __typename: 'UserLikedPlaylistAggregate' } | { __typename: 'UserLikedSongsAggregate' } } } | null> } } | null };

export type NewActivitiesSubscriptionVariables = Exact<{
  activityFeedId: Scalars['UUID'];
}>;


export type NewActivitiesSubscription = { activityFeedNewGroup: { activityFeedGroupInformationTypename: string } };

export type GroupedUsersInfoFragment = { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'GroupedUsersInfoFragment' };

export type TotalRaisedQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalRaisedQuery = { totalRaisedPlatform: { usd: number } };

export type UserDashboardInfoFragment = { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'UserDashboardInfoFragment' };

export type FreshlyMintedQueryVariables = Exact<{
  pagination?: InputMaybe<CursorConnectionArgs>;
}>;


export type FreshlyMintedQuery = { notableCollectorsActivityFeed: { id: string, groups: { edges: Array<{ node: { id: string, information: { __typename: 'ReleaseDroppedAggregate' } | { __typename: 'ReleasesAddedToShelfAggregate' } | { __typename: 'ShelfCreatedAggregate' } | { __typename: 'SongCollectedByManyAggregate', collectedRelease: { release: (
                { id: string, track: { id: string } }
                & { ' $fragmentRefs'?: { 'CollectorCardFragment': CollectorCardFragment } }
              ) }, featuredCollectors: Array<{ nftsCount: number, user: (
                { id: string }
                & { ' $fragmentRefs'?: { 'CollectorCardUserInfoFragment': CollectorCardUserInfoFragment } }
              ) }> } | { __typename: 'UserCollectedManySongsAggregate', user: (
              { id: string }
              & { ' $fragmentRefs'?: { 'CollectorCardUserInfoFragment': CollectorCardUserInfoFragment } }
            ), collectedReleases: Array<{ totalOwnedEditions: number, release: (
                { id: string, track: { id: string } }
                & { ' $fragmentRefs'?: { 'CollectorCardFragment': CollectorCardFragment } }
              ) }> } | { __typename: 'UserCreatedPostAggregate' } | { __typename: 'UserLikedPlaylistAggregate' } | { __typename: 'UserLikedSongsAggregate' } } } | null>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type LandingHeroPlayReleaseFragment = (
  { id: string, type: ReleaseType, title: string, webappUri: string, mintStartTimestamp: number, supplyCutoffTimestamp: number | null, finalQuantity: number | null, quantityLowerBound: number, quantityUpperBound: number, totalMinted: number, listeningParty: number | null, spotifyPresaveCampaign: boolean, track: { id: string }, listing: { id: string, tiers: Array<{ id: string, tierNumber: number, totalMinted: number }> } | null, artist: { id: string, user: (
      { id: string }
      & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
    ) } }
  & { ' $fragmentRefs'?: { 'CollectModalFragment': CollectModalFragment } }
) & { ' $fragmentName'?: 'LandingHeroPlayReleaseFragment' };

export type LandingHeroSlideFragment = (
  { id: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, animatedCoverImage: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'LandingHeroPlayReleaseFragment': LandingHeroPlayReleaseFragment;'LandingHeroTopCollectorsFragment': LandingHeroTopCollectorsFragment;'WaveformNoCommentsFragment': WaveformNoCommentsFragment } }
) & { ' $fragmentName'?: 'LandingHeroSlideFragment' };

export type LandingHeroTopCollectorsFragment = (
  { id: string, collectorsCount: number, mintStartTimestamp: number, artist: { id: string, userId: string }, topCollectors: Array<(
    { user: { id: string } }
    & { ' $fragmentRefs'?: { 'LandingHeroTopCollectorFragment': LandingHeroTopCollectorFragment } }
  )> }
  & { ' $fragmentRefs'?: { 'CollectModalFragment': CollectModalFragment } }
) & { ' $fragmentName'?: 'LandingHeroTopCollectorsFragment' };

export type LandingHeroTopCollectorFragment = { nftsCount: number, position: number, user: { id: string, webappUri: string, username: string, publicAddress: string, avatar: { id: string, url: string } | null } } & { ' $fragmentName'?: 'LandingHeroTopCollectorFragment' };

export type LandingHeroBackgroundFragment = { id: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, track: { id: string } } & { ' $fragmentName'?: 'LandingHeroBackgroundFragment' };

export type PeopleFollowMintedQueryVariables = Exact<{
  pagination?: InputMaybe<CursorConnectionArgs>;
  type: ActivityFeedType;
}>;


export type PeopleFollowMintedQuery = { activityFeed: { id: string, groups: { edges: Array<{ node: { id: string, information: { __typename: 'ReleaseDroppedAggregate' } | { __typename: 'ReleasesAddedToShelfAggregate' } | { __typename: 'ShelfCreatedAggregate' } | { __typename: 'SongCollectedByManyAggregate', collectedRelease: { release: (
                { id: string, track: { id: string } }
                & { ' $fragmentRefs'?: { 'CollectorCardFragment': CollectorCardFragment } }
              ) }, featuredCollectors: Array<{ nftsCount: number, user: (
                { id: string }
                & { ' $fragmentRefs'?: { 'CollectorCardUserInfoFragment': CollectorCardUserInfoFragment } }
              ) }> } | { __typename: 'UserCollectedManySongsAggregate', user: (
              { id: string }
              & { ' $fragmentRefs'?: { 'CollectorCardUserInfoFragment': CollectorCardUserInfoFragment } }
            ), collectedReleases: Array<{ totalOwnedEditions: number, release: (
                { id: string, track: { id: string } }
                & { ' $fragmentRefs'?: { 'CollectorCardFragment': CollectorCardFragment } }
              ) }> } | { __typename: 'UserCreatedPostAggregate' } | { __typename: 'UserLikedPlaylistAggregate' } | { __typename: 'UserLikedSongsAggregate' } } } | null>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type TopCollectorsRankedListItemFragment = { nftsBought: number, creatorsSupported: number, userAddress: string, totalSpent: string, user: { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } | null } & { ' $fragmentName'?: 'TopCollectorsRankedListItemFragment' };

export type TopCollectorsLandingQueryVariables = Exact<{ [key: string]: never; }>;


export type TopCollectorsLandingQuery = { topCollectorsV2: Array<{ ' $fragmentRefs'?: { 'TopCollectorsRankedListItemFragment': TopCollectorsRankedListItemFragment } }> };

export type TrendingPlaylistPostFragment = (
  { id: string, content: string, lexicalContent: unknown | null, createdAt: string, webappUri: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
  ), optionalShelf: (
    { id: string }
    & { ' $fragmentRefs'?: { 'PlaylistPreviewFragment': PlaylistPreviewFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_PlaylistPost_Fragment': FeedPostActionsInfo_PlaylistPost_Fragment } }
) & { ' $fragmentName'?: 'TrendingPlaylistPostFragment' };

export type TrendingReleasePostFragment = (
  { id: string, content: string, lexicalContent: unknown | null, createdAt: string, webappUri: string, optionalRelease: (
    { id: string }
    & { ' $fragmentRefs'?: { 'SoundBarReleaseFragment': SoundBarReleaseFragment } }
  ) | null, creator: (
    { id: string, publicAddress: string }
    & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'FeedPostActionsInfo_ReleasePost_Fragment': FeedPostActionsInfo_ReleasePost_Fragment } }
) & { ' $fragmentName'?: 'TrendingReleasePostFragment' };

export type TrendingPostsCarouselQueryVariables = Exact<{ [key: string]: never; }>;


export type TrendingPostsCarouselQuery = { trendingPostsPreview: Array<{ id: string, information: { __typename: 'ReleaseDroppedAggregate' } | { __typename: 'ReleasesAddedToShelfAggregate' } | { __typename: 'ShelfCreatedAggregate' } | { __typename: 'SongCollectedByManyAggregate' } | { __typename: 'UserCollectedManySongsAggregate' } | { __typename: 'UserCreatedPostAggregate', post: { __typename: 'ActivityFeedGroupBackingPost', id: string } | { __typename: 'ArtistDropPost', id: string } | (
        { __typename: 'PlaylistPost', id: string }
        & { ' $fragmentRefs'?: { 'TrendingPlaylistPostFragment': TrendingPlaylistPostFragment } }
      ) | (
        { __typename: 'ReleasePost', id: string }
        & { ' $fragmentRefs'?: { 'TrendingReleasePostFragment': TrendingReleasePostFragment } }
      ) | { __typename: 'Repost', id: string } | null } | { __typename: 'UserLikedPlaylistAggregate' } | { __typename: 'UserLikedSongsAggregate' } }> };

export type UpcomingDropsCarouselQueryVariables = Exact<{
  filter?: InputMaybe<ReleasesCursorFilterArgs>;
  pagination: ReleasesCursorConnectionArgs;
}>;


export type UpcomingDropsCarouselQuery = { releases: { edges: Array<{ cursor: string, node: (
        { id: string, mintStartTime: number, track: { id: string } }
        & { ' $fragmentRefs'?: { 'UpcomingDropCardFragment': UpcomingDropCardFragment } }
      ) }>, pageInfo: { startCursor: string | null, endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ViralPlaylistsRankedListItemFragment = { trendingIndicator: TrendingIndicator, currentRank: number, id: string, playlist: (
    { id: string, webappUri: string, name: string, numReferralPurchases: number, trackIds: Array<string>, type: ShelfType, coverImage: { id: string, url: string } | null, user: { id: string, username: string, webappUri: string }, coverReleases: Array<{ id: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null }> }
    & { ' $fragmentRefs'?: { 'PlaylistPreviewDropdownInfoFragment': PlaylistPreviewDropdownInfoFragment;'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment } }
  ) } & { ' $fragmentName'?: 'ViralPlaylistsRankedListItemFragment' };

export type ViralPlaylistsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViralPlaylistsQuery = { currentPlaylistChart: { id: string, chartRanks: { edges: Array<{ node: { ' $fragmentRefs'?: { 'ViralPlaylistsRankedListItemFragment': ViralPlaylistsRankedListItemFragment } } }> } } };

export type ViralSoundsRankedListItemFragment = { id: string, trendingIndicator: TrendingIndicator, currentRank: number, release: (
    { id: string, title: string, titleSlug: string, type: ReleaseType, totalMinted: number, supplyCutoffTimestamp: number | null, webappUri: string, listeningParty: number | null, artist: { id: string, name: string, soundHandle: string, webappUri: string }, track: { id: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'CollectModalFragment': CollectModalFragment;'SongCardDropdownInfoFragment': SongCardDropdownInfoFragment } }
  ) } & { ' $fragmentName'?: 'ViralSoundsRankedListItemFragment' };

export type ViralSoundsLandingQueryVariables = Exact<{
  pagination: ReleaseChartRankCursorConnectionArgs;
}>;


export type ViralSoundsLandingQuery = { currentReleaseChart: { id: string, chartRanks: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { ' $fragmentRefs'?: { 'ViralSoundsRankedListItemFragment': ViralSoundsRankedListItemFragment } } }> } } };

export type LeaderboardDesktopUserInfoFragment = { id: string, publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'LeaderboardDesktopUserInfoFragment' };

export type LeaderboardMobileUserInfoFragment = { id: string, publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'LeaderboardMobileUserInfoFragment' };

export type LeaderboardRowInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'LeaderboardDesktopUserInfoFragment': LeaderboardDesktopUserInfoFragment;'LeaderboardMobileUserInfoFragment': LeaderboardMobileUserInfoFragment } }
) & { ' $fragmentName'?: 'LeaderboardRowInfoFragment' };

export type MentionableSearchQueryVariables = Exact<{
  input: SearchInput;
}>;


export type MentionableSearchQuery = { search: { id: string, artistsPaginated: { edges: Array<{ node: { id: string, name: string, webappUri: string, user: { id: string, publicAddress: string, avatar: { url: string, id: string } | null } } }> }, collectors: { edges: Array<{ node: { id: string, displayName: string | null, publicAddress: string, webappUri: string, avatar: { url: string, id: string } | null } }> } } };

export type LikePlaylistMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LikePlaylistMutation = { likeShelf: { __typename: 'MutationLikeShelfSuccess', data: { id: string, likes: number } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type UnlikePlaylistMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UnlikePlaylistMutation = { unlikeShelf: { __typename: 'MutationUnlikeShelfSuccess', data: { id: string, likes: number } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type LikeReleaseMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LikeReleaseMutation = { likeRelease: { __typename: 'MutationLikeReleaseSuccess', data: { id: string, title: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type UnlikeReleaseMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UnlikeReleaseMutation = { unlikeRelease: { __typename: 'MutationUnlikeReleaseSuccess', data: { id: string, title: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type LikeStatusesQueryVariables = Exact<{
  input: Array<IsLikedInput> | IsLikedInput;
}>;


export type LikeStatusesQuery = { likeStatuses: Array<{ entityId: string, isLiked: boolean }> };

export type ArtistDropNotifFragment = { id: string, timestamp: number, release: (
    { id: string, title: string, webappUri: string, track: { id: string }, artist: { id: string, name: string } }
    & { ' $fragmentRefs'?: { 'CollectModalFragment': CollectModalFragment;'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) | null } & { ' $fragmentName'?: 'ArtistDropNotifFragment' };

export type NewChannelMemberNotifFragment = { id: string, timestamp: number, numUsers: number, featuredUsers: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'NotificationUserFragment': NotificationUserFragment;'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
  )>, channel: { id: string, name: string, webappUri: string, staticProfileImage: { id: string, url: string } | null, profileImage: { id: string, url: string } | null } | null } & { ' $fragmentName'?: 'NewChannelMemberNotifFragment' };

export type NewChannelPostNotifFragment = { id: string, timestamp: number, post: (
    { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment;'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
    ), channel: { id: string, name: string, webappUri: string } | null }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ActivityFeedGroupBackingPost_Fragment': NotificationPostContent_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { __typename: 'ArtistDropPost', id: string, webappUri: string, release: { webappUri: string }, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment;'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
    ), channel: { id: string, name: string, webappUri: string } | null }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ArtistDropPost_Fragment': NotificationPostContent_ArtistDropPost_Fragment } }
  ) | (
    { __typename: 'PlaylistPost', id: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment;'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
    ), channel: { id: string, name: string, webappUri: string } | null }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_PlaylistPost_Fragment': NotificationPostContent_PlaylistPost_Fragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment;'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
    ), channel: { id: string, name: string, webappUri: string } | null }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ReleasePost_Fragment': NotificationPostContent_ReleasePost_Fragment } }
  ) | (
    { __typename: 'Repost', id: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment;'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
    ), channel: { id: string, name: string, webappUri: string } | null }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_Repost_Fragment': NotificationPostContent_Repost_Fragment } }
  ) | null } & { ' $fragmentName'?: 'NewChannelPostNotifFragment' };

export type GoldenEggWinnerNotifFragment = { id: string, timestamp: number, release: { id: string, title: string, type: ReleaseType, webappUri: string, listeningParty: number | null, track: { id: string }, goldenEggImage: { id: string, url: string }, animatedGoldenEggImageOptimized: { id: string, url: string } | null } | null } & { ' $fragmentName'?: 'GoldenEggWinnerNotifFragment' };

export type MentionedInPostNotifFragment = { id: string, timestamp: number, post: (
    { webappUri: string, id: string, lexicalContent: unknown | null, content: string }
    & { ' $fragmentRefs'?: { 'FeedPostCommentModal_ActivityFeedGroupBackingPost_Fragment': FeedPostCommentModal_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { webappUri: string, id: string, lexicalContent: unknown | null, content: string }
    & { ' $fragmentRefs'?: { 'FeedPostCommentModal_ArtistDropPost_Fragment': FeedPostCommentModal_ArtistDropPost_Fragment } }
  ) | (
    { webappUri: string, id: string, lexicalContent: unknown | null, content: string }
    & { ' $fragmentRefs'?: { 'FeedPostCommentModal_PlaylistPost_Fragment': FeedPostCommentModal_PlaylistPost_Fragment } }
  ) | (
    { webappUri: string, id: string, lexicalContent: unknown | null, content: string }
    & { ' $fragmentRefs'?: { 'FeedPostCommentModal_ReleasePost_Fragment': FeedPostCommentModal_ReleasePost_Fragment } }
  ) | (
    { webappUri: string, id: string, lexicalContent: unknown | null, content: string }
    & { ' $fragmentRefs'?: { 'FeedPostCommentModal_Repost_Fragment': FeedPostCommentModal_Repost_Fragment } }
  ) | null, mentionedBy: { ' $fragmentRefs'?: { 'NotificationUserFragment': NotificationUserFragment } } | null } & { ' $fragmentName'?: 'MentionedInPostNotifFragment' };

export type MentionedInPostCommentNotifFragment = { id: string, timestamp: number, post: { webappUri: string, id: string } | { webappUri: string, id: string } | { webappUri: string, id: string } | { webappUri: string, id: string } | { webappUri: string, id: string } | null, comment: { id: string, content: string, lexicalContent: unknown | null } | null, mentionedBy: { ' $fragmentRefs'?: { 'NotificationUserFragment': NotificationUserFragment } } | null } & { ' $fragmentName'?: 'MentionedInPostCommentNotifFragment' };

export type MentionedInPostCommentReplyNotifFragment = { id: string, timestamp: number, post: { webappUri: string, id: string } | { webappUri: string, id: string } | { webappUri: string, id: string } | { webappUri: string, id: string } | { webappUri: string, id: string } | null, comment: { id: string, content: string, lexicalContent: unknown | null } | null, parentComment: { id: string } | null, mentionedBy: { ' $fragmentRefs'?: { 'NotificationUserFragment': NotificationUserFragment } } | null } & { ' $fragmentName'?: 'MentionedInPostCommentReplyNotifFragment' };

export type NewFollowerUserFragment = (
  { id: string, username: string, webappUri: string, artist: { id: string } | null }
  & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
) & { ' $fragmentName'?: 'NewFollowerUserFragment' };

export type NewFollowerNotifFragment = { id: string, timestamp: number, numNewFollowers: number, featuredFollowers: Array<(
    { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'NewFollowerUserFragment': NewFollowerUserFragment } }
  )> } & { ' $fragmentName'?: 'NewFollowerNotifFragment' };

export type ArtistReleasePostedNotifFragment = { id: string, timestamp: number, release: { id: string, title: string, webappUri: string } | null, post: { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | null } & { ' $fragmentName'?: 'ArtistReleasePostedNotifFragment' };

export type NewCommentOnReleaseNotifFragment = { id: string, timestamp: number, comment: { id: string, content: string, lexicalContent: unknown | null, author: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment } }
    ) } | null, post: (
    { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ActivityFeedGroupBackingPost_Fragment': NotificationPostContent_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { __typename: 'ArtistDropPost', id: string, webappUri: string, content: string, release: { title: string, webappUri: string } }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ArtistDropPost_Fragment': NotificationPostContent_ArtistDropPost_Fragment } }
  ) | (
    { __typename: 'PlaylistPost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_PlaylistPost_Fragment': NotificationPostContent_PlaylistPost_Fragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ReleasePost_Fragment': NotificationPostContent_ReleasePost_Fragment } }
  ) | (
    { __typename: 'Repost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_Repost_Fragment': NotificationPostContent_Repost_Fragment } }
  ) | null } & { ' $fragmentName'?: 'NewCommentOnReleaseNotifFragment' };

export type NewPostCommentReplyNotifFragment = { id: string, timestamp: number, parentComment: { id: string, content: string, lexicalContent: unknown | null } | null, comment: { id: string, content: string, lexicalContent: unknown | null, author: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment } }
    ) } | null, post: (
    { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ActivityFeedGroupBackingPost_Fragment': NotificationPostContent_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { __typename: 'ArtistDropPost', id: string, webappUri: string, content: string, release: { webappUri: string } }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ArtistDropPost_Fragment': NotificationPostContent_ArtistDropPost_Fragment } }
  ) | (
    { __typename: 'PlaylistPost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_PlaylistPost_Fragment': NotificationPostContent_PlaylistPost_Fragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ReleasePost_Fragment': NotificationPostContent_ReleasePost_Fragment } }
  ) | (
    { __typename: 'Repost', id: string, webappUri: string, content: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_Repost_Fragment': NotificationPostContent_Repost_Fragment } }
  ) | null } & { ' $fragmentName'?: 'NewPostCommentReplyNotifFragment' };

export type NewPostCommentUpvoteNotifFragment = { id: string, timestamp: number, numUsers: number, featuredUsers: Array<(
    { id: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment } }
  )>, post: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_ActivityFeedGroupBackingPost_Fragment': UpvotedPost_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_ArtistDropPost_Fragment': UpvotedPost_ArtistDropPost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_PlaylistPost_Fragment': UpvotedPost_PlaylistPost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_ReleasePost_Fragment': UpvotedPost_ReleasePost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_Repost_Fragment': UpvotedPost_Repost_Fragment } }
  ) | null, comment: { id: string, content: string, lexicalContent: unknown | null } | null } & { ' $fragmentName'?: 'NewPostCommentUpvoteNotifFragment' };

export type NewPostCommentNotifFragment = { id: string, timestamp: number, comment: { id: string, content: string, lexicalContent: unknown | null, author: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment } }
    ) } | null, post: (
    { content: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ActivityFeedGroupBackingPost_Fragment': NotificationPostContent_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { content: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ArtistDropPost_Fragment': NotificationPostContent_ArtistDropPost_Fragment } }
  ) | (
    { content: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_PlaylistPost_Fragment': NotificationPostContent_PlaylistPost_Fragment } }
  ) | (
    { content: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ReleasePost_Fragment': NotificationPostContent_ReleasePost_Fragment } }
  ) | (
    { content: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_Repost_Fragment': NotificationPostContent_Repost_Fragment } }
  ) | null } & { ' $fragmentName'?: 'NewPostCommentNotifFragment' };

export type PlaylistPostedNotifFragment = { id: string, timestamp: number, shelf: { id: string, name: string, webappUri: string } | null, post: { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | { id: string, webappUri: string, creator: (
      { id: string, username: string, webappUri: string, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
    ) } | null } & { ' $fragmentName'?: 'PlaylistPostedNotifFragment' };

export type PostSingleUserFragment = (
  { id: string, webappUri: string, username: string, artist: { id: string } | null }
  & { ' $fragmentRefs'?: { 'NotificationUserFragment': NotificationUserFragment;'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
) & { ' $fragmentName'?: 'PostSingleUserFragment' };

type NotificationPostContent_ActivityFeedGroupBackingPost_Fragment = { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, content: string, lexicalContent: unknown | null, activityFeedGroup: { information: { __typename: 'ReleaseDroppedAggregate', release: { title: string, artist: { name: string } } } | { __typename: 'ReleasesAddedToShelfAggregate' } | { __typename: 'ShelfCreatedAggregate' } | { __typename: 'SongCollectedByManyAggregate' } | { __typename: 'UserCollectedManySongsAggregate', collectedReleases: Array<{ release: { title: string, artist: { name: string } } }> } | { __typename: 'UserCreatedPostAggregate' } | { __typename: 'UserLikedPlaylistAggregate' } | { __typename: 'UserLikedSongsAggregate' } } } & { ' $fragmentName'?: 'NotificationPostContent_ActivityFeedGroupBackingPost_Fragment' };

type NotificationPostContent_ArtistDropPost_Fragment = { __typename: 'ArtistDropPost', id: string, webappUri: string, content: string, lexicalContent: unknown | null } & { ' $fragmentName'?: 'NotificationPostContent_ArtistDropPost_Fragment' };

type NotificationPostContent_PlaylistPost_Fragment = { __typename: 'PlaylistPost', id: string, webappUri: string, content: string, lexicalContent: unknown | null } & { ' $fragmentName'?: 'NotificationPostContent_PlaylistPost_Fragment' };

type NotificationPostContent_ReleasePost_Fragment = { __typename: 'ReleasePost', id: string, webappUri: string, content: string, lexicalContent: unknown | null } & { ' $fragmentName'?: 'NotificationPostContent_ReleasePost_Fragment' };

type NotificationPostContent_Repost_Fragment = { __typename: 'Repost', id: string, webappUri: string, content: string, lexicalContent: unknown | null } & { ' $fragmentName'?: 'NotificationPostContent_Repost_Fragment' };

export type NotificationPostContentFragment = NotificationPostContent_ActivityFeedGroupBackingPost_Fragment | NotificationPostContent_ArtistDropPost_Fragment | NotificationPostContent_PlaylistPost_Fragment | NotificationPostContent_ReleasePost_Fragment | NotificationPostContent_Repost_Fragment;

type UpvotedPost_ActivityFeedGroupBackingPost_Fragment = (
  { __typename: 'ActivityFeedGroupBackingPost', id: string, content: string, webappUri: string }
  & { ' $fragmentRefs'?: { 'NotificationPostContent_ActivityFeedGroupBackingPost_Fragment': NotificationPostContent_ActivityFeedGroupBackingPost_Fragment } }
) & { ' $fragmentName'?: 'UpvotedPost_ActivityFeedGroupBackingPost_Fragment' };

type UpvotedPost_ArtistDropPost_Fragment = (
  { __typename: 'ArtistDropPost', id: string, content: string, webappUri: string, release: { webappUri: string } }
  & { ' $fragmentRefs'?: { 'NotificationPostContent_ArtistDropPost_Fragment': NotificationPostContent_ArtistDropPost_Fragment } }
) & { ' $fragmentName'?: 'UpvotedPost_ArtistDropPost_Fragment' };

type UpvotedPost_PlaylistPost_Fragment = (
  { __typename: 'PlaylistPost', id: string, content: string, webappUri: string }
  & { ' $fragmentRefs'?: { 'NotificationPostContent_PlaylistPost_Fragment': NotificationPostContent_PlaylistPost_Fragment } }
) & { ' $fragmentName'?: 'UpvotedPost_PlaylistPost_Fragment' };

type UpvotedPost_ReleasePost_Fragment = (
  { __typename: 'ReleasePost', id: string, content: string, webappUri: string }
  & { ' $fragmentRefs'?: { 'NotificationPostContent_ReleasePost_Fragment': NotificationPostContent_ReleasePost_Fragment } }
) & { ' $fragmentName'?: 'UpvotedPost_ReleasePost_Fragment' };

type UpvotedPost_Repost_Fragment = (
  { __typename: 'Repost', id: string, content: string, webappUri: string }
  & { ' $fragmentRefs'?: { 'NotificationPostContent_Repost_Fragment': NotificationPostContent_Repost_Fragment } }
) & { ' $fragmentName'?: 'UpvotedPost_Repost_Fragment' };

export type UpvotedPostFragment = UpvotedPost_ActivityFeedGroupBackingPost_Fragment | UpvotedPost_ArtistDropPost_Fragment | UpvotedPost_PlaylistPost_Fragment | UpvotedPost_ReleasePost_Fragment | UpvotedPost_Repost_Fragment;

export type PostUpvotedNotifFragment = { id: string, timestamp: number, numUsers: number, featuredUsers: Array<(
    { id: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment } }
  )>, post: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_ActivityFeedGroupBackingPost_Fragment': UpvotedPost_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_ArtistDropPost_Fragment': UpvotedPost_ArtistDropPost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_PlaylistPost_Fragment': UpvotedPost_PlaylistPost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_ReleasePost_Fragment': UpvotedPost_ReleasePost_Fragment } }
  ) | (
    { id: string }
    & { ' $fragmentRefs'?: { 'UpvotedPost_Repost_Fragment': UpvotedPost_Repost_Fragment } }
  ) | null } & { ' $fragmentName'?: 'PostUpvotedNotifFragment' };

export type RepostNotificationInfoFragment = { id: string, timestamp: number, post: (
    { id: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ActivityFeedGroupBackingPost_Fragment': NotificationPostContent_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { id: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ArtistDropPost_Fragment': NotificationPostContent_ArtistDropPost_Fragment } }
  ) | (
    { id: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_PlaylistPost_Fragment': NotificationPostContent_PlaylistPost_Fragment } }
  ) | (
    { id: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_ReleasePost_Fragment': NotificationPostContent_ReleasePost_Fragment } }
  ) | (
    { id: string, webappUri: string }
    & { ' $fragmentRefs'?: { 'NotificationPostContent_Repost_Fragment': NotificationPostContent_Repost_Fragment } }
  ) | null, reposter: (
    { id: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'PostSingleUserFragment': PostSingleUserFragment } }
  ) | null } & { ' $fragmentName'?: 'RepostNotificationInfoFragment' };

export type PresaleArtistDropNotifFragment = { id: string, timestamp: number, release: (
    { id: string, title: string, webappUri: string, track: { id: string }, artist: { id: string, name: string } }
    & { ' $fragmentRefs'?: { 'CollectModalFragment': CollectModalFragment;'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) | null } & { ' $fragmentName'?: 'PresaleArtistDropNotifFragment' };

export type ReferralReceivedNotifFragment = { id: string, timestamp: number, totalReceivedWei: string | null } & { ' $fragmentName'?: 'ReferralReceivedNotifFragment' };

export type NewUserMintedFragment = (
  { id: string, username: string, webappUri: string, publicAddress: string, artist: { id: string } | null, avatar: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
) & { ' $fragmentName'?: 'NewUserMintedFragment' };

export type ReleaseMintedInNotifFragment = { id: string, title: string, webappUri: string } & { ' $fragmentName'?: 'ReleaseMintedInNotifFragment' };

export type ReleaseMintedNotifFragment = { id: string, timestamp: number, numTotalCollectors: number, numTotalMints: number, featuredCollectors: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'NewUserMintedFragment': NewUserMintedFragment } }
  )>, release: (
    { id: string, title: string }
    & { ' $fragmentRefs'?: { 'ReleaseMintedInNotifFragment': ReleaseMintedInNotifFragment;'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) | null } & { ' $fragmentName'?: 'ReleaseMintedNotifFragment' };

export type PresaveDropStartedNotifFragment = { id: string, timestamp: number, presaveRelease: (
    { id: string, title: string, webappUri: string, mintStartTime: number, spotifyPresaveCampaign: boolean, track: { id: string }, artist: { id: string, name: string } }
    & { ' $fragmentRefs'?: { 'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) } & { ' $fragmentName'?: 'PresaveDropStartedNotifFragment' };

export type PresaveGiftReceivedNotifFragment = { id: string, timestamp: number, presaveRelease: (
    { id: string, title: string, webappUri: string, spotifyPresaveCampaign: boolean, track: { id: string }, artist: { id: string, name: string } }
    & { ' $fragmentRefs'?: { 'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) } & { ' $fragmentName'?: 'PresaveGiftReceivedNotifFragment' };

export type ReleasePresavedNotifFragment = { id: string, timestamp: number, numUsers: number, featuredUsers: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'NewUserPresavedFragment': NewUserPresavedFragment } }
  )>, user: (
    { id: string, webappUri: string, username: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'NotificationUserFragment': NotificationUserFragment } }
  ) | null, presaveRelease: (
    { id: string, title: string, spotifyPresaveCampaign: boolean }
    & { ' $fragmentRefs'?: { 'ReleasePresavedInNotifFragment': ReleasePresavedInNotifFragment;'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) } & { ' $fragmentName'?: 'ReleasePresavedNotifFragment' };

export type NewUserPresavedFragment = (
  { id: string, username: string, webappUri: string, publicAddress: string, artist: { id: string } | null, avatar: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment;'NotificationUserFragment': NotificationUserFragment } }
) & { ' $fragmentName'?: 'NewUserPresavedFragment' };

export type ReleasePresavedInNotifFragment = { id: string, title: string, webappUri: string } & { ' $fragmentName'?: 'ReleasePresavedInNotifFragment' };

export type ViralPresaveNotifFragment = { id: string, timestamp: number, featuredPresavers: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'NewUserPresavedFragment': NewUserPresavedFragment } }
  )>, presaveRelease: (
    { id: string, spotifyPresaveCount: number, spotifyPresaveCampaign: boolean, mintStartTime: number, artist: { id: string } }
    & { ' $fragmentRefs'?: { 'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) } & { ' $fragmentName'?: 'ViralPresaveNotifFragment' };

export type ViralMintNotifFragment = { id: string, timestamp: number, featuredCollectors: Array<(
    { id: string, webappUri: string, username: string }
    & { ' $fragmentRefs'?: { 'GroupedUsersInfoFragment': GroupedUsersInfoFragment } }
  )>, release: (
    { id: string, totalMinted: number, webappUri: string, title: string, artist: { id: string, name: string }, track: { id: string } }
    & { ' $fragmentRefs'?: { 'CollectModalFragment': CollectModalFragment;'NotificationReleaseCoverFragment': NotificationReleaseCoverFragment } }
  ) | null } & { ' $fragmentName'?: 'ViralMintNotifFragment' };

export type NotificationReleaseCoverFragment = { id: string, title: string, type: ReleaseType, webappUri: string, listeningParty: number | null, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, track: { id: string } } & { ' $fragmentName'?: 'NotificationReleaseCoverFragment' };

export type NotificationUserFragment = { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'NotificationUserFragment' };

export type UserNotificationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationStatusQuery = { userNotificationsStatus: { id: string, hasUnreadNotifications: boolean, lastReadTimestamp: number | null } };

export type MarkNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkNotificationsAsReadMutation = { markAllUserNotificationsRead: { id: string, hasUnreadNotifications: boolean, lastReadTimestamp: number | null } };

export type NewUserNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewUserNotificationSubscription = { notificationUpdates: { notificationTimestamp: number | null } };

export type NewGlobalUserNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewGlobalUserNotificationSubscription = { notificationUpdates: { notificationTimestamp: number | null } };

export type UserNotificationsHookQueryVariables = Exact<{
  pagination: CursorConnectionArgs;
}>;


export type UserNotificationsHookQuery = { userNotifications: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
        { __typename: 'ArtistReleasePosted', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'ArtistReleasePostedNotifFragment': ArtistReleasePostedNotifFragment } }
      ) | (
        { __typename: 'GoldenEggWon', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'GoldenEggWinnerNotifFragment': GoldenEggWinnerNotifFragment } }
      ) | (
        { __typename: 'MentionedInPost', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'MentionedInPostNotifFragment': MentionedInPostNotifFragment } }
      ) | (
        { __typename: 'MentionedInPostComment', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'MentionedInPostCommentNotifFragment': MentionedInPostCommentNotifFragment } }
      ) | (
        { __typename: 'MentionedInPostCommentReply', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'MentionedInPostCommentReplyNotifFragment': MentionedInPostCommentReplyNotifFragment } }
      ) | (
        { __typename: 'NewChannelMember', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'NewChannelMemberNotifFragment': NewChannelMemberNotifFragment } }
      ) | (
        { __typename: 'NewChannelPost', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'NewChannelPostNotifFragment': NewChannelPostNotifFragment } }
      ) | (
        { __typename: 'NewCommentOnRelease', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'NewCommentOnReleaseNotifFragment': NewCommentOnReleaseNotifFragment } }
      ) | (
        { __typename: 'NewFollower', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'NewFollowerNotifFragment': NewFollowerNotifFragment } }
      ) | (
        { __typename: 'NewPostComment', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'NewPostCommentNotifFragment': NewPostCommentNotifFragment } }
      ) | (
        { __typename: 'NewPostCommentReply', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'NewPostCommentReplyNotifFragment': NewPostCommentReplyNotifFragment } }
      ) | (
        { __typename: 'NewPostCommentUpvote', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'NewPostCommentUpvoteNotifFragment': NewPostCommentUpvoteNotifFragment } }
      ) | (
        { __typename: 'NewPostUpvote', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'PostUpvotedNotifFragment': PostUpvotedNotifFragment } }
      ) | (
        { __typename: 'NewRepost', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'RepostNotificationInfoFragment': RepostNotificationInfoFragment } }
      ) | (
        { __typename: 'PlaylistPosted', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'PlaylistPostedNotifFragment': PlaylistPostedNotifFragment } }
      ) | (
        { __typename: 'PresaleStarted', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'PresaleArtistDropNotifFragment': PresaleArtistDropNotifFragment } }
      ) | (
        { __typename: 'PresaveDropStarted', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'PresaveDropStartedNotifFragment': PresaveDropStartedNotifFragment } }
      ) | (
        { __typename: 'PresaveGiftReceived', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'PresaveGiftReceivedNotifFragment': PresaveGiftReceivedNotifFragment } }
      ) | (
        { __typename: 'PublicSaleStarted', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'ArtistDropNotifFragment': ArtistDropNotifFragment } }
      ) | (
        { __typename: 'ReferralReceivedNotification', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'ReferralReceivedNotifFragment': ReferralReceivedNotifFragment } }
      ) | (
        { __typename: 'ReleaseMinted', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'ReleaseMintedNotifFragment': ReleaseMintedNotifFragment } }
      ) | (
        { __typename: 'ReleasePresaved', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'ReleasePresavedNotifFragment': ReleasePresavedNotifFragment } }
      ) | { __typename: 'SubscribeToEmailCTA', id: string, timestamp: number } | (
        { __typename: 'ViralMintsReached', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'ViralMintNotifFragment': ViralMintNotifFragment } }
      ) | (
        { __typename: 'ViralPresave', id: string, timestamp: number }
        & { ' $fragmentRefs'?: { 'ViralPresaveNotifFragment': ViralPresaveNotifFragment } }
      ) }> } };

export type PlaylistHeroDetailsFragment = { id: string, numReferralPurchases: number, releaseCount: number, user: { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } } } & { ' $fragmentName'?: 'PlaylistHeroDetailsFragment' };

export type PlaylistHeroFragment = (
  { id: string, name: string, description: string | null, playTimeInSeconds: number, trackIds: Array<string>, type: ShelfType, coverImage: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment;'PlaylistHeroDetailsFragment': PlaylistHeroDetailsFragment } }
) & { ' $fragmentName'?: 'PlaylistHeroFragment' };

export type PlaylistSongsInfoFragment = (
  { id: string, releaseCount: number, webappUri: string }
  & { ' $fragmentRefs'?: { 'PlaylistInfoRowFragment': PlaylistInfoRowFragment } }
) & { ' $fragmentName'?: 'PlaylistSongsInfoFragment' };

export type PlaylistPageFragment = (
  { id: string, name: string, trackIds: Array<string>, releaseIds: Array<string>, description: string | null, playTimeInSeconds: number, releaseCount: number, type: ShelfType, likes: number, webappUri: string, user: (
    { id: string, username: string, webappUri: string, publicAddress: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PlaylistHeroFragment': PlaylistHeroFragment;'PlaylistSongsInfoFragment': PlaylistSongsInfoFragment;'PlaylistShareInfoFragment': PlaylistShareInfoFragment } }
) & { ' $fragmentName'?: 'PlaylistPageFragment' };

export type PlaylistPageNewQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PlaylistPageNewQuery = { shelf: (
    { id: string }
    & { ' $fragmentRefs'?: { 'PlaylistPageFragment': PlaylistPageFragment } }
  ) | null };

export type LikesActivityFeedHookQueryVariables = Exact<{
  userId: Scalars['UUID'];
  pagination?: InputMaybe<CursorConnectionArgs>;
}>;


export type LikesActivityFeedHookQuery = { likeActivityFeed: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
        { __typename: 'ReleaseLiked', id: string, date: string }
        & { ' $fragmentRefs'?: { 'ReleaseLikedListFragment': ReleaseLikedListFragment } }
      ) | (
        { __typename: 'ReleaseUnliked', id: string, date: string }
        & { ' $fragmentRefs'?: { 'ReleaseUnlikedListFragment': ReleaseUnlikedListFragment } }
      ) }> } };

export type PlaylistActivityInfoFragment = { id: string, name: string, webappUri: string } & { ' $fragmentName'?: 'PlaylistActivityInfoFragment' };

export type PlaylistActivityFeedHookQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
  pagination?: InputMaybe<CursorConnectionArgs>;
}>;


export type PlaylistActivityFeedHookQuery = { playlistActivityFeed: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
        { __typename: 'CreatedPlaylistPost', id: string, date: string, playlist: { id: string } | null }
        & { ' $fragmentRefs'?: { 'CreatedPlaylistPostListFragment': CreatedPlaylistPostListFragment } }
      ) | (
        { __typename: 'PlaylistCreated', id: string, date: string, playlist: { id: string } | null }
        & { ' $fragmentRefs'?: { 'PlaylistCreatedListFragment': PlaylistCreatedListFragment } }
      ) | (
        { __typename: 'PlaylistLiked', id: string, date: string, playlist: { id: string } | null }
        & { ' $fragmentRefs'?: { 'PlaylistLikedListFragment': PlaylistLikedListFragment } }
      ) | (
        { __typename: 'ReleasesAddedRemovedFromPlaylist', id: string, date: string, playlist: { id: string } | null }
        & { ' $fragmentRefs'?: { 'ReleasesAddedRemovedListFragment': ReleasesAddedRemovedListFragment } }
      ) | (
        { __typename: 'ReleasesAddedToPlaylist', id: string, date: string, playlist: { id: string } | null }
        & { ' $fragmentRefs'?: { 'ReleasesAddedListFragment': ReleasesAddedListFragment } }
      ) | (
        { __typename: 'ReleasesRemovedFromPlaylist', id: string, date: string, playlist: { id: string } | null }
        & { ' $fragmentRefs'?: { 'ReleasesRemovedListFragment': ReleasesRemovedListFragment } }
      ) }> } };

export type PreviewHeaderFragment = (
  { id: string, name: string, type: ShelfType, numReferralPurchases: number, releaseCount: number, user: { ' $fragmentRefs'?: { 'ShelfCreatorFragment': ShelfCreatorFragment } } }
  & { ' $fragmentRefs'?: { 'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment;'PlaylistPreviewDropdownInfoFragment': PlaylistPreviewDropdownInfoFragment } }
) & { ' $fragmentName'?: 'PreviewHeaderFragment' };

export type PreviewPlaylistRowFragment = { id: string, release: { id: string, type: ReleaseType, listeningParty: number | null, title: string, webappUri: string, finalQuantity: number | null, track: { id: string, duration: number }, artist: { id: string, name: string, webappUri: string }, coverImage: { url: string, id: string }, staticCoverImage: { url: string, id: string } | null }, ownedTokens: Array<{ serialNumber: number, tierNumber: number | null }> | null, ownedFirstNft: { id: string, serialNumber: number, updatedAt: string, tierNumber: number | null } | null, ownedGoldenEgg: { id: string, nft: { id: string, serialNumber: number } } | null } & { ' $fragmentName'?: 'PreviewPlaylistRowFragment' };

export type PlaylistPreviewFragment = (
  { id: string, name: string, releaseCount: number, webappUri: string, user: { id: string, username: string } }
  & { ' $fragmentRefs'?: { 'PreviewHeaderFragment': PreviewHeaderFragment } }
) & { ' $fragmentName'?: 'PlaylistPreviewFragment' };

export type ShelfCreatorFragment = { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'ShelfCreatorFragment' };

export type PlaylistCoverImagesFragment = { id: string, type: ShelfType, coverImage: { id: string, url: string, dominantColor: string | null } | null, previewReleases: Array<{ id: string, release: { id: string, coverImage: { id: string, url: string, dominantColor: string | null }, staticCoverImage: { id: string, url: string, dominantColor: string | null } | null }, ownedGoldenEgg: { id: string, goldenEggImage: { id: string, url: string } | null, animatedGoldenEggImageOptimized: { id: string, url: string } | null } | null }> } & { ' $fragmentName'?: 'PlaylistCoverImagesFragment' };

export type PlaylistPreviewDropdownInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'PlaylistShareInfoFragment': PlaylistShareInfoFragment } }
) & { ' $fragmentName'?: 'PlaylistPreviewDropdownInfoFragment' };

export type LikedSoundsCardDetailsFragment = (
  { id: string, trackIds: Array<string>, webappUri: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ShelfCreatorFragment': ShelfCreatorFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PlaylistCardInfoHookFragment': PlaylistCardInfoHookFragment;'PlaylistPreviewDropdownInfoFragment': PlaylistPreviewDropdownInfoFragment } }
) & { ' $fragmentName'?: 'LikedSoundsCardDetailsFragment' };

export type PlaylistCardDetailsFragment = (
  { __typename: 'Shelf', id: string, likes: number, releaseCount: number, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ShelfCreatorFragment': ShelfCreatorFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PlaylistCardActionFragment': PlaylistCardActionFragment;'PlaylistCardInfoHookFragment': PlaylistCardInfoHookFragment;'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment } }
) & { ' $fragmentName'?: 'PlaylistCardDetailsFragment' };

export type PlaylistCardActionFragment = (
  { id: string, trackIds: Array<string>, type: ShelfType, webappUri: string, user: { id: string } }
  & { ' $fragmentRefs'?: { 'PlaylistPreviewDropdownInfoFragment': PlaylistPreviewDropdownInfoFragment } }
) & { ' $fragmentName'?: 'PlaylistCardActionFragment' };

export type PlaylistCardSocialProofQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
  userPublicAddress?: InputMaybe<Scalars['String']>;
}>;


export type PlaylistCardSocialProofQuery = { playlistV2: { id: string, numReferralPurchases: number, socialProofReferrals: Array<{ id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null }> } | null };

export type PlaylistRowReleaseInfoFragment = { id: string, release: (
    { id: string, type: ReleaseType, listeningParty: number | null, title: string, finalQuantity: number | null, webappUri: string, track: { id: string, duration: number }, artist: { id: string, userId: string, name: string, webappUri: string }, coverImage: { url: string, id: string }, staticCoverImage: { url: string, id: string } | null }
    & { ' $fragmentRefs'?: { 'ReleasePlaylistUrlReleaseInfoFragment': ReleasePlaylistUrlReleaseInfoFragment;'MintComponentFragment': MintComponentFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment } }
  ), ownedTokens: Array<{ serialNumber: number, tierNumber: number | null }> | null, ownedFirstNft: { id: string, serialNumber: number, updatedAt: string, tierNumber: number | null } | null, ownedGoldenEgg: { id: string, nft: { id: string, serialNumber: number } } | null } & { ' $fragmentName'?: 'PlaylistRowReleaseInfoFragment' };

export type PlaylistInfoRowFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'ReleasePlaylistUrlPlaylistInfoFragment': ReleasePlaylistUrlPlaylistInfoFragment } }
) & { ' $fragmentName'?: 'PlaylistInfoRowFragment' };

export type PlaylistCardInfoHookFragment = { id: string, name: string, releaseCount: number, playTimeInSeconds: number, type: ShelfType, webappUri: string, coverReleases: Array<{ id: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null }>, user: { id: string, username: string }, coverImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'PlaylistCardInfoHookFragment' };

export type PlaylistHookQueryVariables = Exact<{
  id: Scalars['UUID'];
  pagination: ShelfOrderedReleaseCursorConnectionArgs;
  showPreviewPlaylistRow: Scalars['Boolean'];
  showPlaylistRow: Scalars['Boolean'];
}>;


export type PlaylistHookQuery = { shelf: { id: string, trackIds: Array<string>, releaseIds: Array<string>, orderedReleases: { edges: Array<{ node: (
          { id: string, index: number, addedAt: number, release: { id: string } }
          & { ' $fragmentRefs'?: { 'PlaylistRowReleaseInfoFragment': PlaylistRowReleaseInfoFragment;'PreviewPlaylistRowFragment': PreviewPlaylistRowFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type ArtistActionBarFragment = { id: string, webappUri: string, artist: { id: string, numReleases: number, bannerImage: { id: string, url: string } | null, pickedRelease: { id: string } | null } | null } & { ' $fragmentName'?: 'ArtistActionBarFragment' };

export type UploadArtistBannerImageMutationVariables = Exact<{
  bannerImage: UploadedMedia;
}>;


export type UploadArtistBannerImageMutation = { upsertArtistBannerImage: { id: string, bannerImage: { id: string, url: string, key: string } | null } };

export type CollectorActionBarFragment = { id: string, webappUri: string, collectedReleasesCount: number, bannerImage: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'CollectorActionBarFragment' };

export type UpsertUserBannerImageMutationVariables = Exact<{
  bannerImage: UploadedMedia;
}>;


export type UpsertUserBannerImageMutation = { upsertUserBannerImage: { id: string, bannerImage: { id: string, key: string, url: string } | null } };

export type ArtistLatestReleaseQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  filter?: InputMaybe<ArtistReleasesFilter>;
}>;


export type ArtistLatestReleaseQuery = { artist: { id: string, pickedRelease: (
      { id: string, mintStartTime: number }
      & { ' $fragmentRefs'?: { 'SoundBarReleaseFragment': SoundBarReleaseFragment } }
    ) | null, releases: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ cursor: string, node: (
          { id: string, mintStartTime: number }
          & { ' $fragmentRefs'?: { 'SoundBarReleaseFragment': SoundBarReleaseFragment } }
        ) }> } } | null };

export type ArtistAppearsOnFragment = { id: string, appearsOnNumReleases: number, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'CarouselUserInfoFragment': CarouselUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'ArtistAppearsOnFragment' };

export type ArtistAppearsOnCarouselQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type ArtistAppearsOnCarouselQuery = { artist: { id: string, appearsOnReleases: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'ReleasesCardFragment': ReleasesCardFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type CollectionCarouselFragment = (
  { id: string, collectedReleasesCount: number }
  & { ' $fragmentRefs'?: { 'CarouselUserInfoFragment': CarouselUserInfoFragment } }
) & { ' $fragmentName'?: 'CollectionCarouselFragment' };

export type CollectionCarouselSlidesQueryVariables = Exact<{
  userId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type CollectionCarouselSlidesQuery = { user: { id: string, releases: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'CollectionCardFragment': CollectionCardFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type CollectorAppearsOnFragment = (
  { id: string, creditAllocations: Array<{ id: string, creditSplit: { id: string, mintedReleases: Array<(
        { id: string }
        & { ' $fragmentRefs'?: { 'ReleasesCardFragment': ReleasesCardFragment } }
      )> } }> }
  & { ' $fragmentRefs'?: { 'CarouselUserInfoFragment': CarouselUserInfoFragment } }
) & { ' $fragmentName'?: 'CollectorAppearsOnFragment' };

export type PlaylistsCarouselUserInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'CarouselUserInfoFragment': CarouselUserInfoFragment } }
) & { ' $fragmentName'?: 'PlaylistsCarouselUserInfoFragment' };

export type PlaylistsCarouselPlaylistsQueryVariables = Exact<{
  id: Scalars['UUID'];
  pagination: ShelfCursorConnectionArgs;
  filter: UserShelvesFilter;
}>;


export type PlaylistsCarouselPlaylistsQuery = { user: { id: string, shelvesCount: number, likedSounds: (
      { id: string, releaseCount: number }
      & { ' $fragmentRefs'?: { 'LikedSoundsCardDetailsFragment': LikedSoundsCardDetailsFragment } }
    ) | null, shelves: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: (
          { id: string, releaseCount: number }
          & { ' $fragmentRefs'?: { 'PlaylistCardDetailsFragment': PlaylistCardDetailsFragment } }
        ) }> } } | null };

export type ReleasesCarouselInfoFragment = { id: string, carouselReleases: number, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'CarouselUserInfoFragment': CarouselUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'ReleasesCarouselInfoFragment' };

export type ReleasesCarouselQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type ReleasesCarouselQuery = { artist: { id: string, releases: { edges: Array<{ node: (
          { id: string, track: { id: string } }
          & { ' $fragmentRefs'?: { 'ReleaseInfoCardFragment': ReleaseInfoCardFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type RecommendedPlaylistsQueryVariables = Exact<{
  id: Scalars['UUID'];
  pagination: ShelfCursorConnectionArgs;
}>;


export type RecommendedPlaylistsQuery = { user: (
    { id: string, shelvesCount: number, shelves: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PlaylistCardDetailsFragment': PlaylistCardDetailsFragment } }
        ) }> } }
    & { ' $fragmentRefs'?: { 'CollectionCarouselFragment': CollectionCarouselFragment;'CarouselUserInfoFragment': CarouselUserInfoFragment } }
  ) | null };

export type ArtistActivityFeedQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
  filter?: InputMaybe<ArtistActivityFeedFilterArgs>;
}>;


export type ArtistActivityFeedQuery = { artistActivityFeed: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
        { __typename: 'BondingCurveSale', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'BondingCurveSaleListFragment': BondingCurveSaleListFragment } }
      ) | (
        { __typename: 'BondingCurveSold', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'BondingCurveSoldListFragment': BondingCurveSoldListFragment } }
      ) | { __typename: 'CreatedPlaylistPost', id: string, date: string, user: { id: string } } | (
        { __typename: 'CreatedPost', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ProfileCreatedPostFragment': ProfileCreatedPostFragment } }
      ) | (
        { __typename: 'PlaylistCreated', id: string, date: string, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PlaylistCreatedListFragment': PlaylistCreatedListFragment } }
      ) | (
        { __typename: 'PlaylistLiked', id: string, date: string, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PlaylistLikedListFragment': PlaylistLikedListFragment } }
      ) | (
        { __typename: 'PostReposted', id: string, date: string, originalPost: { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | null, repost: { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PostRepostedInfoFragment': PostRepostedInfoFragment } }
      ) | (
        { __typename: 'PrimarySale', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PrimarySaleListFragment': PrimarySaleListFragment } }
      ) | (
        { __typename: 'ReleaseDropped', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleaseDroppedListFragment': ReleaseDroppedListFragment } }
      ) | (
        { __typename: 'ReleaseLiked', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleaseLikedListFragment': ReleaseLikedListFragment } }
      ) | { __typename: 'ReleaseUnliked', id: string, date: string, user: { id: string } } | (
        { __typename: 'ReleasesAddedRemovedFromPlaylist', id: string, numAddedReleases: number, date: string, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleasesAddedRemovedListFragment': ReleasesAddedRemovedListFragment } }
      ) | (
        { __typename: 'ReleasesAddedToPlaylist', id: string, date: string, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleasesAddedListFragment': ReleasesAddedListFragment } }
      ) | (
        { __typename: 'SecondarySale', id: string, date: string, release: { id: string }, purchasedFromUser: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'SecondarySaleListFragment': SecondarySaleListFragment } }
      ) }> } };

export type ArtistActivitySectionArtistInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'ArtistActivitySectionArtistInfoFragment' };

export type AllArtistAppearsOnReleasesQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
  filter: ArtistReleasesFilter;
}>;


export type AllArtistAppearsOnReleasesQuery = { artist: { id: string, numReleases: number, user: { id: string }, releases: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'ReleasesCardFragment': ReleasesCardFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type ArtistAppearsOnSectionArtistInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'ArtistAppearsOnSectionArtistInfoFragment' };

export type AllBackedArtistsQueryVariables = Exact<{
  id: Scalars['UUID'];
  pagination?: InputMaybe<ArtistCollectorCursorConnectionArgs>;
}>;


export type AllBackedArtistsQuery = { user: { id: string, backedArtists: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
          { id: string, nftsCount: number, firstNftCollectedDate: string }
          & { ' $fragmentRefs'?: { 'CollectorCardInfoFragment': CollectorCardInfoFragment } }
        ) }> } } | null };

export type ProfileCollectionPageQueryVariables = Exact<{
  userId: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserCollectedReleasesFilter>;
  sort?: InputMaybe<ReleasesCollectorSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type ProfileCollectionPageQuery = { user: { id: string, publicAddress: string, collectedReleases: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'CollectionCardFragment': CollectionCardFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type CollectionSectionUserInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'CollectionSectionUserInfoFragment' };

export type CollectorActivityFeedQueryVariables = Exact<{
  userId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
  filter?: InputMaybe<CollectorActivityFeedFilterArgs>;
}>;


export type CollectorActivityFeedQuery = { collectorActivityFeed: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { __typename: 'Airdrop', id: string, date: string, user: { id: string } } | (
        { __typename: 'BondingCurveSale', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'BondingCurveSaleListFragment': BondingCurveSaleListFragment } }
      ) | (
        { __typename: 'BondingCurveSold', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'BondingCurveSoldListFragment': BondingCurveSoldListFragment } }
      ) | { __typename: 'CreatedPlaylistPost', id: string, date: string, user: { id: string } } | (
        { __typename: 'CreatedPost', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ProfileCreatedPostFragment': ProfileCreatedPostFragment } }
      ) | (
        { __typename: 'PlaylistCreated', id: string, date: string, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PlaylistCreatedListFragment': PlaylistCreatedListFragment } }
      ) | (
        { __typename: 'PlaylistLiked', id: string, date: string, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PlaylistLikedListFragment': PlaylistLikedListFragment } }
      ) | (
        { __typename: 'PostReposted', id: string, date: string, originalPost: { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | null, repost: { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PostRepostedInfoFragment': PostRepostedInfoFragment } }
      ) | (
        { __typename: 'PrimarySale', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'PrimarySaleListFragment': PrimarySaleListFragment } }
      ) | (
        { __typename: 'ReleaseLiked', id: string, date: string, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleaseLikedListFragment': ReleaseLikedListFragment } }
      ) | { __typename: 'ReleaseUnliked', id: string, date: string, user: { id: string } } | (
        { __typename: 'ReleasesAddedRemovedFromPlaylist', id: string, date: string, numAddedReleases: number, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleasesAddedRemovedListFragment': ReleasesAddedRemovedListFragment } }
      ) | (
        { __typename: 'ReleasesAddedToPlaylist', id: string, date: string, playlist: { id: string } | null, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleasesAddedListFragment': ReleasesAddedListFragment } }
      ) | { __typename: 'ReleasesRemovedFromPlaylist', id: string, date: string, user: { id: string } } | (
        { __typename: 'SecondarySale', id: string, date: string, purchasedFromUser: { id: string }, release: { id: string }, user: { id: string } }
        & { ' $fragmentRefs'?: { 'SecondarySaleListFragment': SecondarySaleListFragment } }
      ) }> } };

export type CollectorActivityUserInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'CollectorActivityUserInfoFragment' };

export type AllCollectorAppearsOnReleasesQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type AllCollectorAppearsOnReleasesQuery = { user: { id: string, publicAddress: string, creditAllocations: Array<{ id: string, creditSplit: { id: string, mintedReleases: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'ReleasesCardFragment': ReleasesCardFragment } }
        )> } }> } | null };

export type CollectorAppearsOnUserInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'CollectorAppearsOnUserInfoFragment' };

export type AllArtistCollectorsQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination: ArtistCollectorCursorConnectionArgs;
}>;


export type AllArtistCollectorsQuery = { artist: { id: string, collectors: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: (
          { id: string, nftsCount: number, firstNftCollectedDate: string }
          & { ' $fragmentRefs'?: { 'CollectorCardInfoFragment': CollectorCardInfoFragment } }
        ) }> } } | null };

export type CollectorsSectionArtistInfoFragment = { id: string, webappUri: string, user: { id: string, publicAddress: string } } & { ' $fragmentName'?: 'CollectorsSectionArtistInfoFragment' };

export type AllUserPlaylistsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  shelfPagination: ShelfCursorConnectionArgs;
  filter: UserShelvesFilter;
}>;


export type AllUserPlaylistsQuery = { user: { id: string, shelvesCount: number, likedSounds: (
      { id: string, releaseCount: number }
      & { ' $fragmentRefs'?: { 'PlaylistPreviewFragment': PlaylistPreviewFragment } }
    ) | null, shelves: { edges: Array<{ node: (
          { id: string, createdAt: string, releaseCount: number }
          & { ' $fragmentRefs'?: { 'PlaylistPreviewFragment': PlaylistPreviewFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type PlaylistsSectionUserInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'PlaylistsSectionUserInfoFragment' };

export type AllArtistReleasesQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
  filter: ArtistReleasesFilter;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type AllArtistReleasesQuery = { artist: { id: string, numReleases: number, user: { id: string }, releases: { edges: Array<{ node: (
          { id: string, track: { id: string } }
          & { ' $fragmentRefs'?: { 'ReleaseInfoCardFragment': ReleaseInfoCardFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type ReleasesSectionArtistInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'ReleasesSectionArtistInfoFragment' };

export type SectionExpandedArtistInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'CollectorsSectionArtistInfoFragment': CollectorsSectionArtistInfoFragment;'ReleasesSectionArtistInfoFragment': ReleasesSectionArtistInfoFragment;'ArtistAppearsOnSectionArtistInfoFragment': ArtistAppearsOnSectionArtistInfoFragment;'ArtistActivitySectionArtistInfoFragment': ArtistActivitySectionArtistInfoFragment } }
) & { ' $fragmentName'?: 'SectionExpandedArtistInfoFragment' };

export type SectionExpandedUserInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'PlaylistsSectionUserInfoFragment': PlaylistsSectionUserInfoFragment;'CollectorAppearsOnUserInfoFragment': CollectorAppearsOnUserInfoFragment;'CollectorActivityUserInfoFragment': CollectorActivityUserInfoFragment;'CollectionSectionUserInfoFragment': CollectionSectionUserInfoFragment;'BackedArtistSectionFragment': BackedArtistSectionFragment } }
) & { ' $fragmentName'?: 'SectionExpandedUserInfoFragment' };

export type GetUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetUserQuery = { user: { id: string, username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null, artist: { id: string, name: string } | null } | null };

export type AuthUserEditProfileDataNewQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthUserEditProfileDataNewQuery = { authUser: { id: string, displayName: string | null, tiktokUrl: string | null, description: string | null, delegateWalletAddress: string | null, avatar: { id: string, key: string } | null, bannerImage: { id: string, key: string } | null, invitedByUser: { id: string } | null, artist: { id: string, spotifyUrl: string | null, bannerImage: { id: string, key: string } | null } | null } | null };

export type SetUserAvatarImageMutationVariables = Exact<{
  image: UploadedMedia;
}>;


export type SetUserAvatarImageMutation = { uploadUserMedia: { id: string, avatar: { id: string, url: string, key: string } | null } };

export type SetUserDisplayNameMutationVariables = Exact<{
  displayName: Scalars['String'];
}>;


export type SetUserDisplayNameMutation = { setUserDisplayName: { __typename: 'MutationSetUserDisplayNameSuccess', data: { id: string, displayName: string | null } } | { __typename: 'ValidationError', message: string } };

export type SetDelegateAddressMutationVariables = Exact<{
  delegateAddress?: InputMaybe<Scalars['Address']>;
}>;


export type SetDelegateAddressMutation = { setDelegateAddress: { id: string } };

export type SetDescriptionMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type SetDescriptionMutation = { updateDescription: { id: string, description: string | null } };

export type SetArtistSpotifyUrlMutationVariables = Exact<{
  spotifyUrl?: InputMaybe<Scalars['URL']>;
}>;


export type SetArtistSpotifyUrlMutation = { updateSpotifyArtistUrl: { __typename: 'MutationUpdateSpotifyArtistUrlSuccess', data: { id: string, spotifyUrl: string | null } } | { __typename: 'ValidationError', message: string } };

export type SetTiktokUrlMutationVariables = Exact<{
  tiktokUrl?: InputMaybe<Scalars['URL']>;
}>;


export type SetTiktokUrlMutation = { updateTiktokUrl: { __typename: 'MutationUpdateTiktokUrlSuccess', data: { id: string, tiktokUrl: string | null } } | { __typename: 'ValidationError', message: string } };

export type SetUserLocationMutationVariables = Exact<{
  location?: InputMaybe<GeoLocationInput>;
}>;


export type SetUserLocationMutation = { setUserLocation: { message: string } | { data: { id: string, location: { label: string, placeId: string } | null } } | { message: string } };

export type SetInvitedByUserMutationVariables = Exact<{
  invitedBy?: InputMaybe<Scalars['UUID']>;
}>;


export type SetInvitedByUserMutation = { setInvitedByUser: { data: { id: string } } | {} };

export type CollectorFeaturedReleaseFragment = { id: string, release: { ' $fragmentRefs'?: { 'SoundBarReleaseFragment': SoundBarReleaseFragment } }, firstNftOwned: { id: string, updatedAt: string } | null } & { ' $fragmentName'?: 'CollectorFeaturedReleaseFragment' };

export type ArtistHeroFragment = { id: string, bannerImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'ArtistHeroFragment' };

export type CollectorHeroFragment = { id: string, bannerImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'CollectorHeroFragment' };

export type AboutSectionFragment = { id: string, username: string, createdAt: string, description: string | null, artist: { id: string, name: string } | null, location: { label: string, placeId: string } | null } & { ' $fragmentName'?: 'AboutSectionFragment' };

export type UserSoundCollectionFragment = (
  { id: string, shelvesCount: number, artist: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ArtistAppearsOnFragment': ArtistAppearsOnFragment;'ReleasesCarouselInfoFragment': ReleasesCarouselInfoFragment } }
  ) | null, likedSounds: { id: string, releaseCount: number } | null }
  & { ' $fragmentRefs'?: { 'UserInfoSectionFragment': UserInfoSectionFragment;'CollectionCarouselFragment': CollectionCarouselFragment;'CollectorAppearsOnFragment': CollectorAppearsOnFragment;'PlaylistsCarouselUserInfoFragment': PlaylistsCarouselUserInfoFragment;'SeeAllUserInfoFragment': SeeAllUserInfoFragment } }
) & { ' $fragmentName'?: 'UserSoundCollectionFragment' };

export type UserInfoSectionFragment = (
  { id: string, username: string, instagramHandle: string | null, twitterHandle: string | null, tiktokUrl: string | null, publicAddress: string, webappUri: string, followerCount: number, topCollectorPosition: number | null, invitedByUser: { ' $fragmentRefs'?: { 'InvitedUserByFragment': InvitedUserByFragment } } | null, artist: { id: string, name: string, spotifyUrl: string | null } | null, avatar: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'CollectorActionBarFragment': CollectorActionBarFragment;'UserStatsFragment': UserStatsFragment;'ArtistActionBarFragment': ArtistActionBarFragment } }
) & { ' $fragmentName'?: 'UserInfoSectionFragment' };

export type InvitedUserByFragment = { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'InvitedUserByFragment' };

export type UserStatsFragment = (
  { id: string, followerCount: number, followingCount: number, numBackedArtists: number, nftsOwned: number, artist: (
    { id: string, numCollectors: number, numNfts: number }
    & { ' $fragmentRefs'?: { 'ArtistCollectorsMintInfoFragment': ArtistCollectorsMintInfoFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'FollowersFollowingModalFragment': FollowersFollowingModalFragment;'CollectedUserStatModalFragment': CollectedUserStatModalFragment;'UserArtistBackedInfoFragment': UserArtistBackedInfoFragment } }
) & { ' $fragmentName'?: 'UserStatsFragment' };

export type UserTopFollowersQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UserTopFollowersQuery = { userTopFollowers: Array<{ id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null }> };

export type RecommendedFollowsUserCellFragment = (
  { id: string, webappUri: string, publicAddress: string, username: string, followerCount: number, avatar: { id: string, url: string } | null, artist: { id: string } | null }
  & { ' $fragmentRefs'?: { 'FollowersFollowingModalFragment': FollowersFollowingModalFragment } }
) & { ' $fragmentName'?: 'RecommendedFollowsUserCellFragment' };

export type SearchHistoryReleaseQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type SearchHistoryReleaseQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'SearchResultReleaseFragment': SearchResultReleaseFragment } }
  ) | null };

export type SearchHistoryArtistQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type SearchHistoryArtistQuery = { artist: (
    { id: string }
    & { ' $fragmentRefs'?: { 'SearchResultArtistFragment': SearchResultArtistFragment } }
  ) | null };

export type SearchHistoryPlaylistQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type SearchHistoryPlaylistQuery = { shelf: (
    { id: string }
    & { ' $fragmentRefs'?: { 'SearchResultShelfFragment': SearchResultShelfFragment } }
  ) | null };

export type SearchHistoryCollectorQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type SearchHistoryCollectorQuery = { user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'SearchResultCollectorFragment': SearchResultCollectorFragment } }
  ) | null };

export type InitialPrimarySearchResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type InitialPrimarySearchResultsQuery = { releases: { edges: Array<{ node: { ' $fragmentRefs'?: { 'SearchResultReleaseFragment': SearchResultReleaseFragment } } }> }, artists: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'SearchResultArtistFragment': SearchResultArtistFragment } }
      ) }> }, allCollectors: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'SearchResultCollectorFragment': SearchResultCollectorFragment } }
      ) }> }, allShelves: { edges: Array<{ node: { ' $fragmentRefs'?: { 'SearchResultShelfFragment': SearchResultShelfFragment } } }> } };

export type PrimarySearchResultsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type PrimarySearchResultsQuery = { search: { id: string, releasesPaginated: { edges: Array<{ node: { ' $fragmentRefs'?: { 'SearchResultReleaseFragment': SearchResultReleaseFragment } } }> }, artistsPaginated: { edges: Array<{ node: { ' $fragmentRefs'?: { 'SearchResultArtistFragment': SearchResultArtistFragment } } }> }, shelves: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'SearchResultShelfFragment': SearchResultShelfFragment } }
        ) }> }, collectors: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'SearchResultCollectorFragment': SearchResultCollectorFragment } }
        ) }> } } };

export type SearchResultReleaseFragment = (
  { id: string, title: string, webappUri: string, mintStartTimestamp: number, quantityUpperBound: number, quantityLowerBound: number, supplyCutoffTimestamp: number | null, finalQuantity: number | null, track: { id: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, artist: { id: string, name: string, soundHandle: string } }
  & { ' $fragmentRefs'?: { 'ReleaseCardActionsFragment': ReleaseCardActionsFragment;'ReleasesCardInfoFragment': ReleasesCardInfoFragment;'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
) & { ' $fragmentName'?: 'SearchResultReleaseFragment' };

export type SearchResultArtistFragment = { id: string, name: string, webappUri: string, user: { id: string, publicAddress: string, avatar: { id: string, url: string, dominantColor: string | null } | null } } & { ' $fragmentName'?: 'SearchResultArtistFragment' };

export type SearchResultShelfFragment = (
  { id: string, name: string, webappUri: string, coverReleases: Array<{ id: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null }>, user: (
    { id: string, username: string, artist: { id: string } | null }
    & { ' $fragmentRefs'?: { 'ShelfCreatorFragment': ShelfCreatorFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'PlaylistCardDetailsFragment': PlaylistCardDetailsFragment;'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment } }
) & { ' $fragmentName'?: 'SearchResultShelfFragment' };

export type SearchResultCollectorFragment = { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string, dominantColor: string | null } | null } & { ' $fragmentName'?: 'SearchResultCollectorFragment' };

export type SetupProfileDisplayNameMutationVariables = Exact<{
  displayName: Scalars['String'];
}>;


export type SetupProfileDisplayNameMutation = { setUserDisplayName: { __typename: 'MutationSetUserDisplayNameSuccess', data: { id: string, displayName: string | null } } | { __typename: 'ValidationError', message: string } };

export type ReleaseShareImageInfoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReleaseShareImageInfoQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleaseShareImageInfoFragment': ReleaseShareImageInfoFragment } }
  ) | null };

export type ReleaseShareImageInfoFragment = { id: string, webappUri: string, title: string, publicMintStart: string, artist: { id: string, name: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'ReleaseShareImageInfoFragment' };

type ActivityReleaseAction_Airdrop_Fragment = { __typename: 'Airdrop', id: string, date: string, user: { id: string } } & { ' $fragmentName'?: 'ActivityReleaseAction_Airdrop_Fragment' };

type ActivityReleaseAction_BondingCurveSale_Fragment = (
  { __typename: 'BondingCurveSale', id: string, date: string, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedBondingCurveSaleFragment': ReleaseFeedBondingCurveSaleFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_BondingCurveSale_Fragment' };

type ActivityReleaseAction_BondingCurveSold_Fragment = (
  { __typename: 'BondingCurveSold', id: string, date: string, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedBondingCurveSoldFragment': ReleaseFeedBondingCurveSoldFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_BondingCurveSold_Fragment' };

type ActivityReleaseAction_CreatedPost_Fragment = (
  { __typename: 'CreatedPost', id: string, date: string, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseCreatedPostFragment': ReleaseCreatedPostFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_CreatedPost_Fragment' };

type ActivityReleaseAction_PlaylistCreated_Fragment = { __typename: 'PlaylistCreated', id: string, date: string, playlist: (
    { id: string, name: string }
    & { ' $fragmentRefs'?: { 'PlaylistActivityInfoFragment': PlaylistActivityInfoFragment } }
  ) | null, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ActivityReleaseAction_PlaylistCreated_Fragment' };

type ActivityReleaseAction_PrimarySale_Fragment = (
  { __typename: 'PrimarySale', id: string, date: string, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedPrimarySaleFragment': ReleaseFeedPrimarySaleFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_PrimarySale_Fragment' };

type ActivityReleaseAction_ReleaseDropped_Fragment = (
  { __typename: 'ReleaseDropped', id: string, date: string, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedReleaseDroppedFragment': ReleaseFeedReleaseDroppedFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_ReleaseDropped_Fragment' };

type ActivityReleaseAction_ReleaseLiked_Fragment = (
  { __typename: 'ReleaseLiked', id: string, date: string, release: { id: string }, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedReleaseLikedFragment': ReleaseFeedReleaseLikedFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_ReleaseLiked_Fragment' };

type ActivityReleaseAction_ReleasesAddedRemovedFromPlaylist_Fragment = { __typename: 'ReleasesAddedRemovedFromPlaylist', id: string, date: string, numAddedReleases: number, numRemovedReleases: number, playlist: (
    { id: string }
    & { ' $fragmentRefs'?: { 'PlaylistActivityInfoFragment': PlaylistActivityInfoFragment } }
  ) | null, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) } & { ' $fragmentName'?: 'ActivityReleaseAction_ReleasesAddedRemovedFromPlaylist_Fragment' };

type ActivityReleaseAction_ReleasesAddedToPlaylist_Fragment = (
  { __typename: 'ReleasesAddedToPlaylist', id: string, date: string, playlist: { id: string } | null, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedReleasesAddedFragment': ReleaseFeedReleasesAddedFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_ReleasesAddedToPlaylist_Fragment' };

type ActivityReleaseAction_SecondarySale_Fragment = (
  { __typename: 'SecondarySale', id: string, date: string, purchasedFromUser: { id: string }, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedSecondarySaleFragment': ReleaseFeedSecondarySaleFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_SecondarySale_Fragment' };

type ActivityReleaseAction_UserPresavedRelease_Fragment = (
  { __typename: 'UserPresavedRelease', id: string, date: string, user: { id: string } }
  & { ' $fragmentRefs'?: { 'ReleaseFeedReleasePresavedFragment': ReleaseFeedReleasePresavedFragment } }
) & { ' $fragmentName'?: 'ActivityReleaseAction_UserPresavedRelease_Fragment' };

export type ActivityReleaseActionFragment = ActivityReleaseAction_Airdrop_Fragment | ActivityReleaseAction_BondingCurveSale_Fragment | ActivityReleaseAction_BondingCurveSold_Fragment | ActivityReleaseAction_CreatedPost_Fragment | ActivityReleaseAction_PlaylistCreated_Fragment | ActivityReleaseAction_PrimarySale_Fragment | ActivityReleaseAction_ReleaseDropped_Fragment | ActivityReleaseAction_ReleaseLiked_Fragment | ActivityReleaseAction_ReleasesAddedRemovedFromPlaylist_Fragment | ActivityReleaseAction_ReleasesAddedToPlaylist_Fragment | ActivityReleaseAction_SecondarySale_Fragment | ActivityReleaseAction_UserPresavedRelease_Fragment;

export type ReleaseActivityFeedHookQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
  filter?: InputMaybe<ReleaseActivityFeedFilterArgs>;
}>;


export type ReleaseActivityFeedHookQuery = { releaseActivityFeed: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
        { __typename: 'Airdrop', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_Airdrop_Fragment': ActivityReleaseAction_Airdrop_Fragment } }
      ) | (
        { __typename: 'BondingCurveSale', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_BondingCurveSale_Fragment': ActivityReleaseAction_BondingCurveSale_Fragment } }
      ) | (
        { __typename: 'BondingCurveSold', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_BondingCurveSold_Fragment': ActivityReleaseAction_BondingCurveSold_Fragment } }
      ) | (
        { __typename: 'CreatedPost', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_CreatedPost_Fragment': ActivityReleaseAction_CreatedPost_Fragment } }
      ) | (
        { __typename: 'PlaylistCreated', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_PlaylistCreated_Fragment': ActivityReleaseAction_PlaylistCreated_Fragment } }
      ) | (
        { __typename: 'PrimarySale', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_PrimarySale_Fragment': ActivityReleaseAction_PrimarySale_Fragment } }
      ) | (
        { __typename: 'ReleaseDropped', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleaseDropped_Fragment': ActivityReleaseAction_ReleaseDropped_Fragment } }
      ) | (
        { __typename: 'ReleaseLiked', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleaseLiked_Fragment': ActivityReleaseAction_ReleaseLiked_Fragment } }
      ) | (
        { __typename: 'ReleasesAddedRemovedFromPlaylist', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleasesAddedRemovedFromPlaylist_Fragment': ActivityReleaseAction_ReleasesAddedRemovedFromPlaylist_Fragment } }
      ) | (
        { __typename: 'ReleasesAddedToPlaylist', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_ReleasesAddedToPlaylist_Fragment': ActivityReleaseAction_ReleasesAddedToPlaylist_Fragment } }
      ) | (
        { __typename: 'SecondarySale', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_SecondarySale_Fragment': ActivityReleaseAction_SecondarySale_Fragment } }
      ) | (
        { __typename: 'UserPresavedRelease', id: string, date: string, user: { id: string } }
        & { ' $fragmentRefs'?: { 'ActivityReleaseAction_UserPresavedRelease_Fragment': ActivityReleaseAction_UserPresavedRelease_Fragment } }
      ) }> } };

export type HighlightedCollectorFragment = { id: string, volumeSpent: string, firstNftCollectedDate: string, user: { username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null } } & { ' $fragmentName'?: 'HighlightedCollectorFragment' };

export type HighlightedAudienceFragment = { id: string, earliestCollector: (
    { id: string }
    & { ' $fragmentRefs'?: { 'HighlightedCollectorFragment': HighlightedCollectorFragment } }
  ) | null, topSpentCollector: (
    { id: string }
    & { ' $fragmentRefs'?: { 'HighlightedCollectorFragment': HighlightedCollectorFragment } }
  ) | null, latestCollector: (
    { id: string }
    & { ' $fragmentRefs'?: { 'HighlightedCollectorFragment': HighlightedCollectorFragment } }
  ) | null } & { ' $fragmentName'?: 'HighlightedAudienceFragment' };

export type TopCommentCardFragment = { id: string, nftsCount: number, gaNftsCount: number, vipNftsCount: number, firstNftCollectedDate: string, user: { id: string, username: string, publicAddress: string, webappUri: string, artist: { id: string } | null, avatar: { id: string, url: string } | null }, mostRecentNftWithComment: { id: string, comment: { id: string, message: string } | null } | null } & { ' $fragmentName'?: 'TopCommentCardFragment' };

export type AudienceSongInfoFragment = (
  { id: string, numSold: number, auctionContractType: ContractType | null }
  & { ' $fragmentRefs'?: { 'ReleaseUpdatesFragment': ReleaseUpdatesFragment;'EmptyAudienceFragment': EmptyAudienceFragment;'HighlightedAudienceFragment': HighlightedAudienceFragment } }
) & { ' $fragmentName'?: 'AudienceSongInfoFragment' };

export type TopAudienceSeatFragment = (
  { id: string, vipNftsCount: number, user: { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null }, ownedGoldenEgg: { id: string } | null }
  & { ' $fragmentRefs'?: { 'TopCommentCardFragment': TopCommentCardFragment } }
) & { ' $fragmentName'?: 'TopAudienceSeatFragment' };

export type EmptyAudienceFragment = { id: string, mintStartTimestamp: number, artist: { id: string, userId: string }, listing: { id: string, tiers: Array<{ id: string, tierNumber: number, totalMinted: number }> } | null } & { ' $fragmentName'?: 'EmptyAudienceFragment' };

export type ReleaseBackersCsvUrlQueryVariables = Exact<{
  releaseId: Scalars['String'];
}>;


export type ReleaseBackersCsvUrlQuery = { releaseBackersCSVUrl: string | null };

export type AudienceQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  pagination: ReleaseCollectorCursorConnectionArgs;
}>;


export type AudienceQuery = { release: { id: string, collectors: { edges: Array<{ node: (
          { id: string, nftsCount: number, vipNftsCount: number, gaNftsCount: number, lowestNftSerialNumber: number, user: { id: string, publicAddress: string } }
          & { ' $fragmentRefs'?: { 'TopAudienceSeatFragment': TopAudienceSeatFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type DraftBehindTheMusicSectionFragment = { id: string, artist: { id: string, name: string }, info: { releaseInfo: { behindTheMusic: string, title: string } | null } | null } & { ' $fragmentName'?: 'DraftBehindTheMusicSectionFragment' };

export type BehindTheMusicSectionFragment = { id: string, behindTheMusic: string, artist: { id: string, name: string, user: (
      { id: string, followerCount: number }
      & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment;'FollowersModalFragment': FollowersModalFragment } }
    ) } } & { ' $fragmentName'?: 'BehindTheMusicSectionFragment' };

export type CollectorCommentsQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  pagination: CollectorCommentCursorConnectionArgs;
}>;


export type CollectorCommentsQuery = { release: { id: string, collectorComments: { edges: Array<{ node: { id: string, normalizedSongSlot: number, postComment: { id: string, content: string, lexicalContent: unknown | null, createdAt: string, upvoteCount: number, repliesCount: number, currentHolderOfRelease: boolean, author: (
              { id: string }
              & { ' $fragmentRefs'?: { 'CommentAuthorFragment': CommentAuthorFragment } }
            ), post: { __typename: 'ActivityFeedGroupBackingPost', id: string } | { __typename: 'ArtistDropPost', id: string } | { __typename: 'PlaylistPost', id: string } | { __typename: 'ReleasePost', id: string } | { __typename: 'Repost', id: string } }, nft: { id: string } } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type MoreFromArtistCarouselInfoFragment = { id: string, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'CarouselUserInfoFragment': CarouselUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'MoreFromArtistCarouselInfoFragment' };

export type MoreFromArtistCarouselQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination?: InputMaybe<CursorConnectionArgs>;
  filter?: InputMaybe<ArtistReleasesFilter>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type MoreFromArtistCarouselQuery = { artist: { id: string, releases: { edges: Array<{ node: (
          { id: string, track: { id: string } }
          & { ' $fragmentRefs'?: { 'ReleaseInfoCardFragment': ReleaseInfoCardFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type PreviewSongPageDraftQueryVariables = Exact<{
  draftId: Scalars['UUID'];
}>;


export type PreviewSongPageDraftQuery = { draft: (
    { id: string, artist: { id: string, name: string, user: { id: string, twitterHandle: string | null } }, release: { id: string, contractAddress: string, chainId: number, type: ReleaseType } | null, info: { releaseInfo: { title: string, behindTheMusic: string, coverImage: { mediaType: MediaType, uploadKey: string }, staticCoverImage: { mediaType: MediaType, uploadKey: string } | null } | null, auctionConfigurations: { auctionType: AuctionType, minQuantity: number, publicMint: { startTime: number, quantity: number, price: number } } | null, splitsInfo: { splits: Array<{ ownerAddress: string, percent: number, roles: Array<CreditRoleType> }> } | null } | null }
    & { ' $fragmentRefs'?: { 'DraftSongHeroFragment': DraftSongHeroFragment;'DraftBehindTheMusicSectionFragment': DraftBehindTheMusicSectionFragment;'DraftRewardsSongInfoFragment': DraftRewardsSongInfoFragment } }
  ) };

export type DraftSongHeroFragment = (
  { id: string, artist: { id: string, name: string, webappUri: string }, info: { releaseInfo: { title: string, tokenSymbol: string, genre: string, type: string, behindTheMusic: string, beatsPerMinute: number | null, lyrics: string | null, key: SongKeyType | null, license: LicenseType | null, location: string | null, tracks: Array<{ title: string, normalizedPeaks: Array<number>, duration: number, fileDetail: { mediaType: MediaType, uploadKey: string }, coverImage: { mediaType: MediaType, uploadKey: string } | null }>, coverImage: { mediaType: MediaType, uploadKey: string }, staticCoverImage: { mediaType: MediaType, uploadKey: string } | null } | null } | null }
  & { ' $fragmentRefs'?: { 'DraftWaveformInfoFragment': DraftWaveformInfoFragment;'DraftSongHeroCoverImagesFragment': DraftSongHeroCoverImagesFragment;'DraftHeroDetailsFragment': DraftHeroDetailsFragment } }
) & { ' $fragmentName'?: 'DraftSongHeroFragment' };

export type DraftSongHeroCoverImagesFragment = { id: string, artist: { id: string, name: string }, info: { releaseInfo: { title: string, tokenSymbol: string, coverImage: { mediaType: MediaType, uploadKey: string } } | null } | null } & { ' $fragmentName'?: 'DraftSongHeroCoverImagesFragment' };

export type GoldenEggCoverBadgeFragment = { id: string, goldenEggNft: { id: string, serialNumber: number, owner: { id: string, username: string, webappUri: string } } | null } & { ' $fragmentName'?: 'GoldenEggCoverBadgeFragment' };

export type SongHeroFragment = (
  { id: string, title: string, type: ReleaseType, mintStartTimestamp: number, listeningParty: number | null, spotifyPresaveCampaign: boolean, artist: { id: string, name: string, webappUri: string, user: { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } } }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, track: { id: string, duration: number, normalizedPeaks: Array<number> }, goldenEggImage: { id: string, url: string }, animatedGoldenEggImageOptimized: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'WaveformWithCommentsFragment': WaveformWithCommentsFragment;'SongHeroCoverImagesFragment': SongHeroCoverImagesFragment;'GoldenEggCoverBadgeFragment': GoldenEggCoverBadgeFragment;'SongHeroDetailsFragment': SongHeroDetailsFragment } }
) & { ' $fragmentName'?: 'SongHeroFragment' };

export type SongHeroCoverImagesFragment = (
  { id: string, title: string, artist: { id: string, name: string, webappUri: string }, coverImage: { id: string, url: string }, animatedCoverImage: { id: string, url: string } | null, goldenEggImage: { id: string, url: string }, animatedGoldenEggImageOptimized: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'GoldenEggCoverBadgeFragment': GoldenEggCoverBadgeFragment } }
) & { ' $fragmentName'?: 'SongHeroCoverImagesFragment' };

export type SongHeroDetailsFragment = (
  { id: string, totalMinted: number, artist: { id: string, user: { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } } }, track: { id: string, duration: number } }
  & { ' $fragmentRefs'?: { 'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
) & { ' $fragmentName'?: 'SongHeroDetailsFragment' };

export type DraftHeroDetailsFragment = { id: string, artist: { id: string, user: { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } } }, info: { releaseInfo: { tracks: Array<{ duration: number }> } | null } | null } & { ' $fragmentName'?: 'DraftHeroDetailsFragment' };

export type BondingCurveMintComponentFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'SamCollectInfoFragment': SamCollectInfoFragment;'SamSellInfoFragment': SamSellInfoFragment } }
) & { ' $fragmentName'?: 'BondingCurveMintComponentFragment' };

export type SamSaleInfoFragment = { id: string, samBuyBufferBpsOverride: number | null, samSellBufferBpsOverride: number | null, samConfig: { id: string, affiliateFeeBPS: number, artistFeeBPS: number, basePrice: string, buyFreezeTime: number, goldenEggFeeBPS: number, inflectionPoint: number, inflectionPrice: string, maxSupply: number, platformFeeBPS: number, platformPerTxFlatFee: string } | null, saleDetails: { soundSwapCollected: number } } & { ' $fragmentName'?: 'SamSaleInfoFragment' };

export type SamCollectInfoFragment = (
  { id: string, chainId: number, contractAddress: string, samAddress: string | null, samConfig: { maxSupply: number, buyFreezeTime: number } | null }
  & { ' $fragmentRefs'?: { 'BuyEditionSongDetailsFragment': BuyEditionSongDetailsFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'ReleaseUpdatesFragment': ReleaseUpdatesFragment;'SamSaleInfoFragment': SamSaleInfoFragment;'ReleaseDetailsFragment': ReleaseDetailsFragment } }
) & { ' $fragmentName'?: 'SamCollectInfoFragment' };

export type BondingCurveSaleDetailsInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
) & { ' $fragmentName'?: 'BondingCurveSaleDetailsInfoFragment' };

export type SamSellInfoFragment = { id: string, chainId: number, contractAddress: string, samSellBufferBpsOverride: number | null, samConfig: { id: string, basePrice: string, inflectionPoint: number, inflectionPrice: string } | null, saleDetails: { soundSwapCollected: number } } & { ' $fragmentName'?: 'SamSellInfoFragment' };

export type BondingCurveMintDataFragment = (
  { id: string, chainId: number, contractAddress: string, samAddress: string | null, goldenEggNft: { id: string, owner: { id: string } } | null }
  & { ' $fragmentRefs'?: { 'BondingCurveMintComponentFragment': BondingCurveMintComponentFragment;'BondingCurveSaleDetailsInfoFragment': BondingCurveSaleDetailsInfoFragment } }
) & { ' $fragmentName'?: 'BondingCurveMintDataFragment' };

export type RegularMintInfoFragment = (
  { id: string, type: ReleaseType, contractAddress: string, auctionContractType: ContractType | null, title: string, chainId: number, finalQuantity: number | null, price: string, marketPlaceUrl: string | null, samAddress: string | null }
  & { ' $fragmentRefs'?: { 'CheckoutReleaseInfoFragment': CheckoutReleaseInfoFragment;'MarketplaceCheckoutFragment': MarketplaceCheckoutFragment;'ReleaseUpdatesFragment': ReleaseUpdatesFragment;'MintDataContractsFragment': MintDataContractsFragment } }
) & { ' $fragmentName'?: 'RegularMintInfoFragment' };

export type ReleaseMintDataSubscribeSubscriptionVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type ReleaseMintDataSubscribeSubscription = { releaseUpdates: { id: string, numSold: number, isFirstPhaseCompleted: boolean } };

export type MintDataContractsFragment = { id: string, price: string, chainId: number, numSold: number, type: ReleaseType, mintStartTime: number, samAddress: string | null, airdropCount: number, isFirstPhaseCompleted: boolean, auctionContractType: ContractType | null, contractAddress: string, quantityLowerBound: number, quantityUpperBound: number, supplyCutoffTimestamp: number | null, scheduleIds: Array<{ minterAddress: string, mintIds: Array<number> }> | null } & { ' $fragmentName'?: 'MintDataContractsFragment' };

export type GetLegacySongSaleScheduleQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type GetLegacySongSaleScheduleQuery = { release: { id: string, saleSchedules: Array<{ id: string, isPresale: boolean, artistContractTotalMinted: number | null, maxMintable: number, startTime: string, endTime: string, price: string }> } | null };

export type TiersMintComponentFragment = (
  { id: string, auctionContractType: ContractType | null, chainId: number, contractAddress: string, finalQuantity: number | null, marketPlaceUrl: string | null, spotifyPresaveCampaign: boolean, spotifyPresaveCount: number, title: string, type: ReleaseType }
  & { ' $fragmentRefs'?: { 'TiersCheckoutReleaseInfoFragment': TiersCheckoutReleaseInfoFragment;'MarketplaceCheckoutFragment': MarketplaceCheckoutFragment } }
) & { ' $fragmentName'?: 'TiersMintComponentFragment' };

export type MintComponentFragment = (
  { id: string, auctionContractType: ContractType | null, chainId: number, samAddress: string | null }
  & { ' $fragmentRefs'?: { 'MintComponentSongInfoFragment': MintComponentSongInfoFragment;'RegularMintInfoFragment': RegularMintInfoFragment;'BondingCurveMintDataFragment': BondingCurveMintDataFragment;'TiersMintComponentFragment': TiersMintComponentFragment;'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
) & { ' $fragmentName'?: 'MintComponentFragment' };

export type MintComponentSocialProofQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type MintComponentSocialProofQuery = { release: (
    { id: string, socialProofCollectors: Array<{ id: string, publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null }> }
    & { ' $fragmentRefs'?: { 'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
  ) | null };

export type MintComponentSongInfoFragment = { id: string, title: string, webappUri: string, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string }, artist: { id: string, userId: string, webappUri: string, name: string } } & { ' $fragmentName'?: 'MintComponentSongInfoFragment' };

export type PeopleAlsoCollectedCarouselQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type PeopleAlsoCollectedCarouselQuery = { releasesCollectorsAlsoMinted: Array<(
    { id: string, track: { id: string } }
    & { ' $fragmentRefs'?: { 'ReleaseInfoCardFragment': ReleaseInfoCardFragment } }
  )> };

export type DraftRewardSongInfoFragment = { title: string, description: string } & { ' $fragmentName'?: 'DraftRewardSongInfoFragment' };

export type DraftRewardsSongInfoFragment = { id: string, info: { rewardsInfo: { canCollectorsDownloadAudio: boolean, rewards: Array<{ ' $fragmentRefs'?: { 'DraftRewardSongInfoFragment': DraftRewardSongInfoFragment } }>, goldenEggImages: Array<{ mediaType: MediaType, uploadKey: string }> } | null } | null } & { ' $fragmentName'?: 'DraftRewardsSongInfoFragment' };

export type RewardSongInfoFragment = { id: string, title: string, description: string } & { ' $fragmentName'?: 'RewardSongInfoFragment' };

export type GoldenEggWinnerFragment = { id: string, publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'GoldenEggWinnerFragment' };

export type AudioRewardCardFragment = { id: string, track: { id: string } } & { ' $fragmentName'?: 'AudioRewardCardFragment' };

export type AudioRewardDownloadableUrlQueryVariables = Exact<{
  trackId: Scalars['UUID'];
}>;


export type AudioRewardDownloadableUrlQuery = { downloadableTrackURLForAudioReward: string | null };

export type RewardsSongInfoFragment = (
  { id: string, canCollectorsDownloadAudio: boolean, auctionContractType: ContractType | null, rewards: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'RewardSongInfoFragment': RewardSongInfoFragment } }
  )>, goldenEggNft: { id: string, owner: (
      { id: string }
      & { ' $fragmentRefs'?: { 'GoldenEggWinnerFragment': GoldenEggWinnerFragment } }
    ) } | null }
  & { ' $fragmentRefs'?: { 'AudioRewardCardFragment': AudioRewardCardFragment } }
) & { ' $fragmentName'?: 'RewardsSongInfoFragment' };

export type ReleaseShareAndEarnFragment = (
  { id: string, publicAffiliateFeePercent: string | null, samConfig: { id: string, affiliateFeePercent: string } | null }
  & { ' $fragmentRefs'?: { 'ReleaseUpdatesFragment': ReleaseUpdatesFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
) & { ' $fragmentName'?: 'ReleaseShareAndEarnFragment' };

export type UserByAddressQueryVariables = Exact<{
  publicAddress?: InputMaybe<Scalars['Address']>;
}>;


export type UserByAddressQuery = { userByAddress: { id: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } | null };

export type SongViewFragment = (
  { id: string, contractAddress: string, draftId: string | null, type: ReleaseType, titleSlug: string, auctionContractType: ContractType | null, listeningParty: number | null, royaltyBps: number, collectorsCount: number, totalMinted: number, mintStartTime: number, mintStartTimestamp: number, chainId: number, canCollectorsDownloadAudio: boolean, listing: { royaltyBPS: number } | null, vipCoverImage: { id: string } | null, track: { id: string, duration: number }, saleDetails: { totalVolume: string }, artist: (
    { id: string, userId: string, soundHandle: string }
    & { ' $fragmentRefs'?: { 'MoreFromArtistCarouselInfoFragment': MoreFromArtistCarouselInfoFragment } }
  ), creditSplit: { id: string, splitAddress: string | null, creditAllocations: Array<{ id: string, roles: Array<string>, percent: number, owner: { id: string, username: string, publicAddress: string, webappUri: string, artist: { id: string } | null, avatar: { id: string, url: string } | null } }> } | null }
  & { ' $fragmentRefs'?: { 'SongHeroFragment': SongHeroFragment;'BehindTheMusicSectionFragment': BehindTheMusicSectionFragment;'AudienceSongInfoFragment': AudienceSongInfoFragment;'RewardsSongInfoFragment': RewardsSongInfoFragment;'ReleaseShareAndEarnFragment': ReleaseShareAndEarnFragment;'WaveformExpandedPlayerInfoFragment': WaveformExpandedPlayerInfoFragment;'MintComponentFragment': MintComponentFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'CollectModalFragment': CollectModalFragment;'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment } }
) & { ' $fragmentName'?: 'SongViewFragment' };

export type CollectionCardFragment = { id: string, vipNftsCount: number, gaNftsCount: number, ownedTokens: Array<{ isGoldenEgg: boolean, serialNumber: number, tierNumber: number | null }> | null, release: (
    { id: string, goldenEggNft: { id: string, serialNumber: number, owner: { id: string } } | null, goldenEggImage: { id: string, url: string }, animatedGoldenEggImageOptimized: { id: string, url: string } | null, vipCoverImage: { id: string, url: string } | null, staticVipCoverImage: { id: string, url: string } | null, gaCoverImage: { id: string, url: string } | null, staticGaCoverImage: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'ReleaseCardActionsFragment': ReleaseCardActionsFragment;'ReleasesCardInfoFragment': ReleasesCardInfoFragment } }
  ) } & { ' $fragmentName'?: 'CollectionCardFragment' };

export type CollectorCardUserInfoFragment = { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'CollectorCardUserInfoFragment' };

export type CollectorCardFragment = (
  { id: string, supplyCutoffTimestamp: number | null, quantityUpperBound: number, quantityLowerBound: number, mintStartTimestamp: number }
  & { ' $fragmentRefs'?: { 'ReleasesCardInfoFragment': ReleasesCardInfoFragment;'ReleaseCardActionsFragment': ReleaseCardActionsFragment;'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
) & { ' $fragmentName'?: 'CollectorCardFragment' };

export type PurchaseCardCollectedByUserFragment = { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } & { ' $fragmentName'?: 'PurchaseCardCollectedByUserFragment' };

export type NftSaleInfoFragment = { amountPaidInWei: string, totalUsersPurchasedFrom: number, totalOwnedEditions: number, mostRecentPurchasedFromUser: { id: string, publicAddress: string, webappUri: string, username: string, artist: { id: string } | null, avatar: { id: string, url: string } | null } } & { ' $fragmentName'?: 'NftSaleInfoFragment' };

export type PurchaseCardFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'ReleasesCardInfoFragment': ReleasesCardInfoFragment;'ReleaseCardActionsFragment': ReleaseCardActionsFragment;'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
) & { ' $fragmentName'?: 'PurchaseCardFragment' };

export type ReleaseCardActionsFragment = (
  { id: string, type: ReleaseType }
  & { ' $fragmentRefs'?: { 'SongCardDropdownInfoFragment': SongCardDropdownInfoFragment } }
) & { ' $fragmentName'?: 'ReleaseCardActionsFragment' };

export type ReleaseInfoCardFragment = (
  { id: string, quantityLowerBound: number, quantityUpperBound: number, supplyCutoffTimestamp: number | null, mintStartTimestamp: number, listeningParty: number | null, track: { id: string }, socialProofCollectors: Array<{ ' $fragmentRefs'?: { 'PurchaseCardCollectedByUserFragment': PurchaseCardCollectedByUserFragment } }> }
  & { ' $fragmentRefs'?: { 'ReleaseCardActionsFragment': ReleaseCardActionsFragment;'ReleasesCardInfoFragment': ReleasesCardInfoFragment;'ReleaseUpdatesFragment': ReleaseUpdatesFragment } }
) & { ' $fragmentName'?: 'ReleaseInfoCardFragment' };

export type ReleasesCardFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'ReleaseCardActionsFragment': ReleaseCardActionsFragment;'ReleasesCardInfoFragment': ReleasesCardInfoFragment } }
) & { ' $fragmentName'?: 'ReleasesCardFragment' };

export type UpcomingDropCardFragment = (
  { id: string, supplyCutoffTimestamp: number | null, mintStartTimestamp: number, listeningParty: number | null, spotifyPresaveCampaign: boolean, coverImage: { id: string, url: string } }
  & { ' $fragmentRefs'?: { 'ReleaseCardActionsFragment': ReleaseCardActionsFragment;'ReleasesCardInfoFragment': ReleasesCardInfoFragment } }
) & { ' $fragmentName'?: 'UpcomingDropCardFragment' };

export type SongCardDropdownInfoFragment = (
  { id: string, type: ReleaseType, listeningParty: number | null, webappUri: string, track: { id: string } }
  & { ' $fragmentRefs'?: { 'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment;'GiftingModalFragment': GiftingModalFragment } }
) & { ' $fragmentName'?: 'SongCardDropdownInfoFragment' };

export type ReleasesCardInfoFragment = { id: string, type: ReleaseType, externalUrl: string | null, title: string, webappUri: string, listeningParty: number | null, artist: { id: string, name: string, webappUri: string, userId: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, track: { id: string } } & { ' $fragmentName'?: 'ReleasesCardInfoFragment' };

export type SoundBarReleaseFragment = (
  { id: string, title: string, type: ReleaseType, listeningParty: number | null, totalMinted: number, mintStartTimestamp: number, webappUri: string, spotifyPresaveCampaign: boolean, artist: { id: string, name: string, webappUri: string, user: { id: string } }, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string, dominantColor: string | null }, track: { id: string, normalizedPeaks: Array<number>, duration: number }, goldenEggNft: { id: string, owner: { id: string } } | null }
  & { ' $fragmentRefs'?: { 'WaveformNoCommentsFragment': WaveformNoCommentsFragment;'CollectModalFragment': CollectModalFragment;'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
) & { ' $fragmentName'?: 'SoundBarReleaseFragment' };

export type PresaveSpotifyReleaseMutationVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type PresaveSpotifyReleaseMutation = { presaveRelease: { __typename: 'AuthorizationError', message: string } | { __typename: 'MutationPresaveReleaseSuccess' } | { __typename: 'NotFoundError', message: string } };

export type TrendingRecommendedFollowsQueryVariables = Exact<{ [key: string]: never; }>;


export type TrendingRecommendedFollowsQuery = { trendingPostsRecommendedFollows: Array<{ ' $fragmentRefs'?: { 'RecommendedFollowsUserCellFragment': RecommendedFollowsUserCellFragment } }> };

export type DraftWaveformInfoFragment = { info: { releaseInfo: { tracks: Array<{ duration: number, normalizedPeaks: Array<number>, fileDetail: { uploadKey: string } }> } | null } | null } & { ' $fragmentName'?: 'DraftWaveformInfoFragment' };

export type WaveformWithCommentsFragment = (
  { id: string, listeningParty: number | null, track: { id: string, normalizedPeaks: Array<number>, duration: number } }
  & { ' $fragmentRefs'?: { 'WaveformCommentsReleaseInfoFragment': WaveformCommentsReleaseInfoFragment } }
) & { ' $fragmentName'?: 'WaveformWithCommentsFragment' };

export type WaveformNoCommentsFragment = { id: string, listeningParty: number | null, track: { id: string, normalizedPeaks: Array<number>, duration: number } } & { ' $fragmentName'?: 'WaveformNoCommentsFragment' };

export type WaveformCommentInfoFragment = { id: string, songSlot: number, avatarUrl: string | null, ownerPublicAddress: string, ownerWebappUri: string, ownerArtistName: string | null, ownerUsername: string, updatedAt: number, serialNumber: number, ownerReleaseNftCount: number, isGoldenEgg: boolean, comment: { id: string, message: string } } & { ' $fragmentName'?: 'WaveformCommentInfoFragment' };

export type WaveformCommentsReleaseInfoFragment = { id: string, titleSlug: string, artist: { id: string, soundHandle: string }, track: { id: string, duration: number }, topNftsWithComment: Array<(
    { id: string, serialNumber: number }
    & { ' $fragmentRefs'?: { 'WaveformCommentInfoFragment': WaveformCommentInfoFragment } }
  )> } & { ' $fragmentName'?: 'WaveformCommentsReleaseInfoFragment' };

export type RemoveReleaseFromShelfMutationVariables = Exact<{
  input: RemoveReleaseFromShelfInput;
}>;


export type RemoveReleaseFromShelfMutation = { removeReleaseFromShelf: { __typename: 'MutationRemoveReleaseFromShelfSuccess', data: { id: string } } | { __typename: 'NotAllowedError' } | { __typename: 'NotFoundError' } | { __typename: 'UnexpectedValueError' } | { __typename: 'UniqueConstraintError' } };

export type FollowUserMutationVariables = Exact<{
  input: FollowUserInput;
}>;


export type FollowUserMutation = { followUser: { id: string, userA: { id: string, username: string, followerCount: number, followingCount: number }, userB: { id: string, username: string, followerCount: number, followingCount: number } } };

export type UnfollowUserMutationVariables = Exact<{
  input: UnfollowUserInput;
}>;


export type UnfollowUserMutation = { unfollowUser: { id: string, userA: { id: string, username: string, followerCount: number, followingCount: number }, userB: { id: string, username: string, followerCount: number, followingCount: number } } };

export type MinimalUserFragment = { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'MinimalUserFragment' };

export type ReleaseCoverImagePlayButtonFragment = { id: string, title: string, createdAt: string, type: ReleaseType, webappUri: string, listeningParty: number | null, artist: { id: string, name: string, webappUri: string }, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string, dominantColor: string | null }, track: { id: string, normalizedPeaks: Array<number>, duration: number } } & { ' $fragmentName'?: 'ReleaseCoverImagePlayButtonFragment' };

export type ReleasePlayButtonFragment = { id: string, type: ReleaseType, title: string, listeningParty: number | null, track: { id: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, eggGame: { id: string, goldenEggImage: { id: string, url: string } | null, animatedGoldenEggImageOptimized: { id: string, url: string } | null } | null } & { ' $fragmentName'?: 'ReleasePlayButtonFragment' };

export type SeeAllUserInfoFragment = { id: string, webappUri: string } & { ' $fragmentName'?: 'SeeAllUserInfoFragment' };

export type IsSubscribedToArtistsNotificationsQueryVariables = Exact<{
  pagination: ArtistNotificationSubscriptionCursorConnectionArgs;
  artists: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type IsSubscribedToArtistsNotificationsQuery = { artistNotificationSubscriptions: { edges: Array<{ node: { id: string, artistId: string } }> } };

export type ArtistHighlightsFragment = { id: string, highlights: Array<{ imageLabel: string, imageUrl: string, linkUrl: string }> | null } & { ' $fragmentName'?: 'ArtistHighlightsFragment' };

export type LearnMoreFooterQueryVariables = Exact<{ [key: string]: never; }>;


export type LearnMoreFooterQuery = { artistPartnership: (
    { id: string, message: string }
    & { ' $fragmentRefs'?: { 'ArtistHighlightsFragment': ArtistHighlightsFragment } }
  ) };

export type CarouselUserInfoFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'SeeAllUserInfoFragment': SeeAllUserInfoFragment } }
) & { ' $fragmentName'?: 'CarouselUserInfoFragment' };

export type CommentAuthorFragment = { id: string, username: string, webappUri: string, publicAddress: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'CommentAuthorFragment' };

export type VoteOnPostCommentMutationVariables = Exact<{
  input: SetVoteOnPostCommentInput;
}>;


export type VoteOnPostCommentMutation = { voteOnPostComment: { __typename: 'MutationVoteOnPostCommentSuccess', data: null } | { __typename: 'NotFoundError', message: string } | { __typename: 'RateLimitError', message: string } | null };

export type UserVoteOnPostCommentQueryVariables = Exact<{
  input: QueryUserVoteOnPostCommentInput;
}>;


export type UserVoteOnPostCommentQuery = { userVoteOnPostComment: Array<{ postCommentId: string, voteStatus: CurrentUserPostVoteStatus, upvoteCount: number }> };

export type CommentRepliesQueryVariables = Exact<{
  pagination: PostCommentCursorConnectionArgs;
  parentCommentId: Scalars['UUID'];
  postId: Scalars['UUID'];
}>;


export type CommentRepliesQuery = { commentReplies: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'PostCommentsRowFragment': PostCommentsRowFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type DeletePostCommentReplyMutationVariables = Exact<{
  input: MutationDeletePostCommentReplyInput;
}>;


export type DeletePostCommentReplyMutation = { deletePostCommentReply: { __typename: 'MutationDeletePostCommentReplySuccess', data: { id: string } } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationError', message: string } };

export type UserPlaylistsSearchQueryVariables = Exact<{
  id: Scalars['UUID'];
  after?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['NonEmptyString']>;
}>;


export type UserPlaylistsSearchQuery = { user: { id: string, shelves: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
          { id: string, name: string }
          & { ' $fragmentRefs'?: { 'AddToPlaylistRowFragment': AddToPlaylistRowFragment } }
        ) }> } } | null };

export type AddReleaseToPlaylistMutationVariables = Exact<{
  input: AddReleaseToShelfInput;
}>;


export type AddReleaseToPlaylistMutation = { addReleaseToShelf: { __typename: 'DuplicatedError' } | { __typename: 'MutationAddReleaseToShelfSuccess', data: { id: string } } | { __typename: 'NotAllowedError' } | { __typename: 'NotFoundError' } | { __typename: 'UnexpectedValueError' } | { __typename: 'UniqueConstraintError' } };

export type ReleasePlaylistsForUserQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  playlistIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type ReleasePlaylistsForUserQuery = { release: { id: string, shelves: { edges: Array<{ node: { id: string } }> } } | null };

export type AddToPlaylistRowFragment = (
  { id: string, name: string, playTimeInSeconds: number, releaseCount: number }
  & { ' $fragmentRefs'?: { 'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment } }
) & { ' $fragmentName'?: 'AddToPlaylistRowFragment' };

export type GetDraftAllowlistFromDraftQueryVariables = Exact<{
  input: DraftAllowlistFromDraftInput;
  allowListType: DraftAllowlistType;
  pagination: CursorConnectionArgs;
}>;


export type GetDraftAllowlistFromDraftQuery = { draftAllowlistFromDraft: { id: string, totalUsers: number, info: { __typename: 'ArtistCollectorsAllowlist', allArtistCollectors: boolean, filteredArtists: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, name: string, webappUri: string, user: { id: string, publicAddress: string, username: string, avatar: { id: string, url: string } | null } } }> } } | { __typename: 'ManuallyAddedCollectorsAllowlist' } | { __typename: 'ReleaseCollectorsAllowlist', allArtistCollaborations: boolean, filteredReleases: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, title: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, artist: { id: string, name: string } } }> } } } | null };

export type GetDraftAllowlistModalQueryVariables = Exact<{
  input: DraftAllowlistFromDraftInput;
}>;


export type GetDraftAllowlistModalQuery = { draftAllowlistFromDraft: { id: string, info: { __typename: 'ArtistCollectorsAllowlist' } | { __typename: 'ManuallyAddedCollectorsAllowlist', description: string | null, totalCollectors: number } | { __typename: 'ReleaseCollectorsAllowlist' } } | null };

export type BaseReleaseAllowlistQueryVariables = Exact<{
  input: ReleaseAllowlistInput;
}>;


export type BaseReleaseAllowlistQuery = { releaseAllowlist: { id: string, createdAt: string, totalUsers: number, info: { allArtistCollaborations: boolean, allArtistCollectors: boolean }, manuallyAddedAddresses: { id: string, totalAddresses: number, description: string | null } | null } | null };

export type ReleaseAllowlistSelectedReleasesQueryVariables = Exact<{
  input: ReleaseAllowlistInput;
  pagination: CursorConnectionArgs;
}>;


export type ReleaseAllowlistSelectedReleasesQuery = { releaseAllowlist: { id: string, selectedReleaseSources: { edges: Array<{ node: { id: string, sourceRelease: { id: string, title: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, artist: { id: string, name: string } } | null } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type ReleaseAllowlistSelectedArtistsQueryVariables = Exact<{
  input: ReleaseAllowlistInput;
  pagination: CursorConnectionArgs;
}>;


export type ReleaseAllowlistSelectedArtistsQuery = { releaseAllowlist: { id: string, selectedArtistSources: { edges: Array<{ node: { id: string, sourceArtist: { id: string, name: string, webappUri: string, user: { id: string, publicAddress: string, username: string, avatar: { id: string, url: string } | null } } | null } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type GetReleaseAllowListedAddressesCsvUrlQueryVariables = Exact<{
  merkleRoot: Scalars['String'];
}>;


export type GetReleaseAllowListedAddressesCsvUrlQuery = { merkleTreeCSVUrl: string | null };

export type ReleaseAllowlistModalDataQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReleaseAllowlistModalDataQuery = { release: { id: string, artist: { id: string, name: string, user: { id: string, avatar: { id: string, url: string } | null } } } | null };

export type ReleaseBuyButtonsFragment = (
  { id: string, contractAddress: string, chainId: number, auctionContractType: ContractType | null, scheduleIds: Array<{ mintIds: Array<number>, minterAddress: string }> | null }
  & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
) & { ' $fragmentName'?: 'ReleaseBuyButtonsFragment' };

export type CheckoutReleaseInfoFragment = (
  { id: string, chainId: number, auctionContractType: ContractType | null, editionId: string | null, title: string, type: ReleaseType, contractAddress: string }
  & { ' $fragmentRefs'?: { 'ReleaseDetailsFragment': ReleaseDetailsFragment;'ReleaseBuyButtonsFragment': ReleaseBuyButtonsFragment } }
) & { ' $fragmentName'?: 'CheckoutReleaseInfoFragment' };

export type TieredBuyButtonsFragment = (
  { id: string, contractAddress: string, chainId: number }
  & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
) & { ' $fragmentName'?: 'TieredBuyButtonsFragment' };

export type TiersCheckoutReleaseInfoFragment = (
  { id: string, chainId: number, auctionContractType: ContractType | null, contractAddress: string }
  & { ' $fragmentRefs'?: { 'ReleaseDetailsFragment': ReleaseDetailsFragment;'TieredBuyButtonsFragment': TieredBuyButtonsFragment } }
) & { ' $fragmentName'?: 'TiersCheckoutReleaseInfoFragment' };

export type BuyEditionSongDetailsFragment = { id: string, title: string, chainId: number, samAddress: string | null, gaCoverImage: { id: string, url: string } | null, staticGaCoverImage: { id: string, url: string } | null, vipCoverImage: { id: string, url: string } | null, staticVipCoverImage: { id: string, url: string } | null, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string }, artist: { id: string, webappUri: string, name: string } } & { ' $fragmentName'?: 'BuyEditionSongDetailsFragment' };

export type CreatePaperSoundSwapKeyMutationVariables = Exact<{
  input: PaperSoundSwapSdkClientSecretInput;
}>;


export type CreatePaperSoundSwapKeyMutation = { paperSoundSwapSdkClientSecret: { __typename: 'MutationPaperSoundSwapSdkClientSecretSuccess', data: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedValueError', message: string } };

export type CreatePaperMinterAdapterKeyMutationVariables = Exact<{
  input: PaperMinterAdapterSdkClientSecretInput;
}>;


export type CreatePaperMinterAdapterKeyMutation = { paperMinterAdapterSdkClientSecret: { __typename: 'MutationPaperMinterAdapterSdkClientSecretSuccess', data: string } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedValueError', message: string } };

export type CreatePaperMerkleMinterV2KeyMutationVariables = Exact<{
  input: PaperMerkleDropMinterV2SdkClientSecretInput;
}>;


export type CreatePaperMerkleMinterV2KeyMutation = { paperMerkleMinterV2SdkClientSecret: { __typename: 'MutationPaperMerkleMinterV2SdkClientSecretSuccess', data: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedValueError', message: string } };

export type CreatePaperRangedEditionV2KeyMutationVariables = Exact<{
  input: PaperRangedMinterV2SdkClientSecretInput;
}>;


export type CreatePaperRangedEditionV2KeyMutation = { paperRangeMinterV2SdkClientSecret: { __typename: 'MutationPaperRangeMinterV2SdkClientSecretSuccess', data: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedValueError', message: string } };

export type CreatePaperSuperMinterKeyMutationVariables = Exact<{
  input: PaperSuperMinterSdkClientSecretInput;
}>;


export type CreatePaperSuperMinterKeyMutation = { paperSuperMinterSdkClientSecret: { __typename: 'MutationPaperSuperMinterSdkClientSecretSuccess', data: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnexpectedValueError', message: string } };

export type PayEditionWithCreditCardQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type PayEditionWithCreditCardQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'BuyEditionSongDetailsFragment': BuyEditionSongDetailsFragment } }
  ) | null };

export type PayEditionWithEthQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type PayEditionWithEthQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'BuyEditionSongDetailsFragment': BuyEditionSongDetailsFragment } }
  ) | null };

export type MarketplaceCheckoutFragment = (
  { id: string, auctionContractType: ContractType | null, chainId: number, contractAddress: string, marketPlaceUrl: string | null, title: string, type: ReleaseType }
  & { ' $fragmentRefs'?: { 'ReleaseDetailsFragment': ReleaseDetailsFragment } }
) & { ' $fragmentName'?: 'MarketplaceCheckoutFragment' };

export type SetAffiliatePurchaseSourceMutationVariables = Exact<{
  input: AffiliateSourceInput;
}>;


export type SetAffiliatePurchaseSourceMutation = { setAffiliatePurchaseSource: { __typename: 'MutationSetAffiliatePurchaseSourceSuccess' } | { __typename: 'ValidationError', message: string } };

export type ReleaseDetailsFragment = { id: string, title: string, gaCoverImage: { id: string, url: string } | null, staticGaCoverImage: { id: string, url: string } | null, vipCoverImage: { id: string, url: string } | null, staticVipCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, artist: { id: string, name: string } } & { ' $fragmentName'?: 'ReleaseDetailsFragment' };

export type CollectReleaseQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type CollectReleaseQuery = { release: (
    { id: string, contractAddress: string, title: string, editionId: string | null, price: string, quantity: number, quantityUpperBound: number, finalQuantity: number | null, numSold: number, coverImage: { id: string, url: string } }
    & { ' $fragmentRefs'?: { 'ReleaseDetailsFragment': ReleaseDetailsFragment } }
  ) | null };

export type UseChannelMembersInUserNotificationQueryVariables = Exact<{
  userNotificationId: Scalars['UUID'];
  pagination: UserCursorConnectionArgs;
}>;


export type UseChannelMembersInUserNotificationQuery = { newChannelMembersInUserNotification: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type GetAudioCollectMintableReleaseQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type GetAudioCollectMintableReleaseQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'CollectModalFragment': CollectModalFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
  ) | null };

export type GetMintableReleasePlaylistQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
}>;


export type GetMintableReleasePlaylistQuery = { playlistV2: { id: string, user: { id: string, publicAddress: string } } | null };

export type CollectModalFragment = (
  { id: string, spotifyPresaveCampaign: boolean }
  & { ' $fragmentRefs'?: { 'MintComponentFragment': MintComponentFragment } }
) & { ' $fragmentName'?: 'CollectModalFragment' };

export type ReleaseCollectedByManyUsersQueryVariables = Exact<{
  activityFeedGroupId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
}>;


export type ReleaseCollectedByManyUsersQuery = { releaseCollectedByManyUsers: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserModalInfoFragment': UserModalInfoFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type UserModalInfoFragment = { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'UserModalInfoFragment' };

export type TimeSlotSelectorQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeSlotSelectorQuery = { track: { id: string, duration: number, normalizedPeaks: Array<number> } | null };

export type ShareToSocialModalReleaseInfoFragment = (
  { id: string, title: string, webappUri: string, artist: { id: string, soundHandle: string, name: string, user: { id: string, twitterHandle: string | null } } }
  & { ' $fragmentRefs'?: { 'ReleaseCommentTypeFragment': ReleaseCommentTypeFragment;'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'DynamicFeePercentInfoFragment': DynamicFeePercentInfoFragment } }
) & { ' $fragmentName'?: 'ShareToSocialModalReleaseInfoFragment' };

export type ShareToSocialModalNftInfoFragment = (
  { id: string, serialNumber: number, tierNumber: number | null, isGoldenEgg: boolean, collectorRelease: { id: string, nftsCount: number } | null }
  & { ' $fragmentRefs'?: { 'NftCommentTypeFragment': NftCommentTypeFragment } }
) & { ' $fragmentName'?: 'ShareToSocialModalNftInfoFragment' };

export type GetNftForShareToSocialQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetNftForShareToSocialQuery = { nftFromId: (
    { id: string, release: (
      { id: string, artist: { id: string, user: { id: string } } }
      & { ' $fragmentRefs'?: { 'ShareToSocialModalReleaseInfoFragment': ShareToSocialModalReleaseInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'ShareToSocialModalNftInfoFragment': ShareToSocialModalNftInfoFragment } }
  ) | null };

export type RecoverPlaylistMutationVariables = Exact<{
  playlistId: Scalars['UUID'];
}>;


export type RecoverPlaylistMutation = { recoverShelf: { __typename: 'MutationRecoverShelfSuccess', data: { id: string } } | { __typename: 'NotAllowedError' } | { __typename: 'NotFoundError' } };

export type ConfirmWithdrawReleaseFragment = { totalWithdrawableForUser: string, splitMainBalanceFromRelease: string, release: { id: string, title: string, coverImage: { id: string, url: string } } } & { ' $fragmentName'?: 'ConfirmWithdrawReleaseFragment' };

export type ConfirmModalCreditSplitsQueryVariables = Exact<{
  pagination: CursorConnectionArgs;
}>;


export type ConfirmModalCreditSplitsQuery = { releaseEarnings: { edges: Array<{ node: { id: string, splitMainBalanceFromRelease: string, totalWithdrawableForUser: string, release: { id: string, title: string, mintStartTime: number, coverImage: { id: string, url: string } } } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type ArtistReleaseFragment = (
  { id: string, title: string, createdAt: string, type: ReleaseType, webappUri: string, artist: { id: string, name: string, webappUri: string }, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string, dominantColor: string | null }, track: { id: string, normalizedPeaks: Array<number>, duration: number } }
  & { ' $fragmentRefs'?: { 'WaveformCommentsReleaseInfoFragment': WaveformCommentsReleaseInfoFragment;'ReleaseCoverImagePlayButtonFragment': ReleaseCoverImagePlayButtonFragment } }
) & { ' $fragmentName'?: 'ArtistReleaseFragment' };

export type ArtistReleasesQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
  filter: ArtistReleasesFilter;
}>;


export type ArtistReleasesQuery = { artist: { id: string, releases: { pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ cursor: string, node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'WaveformCommentsReleaseInfoFragment': WaveformCommentsReleaseInfoFragment;'ArtistReleaseFragment': ArtistReleaseFragment } }
        ) }> } } | null };

export type SetArtistPickedReleaseMutationVariables = Exact<{
  releaseId?: InputMaybe<Scalars['UUID']>;
}>;


export type SetArtistPickedReleaseMutation = { setArtistPickedRelease: { __typename: 'AuthorizationError', message: string } | { __typename: 'MutationSetArtistPickedReleaseSuccess', data: { id: string } } | { __typename: 'NotFoundError', message: string } | null };

type FeedPostCommentModal_ActivityFeedGroupBackingPost_Fragment = { __typename: 'ActivityFeedGroupBackingPost', id: string, content: string, lexicalContent: unknown | null, webappUri: string, activityFeedGroup: { information: { __typename: 'ReleaseDroppedAggregate', release: { id: string, title: string } } | { __typename: 'ReleasesAddedToShelfAggregate' } | { __typename: 'ShelfCreatedAggregate' } | { __typename: 'SongCollectedByManyAggregate' } | { __typename: 'UserCollectedManySongsAggregate', numReleases: number, collectionTypes: Array<CollectionMarketType>, collectedReleases: Array<{ release: { id: string, title: string, artist: { name: string } } }> } | { __typename: 'UserCreatedPostAggregate' } | { __typename: 'UserLikedPlaylistAggregate' } | { __typename: 'UserLikedSongsAggregate' } }, creator: { id: string, username: string, webappUri: string, publicAddress: string, displayName: string | null, avatar: { id: string, url: string } | null, artist: { id: string, name: string } | null } } & { ' $fragmentName'?: 'FeedPostCommentModal_ActivityFeedGroupBackingPost_Fragment' };

type FeedPostCommentModal_ArtistDropPost_Fragment = { __typename: 'ArtistDropPost', id: string, content: string, lexicalContent: unknown | null, webappUri: string, release: { id: string, title: string }, creator: { id: string, username: string, webappUri: string, publicAddress: string, displayName: string | null, avatar: { id: string, url: string } | null, artist: { id: string, name: string } | null } } & { ' $fragmentName'?: 'FeedPostCommentModal_ArtistDropPost_Fragment' };

type FeedPostCommentModal_PlaylistPost_Fragment = { __typename: 'PlaylistPost', id: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, displayName: string | null, avatar: { id: string, url: string } | null, artist: { id: string, name: string } | null } } & { ' $fragmentName'?: 'FeedPostCommentModal_PlaylistPost_Fragment' };

type FeedPostCommentModal_ReleasePost_Fragment = { __typename: 'ReleasePost', id: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, displayName: string | null, avatar: { id: string, url: string } | null, artist: { id: string, name: string } | null } } & { ' $fragmentName'?: 'FeedPostCommentModal_ReleasePost_Fragment' };

type FeedPostCommentModal_Repost_Fragment = { __typename: 'Repost', id: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, webappUri: string, publicAddress: string, displayName: string | null, avatar: { id: string, url: string } | null, artist: { id: string, name: string } | null } } & { ' $fragmentName'?: 'FeedPostCommentModal_Repost_Fragment' };

export type FeedPostCommentModalFragment = FeedPostCommentModal_ActivityFeedGroupBackingPost_Fragment | FeedPostCommentModal_ArtistDropPost_Fragment | FeedPostCommentModal_PlaylistPost_Fragment | FeedPostCommentModal_ReleasePost_Fragment | FeedPostCommentModal_Repost_Fragment;

export type AfterFeedPostPlaylistInfoFragment = { id: string, webappUri: string, optionalShelf: { id: string, user: { id: string, twitterHandle: string | null } } | null } & { ' $fragmentName'?: 'AfterFeedPostPlaylistInfoFragment' };

export type AfterFeedPostReleaseInfoFragment = { id: string, webappUri: string, optionalRelease: { id: string, publicAffiliateFeeBPS: number | null, artist: { id: string, user: { id: string, twitterHandle: string | null } } } | null } & { ' $fragmentName'?: 'AfterFeedPostReleaseInfoFragment' };

export type FeedPostModalMainPlaylistHeaderFragment = (
  { id: string, releaseCount: number, type: ShelfType, name: string, webappUri: string, user: { id: string, username: string, webappUri: string } }
  & { ' $fragmentRefs'?: { 'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment;'PlaylistPreviewDropdownInfoFragment': PlaylistPreviewDropdownInfoFragment } }
) & { ' $fragmentName'?: 'FeedPostModalMainPlaylistHeaderFragment' };

export type FeedPostModalPlaylistPreviewFragment = { id: string, listeningParty: number | null, title: string, webappUri: string, track: { id: string, duration: number }, artist: { id: string, name: string, webappUri: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null } & { ' $fragmentName'?: 'FeedPostModalPlaylistPreviewFragment' };

export type FeedPostModalMainPlaylistQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
}>;


export type FeedPostModalMainPlaylistQuery = { shelf: (
    { id: string, releaseCount: number, webappUri: string, user: { id: string, webappUri: string, username: string }, orderedReleases: { edges: Array<{ node: { id: string, release: (
            { id: string }
            & { ' $fragmentRefs'?: { 'FeedPostModalPlaylistPreviewFragment': FeedPostModalPlaylistPreviewFragment } }
          ) } }> } }
    & { ' $fragmentRefs'?: { 'FeedPostModalMainPlaylistHeaderFragment': FeedPostModalMainPlaylistHeaderFragment } }
  ) };

export type FeedPostModalMainSoundFragment = (
  { totalMinted: number, id: string, title: string, track: { duration: number, title: string, id: string }, coverImage: { id: string, url: string, dominantColor: string | null }, staticCoverImage: { id: string, url: string, dominantColor: string | null } | null, artist: { id: string, name: string } }
  & { ' $fragmentRefs'?: { 'ReleaseCoverImagePlayButtonFragment': ReleaseCoverImagePlayButtonFragment } }
) & { ' $fragmentName'?: 'FeedPostModalMainSoundFragment' };

export type FeedPostModalPlaylistSelectInitialPlayilstResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedPostModalPlaylistSelectInitialPlayilstResultsQuery = { currentPlaylistChart: { id: string, lastDayOfChartInclusive: string, chartRanks: { edges: Array<{ node: { id: string, playlist: (
            { id: string }
            & { ' $fragmentRefs'?: { 'FeedPostModalPlaylistSelectItemFragment': FeedPostModalPlaylistSelectItemFragment } }
          ) } }> } } };

export type FeedPostSearchPlaylistQueryVariables = Exact<{
  input: SearchInput;
}>;


export type FeedPostSearchPlaylistQuery = { search: { id: string, shelves: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'FeedPostModalPlaylistSelectItemFragment': FeedPostModalPlaylistSelectItemFragment } }
        ) }> } } };

export type FeedPostModalPlaylistSelectItemFragment = (
  { id: string, name: string, webappUri: string, releaseCount: number, user: { id: string, webappUri: string, username: string } }
  & { ' $fragmentRefs'?: { 'PlaylistCoverImagesFragment': PlaylistCoverImagesFragment } }
) & { ' $fragmentName'?: 'FeedPostModalPlaylistSelectItemFragment' };

export type SearchAllSoundsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchAllSoundsQuery = { search: { id: string, releasesPaginated: { edges: Array<{ node: { ' $fragmentRefs'?: { 'FeedPostModalSoundSelectItemFragment': FeedPostModalSoundSelectItemFragment;'ReleaseCoverImagePlayButtonFragment': ReleaseCoverImagePlayButtonFragment;'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment } } }> } } };

export type FeedPostModalSoundSelectInitialReleaseResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedPostModalSoundSelectInitialReleaseResultsQuery = { releases: { edges: Array<{ node: { ' $fragmentRefs'?: { 'FeedPostModalSoundSelectItemFragment': FeedPostModalSoundSelectItemFragment;'ReleaseCoverImagePlayButtonFragment': ReleaseCoverImagePlayButtonFragment;'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment } } }> } };

export type FeedPostModalSoundSelectItemFragment = { id: string, title: string, track: { id: string, title: string }, artist: { id: string, name: string } } & { ' $fragmentName'?: 'FeedPostModalSoundSelectItemFragment' };

export type CreateReleasePostMutationVariables = Exact<{
  input: CreateReleasePostInput;
}>;


export type CreateReleasePostMutation = { createReleasePost: { __typename: 'DidNotGoThroughError', message: string } | { __typename: 'MutationCreateReleasePostSuccess', data: { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string } | { __typename: 'ArtistDropPost', id: string, webappUri: string } | { __typename: 'PlaylistPost', id: string, webappUri: string } | (
      { __typename: 'ReleasePost', id: string, webappUri: string }
      & { ' $fragmentRefs'?: { 'AfterFeedPostReleaseInfoFragment': AfterFeedPostReleaseInfoFragment } }
    ) | { __typename: 'Repost', id: string, webappUri: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'RateLimitError', message: string } | { __typename: 'ValidationError', message: string } };

export type CreatePlaylistPostMutationVariables = Exact<{
  input: CreatePlaylistPostInput;
}>;


export type CreatePlaylistPostMutation = { createPlaylistPost: { __typename: 'DidNotGoThroughError', message: string } | { __typename: 'MutationCreatePlaylistPostSuccess', data: { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string } | { __typename: 'ArtistDropPost', id: string, webappUri: string } | (
      { __typename: 'PlaylistPost', id: string, webappUri: string }
      & { ' $fragmentRefs'?: { 'AfterFeedPostPlaylistInfoFragment': AfterFeedPostPlaylistInfoFragment } }
    ) | { __typename: 'ReleasePost', id: string, webappUri: string } | { __typename: 'Repost', id: string, webappUri: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'RateLimitError', message: string } | { __typename: 'ValidationError', message: string } };

export type GiftingModalFragment = { id: string, title: string, contractAddress: string, chainId: number, coverImage: { id: string, url: string, dominantColor: string | null }, staticCoverImage: { id: string, url: string, dominantColor: string | null } | null, artist: { id: string, name: string } } & { ' $fragmentName'?: 'GiftingModalFragment' };

export type MintsDrivenModalQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
}>;


export type MintsDrivenModalQuery = { playlistV2: { id: string, numReferralPurchases: number, numUsersReferred: number, affiliateBuyers: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'MintsDrivenAffiliateBuyerFragment': MintsDrivenAffiliateBuyerFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type MintsDrivenAffiliateBuyerFragment = { id: string, numAffiliateNftsPurchased: number | null, user: { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } } } & { ' $fragmentName'?: 'MintsDrivenAffiliateBuyerFragment' };

export type MintedByUsersModalQueryVariables = Exact<{
  userNotificationId: Scalars['UUID'];
  pagination: ReleaseCollectorCursorConnectionArgs;
}>;


export type MintedByUsersModalQuery = { mintedByUsersInUserNotification: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'CollectorModalInfoFragment': CollectorModalInfoFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type NewFollowersInNotificationQueryVariables = Exact<{
  userNotificationId: Scalars['UUID'];
  pagination: CursorConnectionArgs;
}>;


export type NewFollowersInNotificationQuery = { followedByUsersInUserNotification: { edges: Array<{ node: (
        { id: string, userB: { id: string } }
        & { ' $fragmentRefs'?: { 'FollowersModalRelationFragment': FollowersModalRelationFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type PresavedByUsersModalQueryVariables = Exact<{
  userNotificationId: Scalars['UUID'];
  pagination: UserCursorConnectionArgs;
}>;


export type PresavedByUsersModalQuery = { presavedByUsersInUserNotification: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type ReleaseRowListFragment = (
  { id: string, title: string, webappUri: string, type: ReleaseType, listeningParty: number | null, track: { id: string }, artist: { id: string, name: string, webappUri: string } }
  & { ' $fragmentRefs'?: { 'ReleasePlayButtonFragment': ReleasePlayButtonFragment } }
) & { ' $fragmentName'?: 'ReleaseRowListFragment' };

export type PlaylistReleasesModalQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
  id: Scalars['UUID'];
  pagination: PlaylistActionReleasesCursorConnectionArgs;
  isAdded: Scalars['Boolean'];
  isRemoved: Scalars['Boolean'];
}>;


export type PlaylistReleasesModalQuery = { playlistAction: { __typename: 'CreatedPlaylistPost', id: string } | { __typename: 'PlaylistCreated', id: string } | { __typename: 'PlaylistLiked', id: string } | { __typename: 'ReleasesAddedRemovedFromPlaylist', id: string, addedReleases?: { edges: Array<{ node: (
          { id: string, createdAt: string }
          & { ' $fragmentRefs'?: { 'ReleaseRowListFragment': ReleaseRowListFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } }, removedReleases?: { edges: Array<{ node: (
          { id: string, createdAt: string }
          & { ' $fragmentRefs'?: { 'ReleaseRowListFragment': ReleaseRowListFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | { __typename: 'ReleasesAddedToPlaylist', id: string, addedReleases?: { edges: Array<{ node: (
          { id: string, createdAt: string }
          & { ' $fragmentRefs'?: { 'ReleaseRowListFragment': ReleaseRowListFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | { __typename: 'ReleasesRemovedFromPlaylist', id: string, removedReleases?: { edges: Array<{ node: (
          { id: string, createdAt: string }
          & { ' $fragmentRefs'?: { 'ReleaseRowListFragment': ReleaseRowListFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type UsersThatRepostedQueryVariables = Exact<{
  input: QueryPostRepostedByInput;
}>;


export type UsersThatRepostedQuery = { postRepostedBy: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type UsersThatUpvotedQueryVariables = Exact<{
  notificationId: Scalars['UUID'];
  pagination: UserCursorConnectionArgs;
}>;


export type UsersThatUpvotedQuery = { upvotedByUsersInUserNotification: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type UsersThatUpvotedPostQueryVariables = Exact<{
  input: QueryPostUpvotedByInput;
}>;


export type UsersThatUpvotedPostQuery = { postUpvotedBy: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type ReferralsCollectorsQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  referredCollectorsInput: ReferredUsersInput;
}>;


export type ReferralsCollectorsQuery = { releaseTotalAffiliatePurchases: { id: string, referredCollectors: { edges: Array<{ node: { id: string, earningsETH: string, purchasesQuantity: number, user: { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null } } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type ReleaseMintsModalQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  pagination: ReleaseCollectorCursorConnectionArgs;
}>;


export type ReleaseMintsModalQuery = { release: { id: string, totalMinted: number, collectorsCount: number, collectors: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'CollectorModalInfoFragment': CollectorModalInfoFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type GetArtistByPublicAddressQueryVariables = Exact<{
  publicAddress: Scalars['Address'];
}>;


export type GetArtistByPublicAddressQuery = { userByAddress: { __typename: 'User', id: string, artist: { id: string, name: string, soundHandle: string } | null } | null };

export type RemoveArtistMutationVariables = Exact<{
  publicAddress: Scalars['Address'];
}>;


export type RemoveArtistMutation = { removeArtist: { __typename: 'MutationRemoveArtistSuccess' } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type GetReleaseByIdQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type GetReleaseByIdQuery = { release: { __typename: 'Release', id: string, title: string, createdAt: string, publicMintStart: string, artist: { id: string, name: string, soundHandle: string } } | null };

export type RemoveReleaseMutationVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type RemoveReleaseMutation = { removeRelease: { __typename: 'MutationRemoveReleaseSuccess' } | { __typename: 'NotFoundError', message: string } };

export type AddPostCommentReplyMutationVariables = Exact<{
  input: MutationAddPostCommentReplyInput;
}>;


export type AddPostCommentReplyMutation = { addPostCommentReply: { __typename: 'DidNotGoThroughError', message: string } | { __typename: 'MutationAddPostCommentReplySuccess', data: (
      { id: string }
      & { ' $fragmentRefs'?: { 'PostCommentsRowFragment': PostCommentsRowFragment } }
    ) } | { __typename: 'NotFoundError', message: string } | { __typename: 'RateLimitError', message: string } | { __typename: 'ValidationError', message: string } };

export type PostModalCommentQueryVariables = Exact<{
  postCommentId: Scalars['UUID'];
}>;


export type PostModalCommentQuery = { postComment: { __typename: 'PostComment', id: string, createdAt: string, content: string, lexicalContent: unknown | null, author: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null }, post: { __typename: 'ActivityFeedGroupBackingPost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } } | { __typename: 'ArtistDropPost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } } | (
      { __typename: 'PlaylistPost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } }
      & { ' $fragmentRefs'?: { 'TopPlaylistPostFragment': TopPlaylistPostFragment } }
    ) | (
      { __typename: 'ReleasePost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } }
      & { ' $fragmentRefs'?: { 'TopReleasePostFragment': TopReleasePostFragment } }
    ) | { __typename: 'Repost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } } } | null };

export type PostModalQueryVariables = Exact<{
  postId: Scalars['UUID'];
}>;


export type PostModalQuery = { post: { __typename: 'ActivityFeedGroupBackingPost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } } | { __typename: 'ArtistDropPost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } } | (
    { __typename: 'PlaylistPost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } }
    & { ' $fragmentRefs'?: { 'TopPlaylistPostFragment': TopPlaylistPostFragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } }
    & { ' $fragmentRefs'?: { 'TopReleasePostFragment': TopReleasePostFragment } }
  ) | { __typename: 'Repost', id: string, createdAt: string, content: string, lexicalContent: unknown | null, webappUri: string, creator: { id: string, username: string, publicAddress: string, webappUri: string, displayName: string | null, artist: { id: string, name: string } | null, avatar: { id: string, url: string } | null } } | null };

export type ReleaseShareInfoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ReleaseShareInfoQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleaseShareInfoFragment': ReleaseShareInfoFragment } }
  ) | null };

export type ReleaseShareInfoFragment = (
  { id: string, webappUri: string, publicAffiliateFeePercent: string | null, isFirstPhaseCompleted: boolean, samConfig: { id: string, affiliateFeePercent: string } | null }
  & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'DynamicFeePercentInfoFragment': DynamicFeePercentInfoFragment } }
) & { ' $fragmentName'?: 'ReleaseShareInfoFragment' };

export type PlaylistShareInfoFragment = { id: string, webappUri: string, user: { id: string } } & { ' $fragmentName'?: 'PlaylistShareInfoFragment' };

export type DynamicFeePercentInfoFragment = { publicAffiliateFeePercent: string | null, isFirstPhaseCompleted: boolean, samConfig: { id: string, affiliateFeePercent: string } | null } & { ' $fragmentName'?: 'DynamicFeePercentInfoFragment' };

export type ArtistModalInfoFragment = { id: string, webappUri: string, name: string, user: { id: string, username: string, publicAddress: string, avatar: { id: string, url: string } | null } } & { ' $fragmentName'?: 'ArtistModalInfoFragment' };

export type GetSubscribedArtistsQueryVariables = Exact<{
  artists?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  pagination: ArtistNotificationSubscriptionCursorConnectionArgs;
}>;


export type GetSubscribedArtistsQuery = { artistNotificationSubscriptions: { edges: Array<{ cursor: string, node: { id: string, artist: { ' $fragmentRefs'?: { 'ArtistModalInfoFragment': ArtistModalInfoFragment } } } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type UploadReleaseInfoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UploadReleaseInfoQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UploadReleaseInfoFragment': UploadReleaseInfoFragment } }
  ) | null };

export type UploadReleaseInfoFragment = (
  { id: string, webappUri: string, type: ReleaseType, contractAddress: string, chainId: number, publicAffiliateFeePercent: string | null, isFirstPhaseCompleted: boolean, samConfig: { id: string, affiliateFeePercent: string } | null }
  & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment;'DynamicFeePercentInfoFragment': DynamicFeePercentInfoFragment } }
) & { ' $fragmentName'?: 'UploadReleaseInfoFragment' };

export type ArtistCollectorsMintInfoFragment = { id: string, name: string, numCollectors: number, numNfts: number, userId: string } & { ' $fragmentName'?: 'ArtistCollectorsMintInfoFragment' };

export type ArtistCollectorMintsModalQueryVariables = Exact<{
  artistId: Scalars['UUID'];
  pagination?: InputMaybe<ArtistCollectorCursorConnectionArgs>;
}>;


export type ArtistCollectorMintsModalQuery = { artist: { id: string, collectors: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'CollectorMintsRowFragment': CollectorMintsRowFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type CollectorMintsRowFragment = { id: string, nftsCount: number, user: { id: string, publicAddress: string, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } } & { ' $fragmentName'?: 'CollectorMintsRowFragment' };

export type UserArtistBackedInfoFragment = { id: string, publicAddress: string, username: string, numBackedArtists: number } & { ' $fragmentName'?: 'UserArtistBackedInfoFragment' };

export type AllArtistsBackedModalQueryVariables = Exact<{
  id: Scalars['UUID'];
  pagination?: InputMaybe<ArtistCollectorCursorConnectionArgs>;
}>;


export type AllArtistsBackedModalQuery = { user: { id: string, backedArtists: { edges: Array<{ node: { id: string, artist: { id: string, user: (
              { id: string }
              & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
            ) } } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type CollectedRowReleaseFragment = { id: string, nftsCount: number, release: (
    { id: string, title: string, type: ReleaseType, webappUri: string, listeningParty: number | null, artist: { id: string, name: string, webappUri: string }, track: { id: string } }
    & { ' $fragmentRefs'?: { 'ReleasePlayButtonFragment': ReleasePlayButtonFragment } }
  ) } & { ' $fragmentName'?: 'CollectedRowReleaseFragment' };

export type CollectedUserStatModalFragment = { id: string, nftsOwned: number, username: string } & { ' $fragmentName'?: 'CollectedUserStatModalFragment' };

export type CollectedReleasesModalQueryVariables = Exact<{
  userId: Scalars['UUID'];
  pagination?: InputMaybe<CursorConnectionArgs>;
}>;


export type CollectedReleasesModalQuery = { user: { id: string, releases: { edges: Array<{ node: (
          { id: string, release: { id: string, track: { id: string } } }
          & { ' $fragmentRefs'?: { 'CollectedRowReleaseFragment': CollectedRowReleaseFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type FollowersModalFragment = { id: string, publicAddress: string, followerCount: number, username: string } & { ' $fragmentName'?: 'FollowersModalFragment' };

export type FollowersModalRelationFragment = { id: string, userA: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
  ) } & { ' $fragmentName'?: 'FollowersModalRelationFragment' };

export type FollowingModalRelationFragment = { id: string, userB: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
  ) } & { ' $fragmentName'?: 'FollowingModalRelationFragment' };

export type FollowersFollowingModalFragment = { id: string, publicAddress: string, followerCount: number, followingCount: number, username: string } & { ' $fragmentName'?: 'FollowersFollowingModalFragment' };

export type FollowStatusQueryVariables = Exact<{
  users: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type FollowStatusQuery = { userRelationStatuses: Array<{ isFollowing: boolean, userId: string }> };

export type FollowingUsersQueryVariables = Exact<{
  publicAddress: Scalars['Address'];
  followingCursor: CursorConnectionArgs;
}>;


export type FollowingUsersQuery = { userByAddress: { id: string, following: { edges: Array<{ node: (
          { id: string, userB: { id: string } }
          & { ' $fragmentRefs'?: { 'FollowingModalRelationFragment': FollowingModalRelationFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type FollowerUsersQueryVariables = Exact<{
  publicAddress: Scalars['Address'];
  followingCursor: CursorConnectionArgs;
}>;


export type FollowerUsersQuery = { userByAddress: { id: string, followers: { edges: Array<{ node: (
          { id: string, userA: { id: string } }
          & { ' $fragmentRefs'?: { 'FollowersModalRelationFragment': FollowersModalRelationFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type YouOwnModalQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  publicAddress?: InputMaybe<Scalars['Address']>;
}>;


export type YouOwnModalQuery = { userByAddress: { id: string, collectedReleases: { edges: Array<{ node: { id: string, vipNftsCount: number, gaNftsCount: number, goldenEgg: { id: string } | null, release: { id: string, auctionContractType: ContractType | null, title: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, gaCoverImage: { id: string, url: string } | null, staticGaCoverImage: { id: string, url: string } | null, vipCoverImage: { id: string, url: string } | null, staticVipCoverImage: { id: string, url: string } | null, goldenEggImage: { id: string, url: string }, animatedGoldenEggImageOptimized: { id: string, url: string } | null } } }> } } | null };

export type UserModalRowFragment = { id: string, publicAddress: string, webappUri: string, username: string, avatar: { id: string, url: string } | null, artist: { id: string } | null } & { ' $fragmentName'?: 'UserModalRowFragment' };

export type CollectorModalInfoFragment = { id: string, nftsCount: number, vipNftsCount: number, user: (
    { id: string }
    & { ' $fragmentRefs'?: { 'UserModalRowFragment': UserModalRowFragment } }
  ), ownedGoldenEgg: { id: string } | null } & { ' $fragmentName'?: 'CollectorModalInfoFragment' };

export type AuthUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthUserQuery = { authUser: (
    { id: string, email: string | null, verifiedNotificationEmail: string | null, publicAddress: string, lastReferralWithdrawableBalance: string | null, webappUri: string, username: string, twitterHandle: string | null, instagramHandle: string | null, displayName: string | null, description: string | null, createdAt: string, roles: { isAdmin: boolean, isArtistRelations: boolean }, avatar: { id: string, url: string, key: string } | null, bannerImage: { id: string, url: string, key: string } | null, artist: { id: string, name: string, webappUri: string, soundHandle: string, bannerImage: { id: string, url: string, key: string } | null } | null, creditAllocations: Array<{ id: string }>, location: { label: string, placeId: string } | null, invitedByUser: { id: string } | null }
    & { ' $fragmentRefs'?: { 'UserDashboardInfoFragment': UserDashboardInfoFragment } }
  ) | null };

export type GenerateAuthChallengeMutationVariables = Exact<{
  publicAddress: Scalars['String'];
}>;


export type GenerateAuthChallengeMutation = { generateAuthChallenge: number };

export type VerifyAuthChallengeMutationVariables = Exact<{
  publicAddress: Scalars['String'];
  signedMessage: Scalars['String'];
}>;


export type VerifyAuthChallengeMutation = { verifyAuthChallenge: string };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: { __typename: 'AuthorizationError' } | { __typename: 'MutationLogoutSuccess' } };

export type VerifyDynamicTokenMutationVariables = Exact<{
  token: Scalars['JWT'];
}>;


export type VerifyDynamicTokenMutation = { verifyDynamicJWT: string };

export type ClientNftUpsertMutationVariables = Exact<{
  txHash: Scalars['String'];
  chain: ChainType;
}>;


export type ClientNftUpsertMutation = { clientNftUpsert: { id: string, tokenId: string, release: { id: string }, owner: { id: string } } | null };

export type ClientConfirmedDraftUpsertMutationVariables = Exact<{
  hash: Scalars['String'];
  chain: ChainType;
}>;


export type ClientConfirmedDraftUpsertMutation = { clientConfirmedDraftUpsert: { id: string } | null };

export type ClientDraftSplitUpsertMutationVariables = Exact<{
  txHash: Scalars['String'];
}>;


export type ClientDraftSplitUpsertMutation = { clientDraftSplitUpsert: { id: string } | null };

export type UpdateReferralWithdrawableBalanceMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateReferralWithdrawableBalanceMutation = { updateReferralWithdrawableBalance: { id: string, lastReferralWithdrawableBalance: string | null } };

export type TransactionGiftingUserQueryVariables = Exact<{
  publicAddress?: InputMaybe<Scalars['Address']>;
}>;


export type TransactionGiftingUserQuery = { userByAddress: { id: string, username: string, webappUri: string } | null };

export type AllowlistSearchResultsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type AllowlistSearchResultsQuery = { search: { id: string, releasesPaginated: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'AllowlistReleaseFragment': AllowlistReleaseFragment } }
        ) }> }, artistsPaginated: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'AllowlistArtistFragment': AllowlistArtistFragment } }
        ) }> } } };

export type AllowlistArtistFragment = { id: string, name: string, createdAt: string, user: { id: string, username: string, publicAddress: string, avatar: { id: string, url: string } | null } } & { ' $fragmentName'?: 'AllowlistArtistFragment' };

export type AllowlistReleaseFragment = { id: string, title: string, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, artist: { id: string, name: string, user: { id: string, username: string } }, creditSplit: { id: string, creditAllocations: Array<{ id: string, owner: { id: string } }> } | null } & { ' $fragmentName'?: 'AllowlistReleaseFragment' };

export type InitialUserSearchResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type InitialUserSearchResultsQuery = { artists: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserSearchResultArtistFragment': UserSearchResultArtistFragment } }
      ) }> }, allCollectors: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'UserSearchResultCollectorFragment': UserSearchResultCollectorFragment } }
      ) }> } };

export type UserSearchResultsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type UserSearchResultsQuery = { search: { id: string, artistsPaginated: { edges: Array<{ node: { ' $fragmentRefs'?: { 'UserSearchResultArtistFragment': UserSearchResultArtistFragment } } }> }, collectors: { edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'UserSearchResultCollectorFragment': UserSearchResultCollectorFragment } }
        ) }> } } };

export type UserSearchResultArtistFragment = { id: string, name: string, webappUri: string, user: { id: string, publicAddress: string, avatar: { id: string, url: string, dominantColor: string | null } | null } } & { ' $fragmentName'?: 'UserSearchResultArtistFragment' };

export type UserSearchResultCollectorFragment = { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string, dominantColor: string | null } | null } & { ' $fragmentName'?: 'UserSearchResultCollectorFragment' };

export type AdminDeletePostMutationVariables = Exact<{
  postId: Scalars['UUID'];
}>;


export type AdminDeletePostMutation = { adminDeletePost: { __typename: 'MutationAdminDeletePostSuccess' } | { __typename: 'NotFoundError' } };

export type AdminDeletePostCommentMutationVariables = Exact<{
  postCommentId: Scalars['UUID'];
}>;


export type AdminDeletePostCommentMutation = { adminDeletePostComment: { __typename: 'MutationAdminDeletePostCommentSuccess' } | { __typename: 'NotFoundError' } | { __typename: 'ValidationError' } };

export type AdminDeletePostCommentReplyMutationVariables = Exact<{
  postCommentId: Scalars['UUID'];
}>;


export type AdminDeletePostCommentReplyMutation = { adminDeletePostCommentReply: { __typename: 'MutationAdminDeletePostCommentReplySuccess' } | { __typename: 'NotFoundError' } | { __typename: 'ValidationError' } };

export type ArtistInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ArtistInfoQuery = { authUser: { id: string, artist: { id: string, name: string, soundHandle: string, webappUri: string, spotifyUrl: string | null, bannerImage: { id: string, url: string, key: string } | null } | null } | null };

export type AuthArtistApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthArtistApplicationQuery = { artistApplication: { id: string, status: ArtistApplicationStatus } | null };

export type UserBackendPersistedDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBackendPersistedDataQuery = { getUserPersistedData: unknown };

export type SetUserPersistedDataMutationVariables = Exact<{
  data: Scalars['JSON'];
}>;


export type SetUserPersistedDataMutation = { setUserPersistedData: { __typename: 'MutationSetUserPersistedDataSuccess', data: unknown } | { __typename: 'ValidationError', message: string } };

export type ReleaseReferrableInfoFragment = (
  { id: string, publicAffiliateFeeBPS: number | null, isFirstPhaseCompleted: boolean, samAddress: string | null, price: string, artist: { id: string, user: { id: string, publicAddress: string } }, credits: Array<{ id: string, publicAddress: string }> }
  & { ' $fragmentRefs'?: { 'ReleaseSuperMinterV2InfoFragment': ReleaseSuperMinterV2InfoFragment } }
) & { ' $fragmentName'?: 'ReleaseReferrableInfoFragment' };

export type ArtistMintingOptionsQueryVariables = Exact<{
  artistId: Scalars['UUID'];
}>;


export type ArtistMintingOptionsQuery = { artistMintingOptions: { auction: Array<{ __typename: 'FixedAuction', quantityOptions: Array<number>, presaleMaxMintsPerWalletOptions: Array<number>, publicSaleMaxMintsPerWalletOptions: Array<number>, minPrice: number, maxPrice: number, presaleMinPrice: number, presaleMaxPrice: number, minQuantity: number, maxQuantity: number, mintingStartsInDays: Array<number>, priceOptions: Array<number>, minPublicSaleMaxMintsPerWallet: number, maxPublicSaleMaxMintsPerWallet: number, minPresaleMaxMintsPerWallet: number, maxPresaleMaxMintsPerWallet: number } | { __typename: 'OpenEditionAuction', minOptions: Array<number>, minPrice: number, maxPrice: number, presaleMinPrice: number, presaleMaxPrice: number, mintingPeriodDays: Array<number>, mintingStartsInDays: Array<number>, priceOptions: Array<number> } | { __typename: 'OpenEditionWithSAMAuction', minOptions: Array<number>, inflectionCountSAM: number, inflectionMultipleBPS: number, linearPriceSlope: string, minPrice: number, maxPrice: number, presaleMinPrice: number, presaleMaxPrice: number, mintingPeriodDays: Array<number>, mintingStartsInDays: Array<number>, priceOptions: Array<number> }> } };

export type PrepareMintDraftAsyncMutationVariables = Exact<{
  input: PrepareMintDraftAsyncInput;
}>;


export type PrepareMintDraftAsyncMutation = { prepareMintDraftAsync: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'MutationPrepareMintDraftAsyncSuccess', data: { prepareMintDraftAsyncRequestId: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type PrepareMintDraftAsyncStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PrepareMintDraftAsyncStatusQuery = { prepareMintDraftAsyncStatus: { __typename: 'AlreadyMintedError', message: string } | { __typename: 'EmptyMerkleTreeError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'QueryPrepareMintDraftAsyncStatusSuccess', data: { __typename: 'PrepareMintDraftAsyncStatusPending', result: string } | { __typename: 'PrepareMintDraftAsyncStatusSuccess', merkleTreeRoot: string | null } } | { __typename: 'ValidationError', message: string } };

export type GetDraftDeployedSplitQueryVariables = Exact<{
  draftId: Scalars['UUID'];
}>;


export type GetDraftDeployedSplitQuery = { draft: { id: string, info: { splitsInfo: { splitContractAddress: string | null } | null } | null } };

export type GetDeployedDraftReleaseQueryVariables = Exact<{
  draftId: Scalars['UUID'];
}>;


export type GetDeployedDraftReleaseQuery = { draft: { id: string, release: { id: string, contractAddress: string, type: ReleaseType, chainId: number, webappUri: string } | null } };

export type GetReleaseMintDetailsQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type GetReleaseMintDetailsQuery = { release: { id: string, mintStartTime: number, contractAddress: string } | null };

export type ShouldDeployNewSplitQueryVariables = Exact<{
  draftId: Scalars['UUID'];
}>;


export type ShouldDeployNewSplitQuery = { shouldDeployNewSplit: { __typename: 'NotFoundError', message: string } | { __typename: 'QueryShouldDeployNewSplitSuccess', data: boolean } };

export type DraftMetadataUploadMutationVariables = Exact<{
  input: DraftMetadataUploadInput;
}>;


export type DraftMetadataUploadMutation = { draftMetadataUpload: { __typename: 'ArweavePerUserBudgetExceededError', message: string } | { __typename: 'MutationDraftMetadataUploadSuccess', data: { arweaveHash: string, storefrontArweaveHash: string } } | { __typename: 'NotAllowedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'ValidationError', message: string } };

export type RegisterDraftCreateSplitTxMutationVariables = Exact<{
  draftId: Scalars['UUID'];
  hash: Scalars['String'];
  chain: ChainType;
}>;


export type RegisterDraftCreateSplitTxMutation = { registerDraftCreateSplitTx: { id: string, hash: string } };

export type EthToUsdConversionQueryVariables = Exact<{ [key: string]: never; }>;


export type EthToUsdConversionQuery = { currencies: { ethToUsd: number } };

export type GetCollectedReleasesNftCountQueryVariables = Exact<{
  userId: Scalars['UUID'];
  releaseId: Scalars['UUID'];
}>;


export type GetCollectedReleasesNftCountQuery = { user: { id: string, collectedReleases: { edges: Array<{ node: { id: string, nftsCount: number } }> } } | null };

export type ReleasesArePresavedQueryVariables = Exact<{
  releaseIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type ReleasesArePresavedQuery = { userReleaseStatus: Array<{ isPreSaved: boolean, releaseId: string }> };

export type ReleaseSuperMinterV2InfoFragment = { listing: { __typename: 'TieredEditionListing', id: string, schedules: Array<{ id: string, minterAddress: string }> } | null } & { ' $fragmentName'?: 'ReleaseSuperMinterV2InfoFragment' };

export type UserNfTsForReleaseQueryVariables = Exact<{
  id: Scalars['UUID'];
  filter?: InputMaybe<UserNftsConnectionFilters>;
  pagination: NftCursorConnectionArgs;
}>;


export type UserNfTsForReleaseQuery = { user: { id: string, nftsPaginated: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, songSlot: number | null, tokenId: string, isGoldenEgg: boolean, tierNumber: number | null, serialNumber: number, comment: { id: string, message: string } | null, owner: { id: string, publicAddress: string } } }> } } | null };

export type LastOwnedReleaseNftQueryVariables = Exact<{
  userId: Scalars['UUID'];
  releaseId: Scalars['UUID'];
}>;


export type LastOwnedReleaseNftQuery = { user: { id: string, nftsPaginated: { edges: Array<{ node: { id: string, songSlot: number | null, comment: { id: string, message: string } | null } }> } } | null };

export type CollectorStatusQueryVariables = Exact<{
  userId: Scalars['UUID'];
  releaseId: Scalars['UUID'];
}>;


export type CollectorStatusQuery = { user: { id: string, collectedReleases: { edges: Array<{ node: { id: string } }> } } | null };

export type ListeningPartyReleaseInfoQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type ListeningPartyReleaseInfoQuery = { release: { id: string, saleSchedules: Array<{ id: string, merkleTreeRoot: string | null, startTime: string }> } | null };

export type ReleasePlaylistUrlReleaseInfoFragment = (
  { id: string, webappUri: string }
  & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
) & { ' $fragmentName'?: 'ReleasePlaylistUrlReleaseInfoFragment' };

export type ReleasePlaylistUrlPlaylistInfoFragment = { id: string, user: { id: string, publicAddress: string } } & { ' $fragmentName'?: 'ReleasePlaylistUrlPlaylistInfoFragment' };

export type PublishCommentMutationVariables = Exact<{
  nftId: Scalars['UUID'];
  message: Scalars['String'];
}>;


export type PublishCommentMutation = { setComment: (
    { id: string, comment: { id: string, message: string } | null, releaseCollector: { id: string } | null, release: (
      { id: string }
      & { ' $fragmentRefs'?: { 'ShareToSocialModalReleaseInfoFragment': ShareToSocialModalReleaseInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'ShareToSocialModalNftInfoFragment': ShareToSocialModalNftInfoFragment } }
  ) };

export type SelectCommentSongSlotMutationVariables = Exact<{
  songSlot: Scalars['Int'];
  nftId: Scalars['UUID'];
}>;


export type SelectCommentSongSlotMutation = { selectSongSlotUsingNftId: { __typename: 'AuthorizationError', message: string } | { __typename: 'MaxValueError', message: string } | { __typename: 'MinValueError', message: string } | { __typename: 'MutationSelectSongSlotUsingNftIdSuccess', data: { id: string, songSlot: number | null } } | { __typename: 'UnexpectedValueError', message: string } | { __typename: 'UniqueConstraintError', message: string } };

export type NftCommentQueryVariables = Exact<{
  nftId: Scalars['UUID'];
}>;


export type NftCommentQuery = { nftFromId: { id: string, comment: { id: string, message: string } | null } | null };

export type RecentDropsPageQueryVariables = Exact<{
  pagination?: InputMaybe<ReleasesCursorConnectionArgs>;
  filter?: InputMaybe<ReleasesCursorFilterArgs>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type RecentDropsPageQuery = { releases: { edges: Array<{ node: (
        { id: string, track: { id: string } }
        & { ' $fragmentRefs'?: { 'ReleaseInfoCardFragment': ReleaseInfoCardFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type UserReleaseTokensQueryVariables = Exact<{
  id: Scalars['UUID'];
  filter?: InputMaybe<UserNftsConnectionFilters>;
  pagination: NftCursorConnectionArgs;
}>;


export type UserReleaseTokensQuery = { user: { id: string, nftsPaginated: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ cursor: string, node: { id: string, tokenId: string, songSlot: number | null, isGoldenEgg: boolean, tierNumber: number | null, serialNumber: number, comment: { id: string, message: string } | null, owner: { id: string, publicAddress: string } } }> } } | null };

export type LatestNftQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type LatestNftQuery = { nftFromId: { id: string, tokenId: string, songSlot: number | null, serialNumber: number, tierNumber: number | null, isGoldenEgg: boolean, comment: { id: string, message: string } | null, owner: { id: string, publicAddress: string } } | null };

export type MoreDiscoveredOnQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
  pagination?: InputMaybe<ReleaseShelvesCursorConnectionArgs>;
  filter?: InputMaybe<ReleaseShelvesFilter>;
}>;


export type MoreDiscoveredOnQuery = { release: { id: string, shelves: { edges: Array<{ node: (
          { id: string, type: ShelfType }
          & { ' $fragmentRefs'?: { 'PlaylistCardDetailsFragment': PlaylistCardDetailsFragment } }
        ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } | null };

export type SelectReleaseSongSlotQueryVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type SelectReleaseSongSlotQuery = { release: { id: string, claimedSongSlots: Array<number>, track: { id: string } } | null };

export type SpotifyConnectMutationVariables = Exact<{
  input: MutationConnectSpotifyInput;
}>;


export type SpotifyConnectMutation = { connectSpotify: { __typename: 'MutationConnectSpotifySuccess', data: { id: string } } | { __typename: 'SpotifyAPIError', message: string } | { __typename: 'UniqueConstraintError', message: string } | { __typename: 'ValidationError', message: string } };

export type SpotifyConnectStateQueryVariables = Exact<{ [key: string]: never; }>;


export type SpotifyConnectStateQuery = { spotifyConnection: { id: string } | null };

export type ReleaseUpdatesFragment = { id: string, finalQuantity: number | null, numSold: number, isFirstPhaseCompleted: boolean, totalSupply: number, totalMinted: number, chainId: number, samBuyBufferBpsOverride: number | null, samSellBufferBpsOverride: number | null, saleDetails: { soundSwapCollected: number, soundSwapRaisedInWei: string, primaryCollected: number, primaryRaisedInWei: string, totalVolume: string } } & { ' $fragmentName'?: 'ReleaseUpdatesFragment' };

export type MinimalReleaseUpdatesSubscriptionVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type MinimalReleaseUpdatesSubscription = { releaseUpdates: { id: string, finalQuantity: number | null, numSold: number, isFirstPhaseCompleted: boolean, totalSupply: number, totalMinted: number, chainId: number, soundSwapCollected: number, soundSwapRaisedInWei: string, samBuyBufferBpsOverride: number | null, samSellBufferBpsOverride: number | null, primaryCollected: number, primaryRaisedInWei: string, totalVolume: string } };

export type ReleaseCollectorUpdateSubscriptionVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type ReleaseCollectorUpdateSubscription = { releaseCollectorUpdates: { releaseId: string, userPublicAddress: string, collector: { id: string, nftsCount: number, userId: string, lowestNftSerialNumber: number } | null } };

export type ReleaseNftCommentsUpdatesSubscriptionVariables = Exact<{
  releaseId: Scalars['UUID'];
}>;


export type ReleaseNftCommentsUpdatesSubscription = { releaseNftCommentUpdate: Array<{ id: string, serialNumber: number, updatedAt: string, isGoldenEgg: boolean, ownerReleaseLowestNftSerialNumber: number, songSlot: number, ownerAvatarUrl: string | null, ownerPublicAddress: string, ownerWebappUri: string, ownerArtistId: string | null, ownerArtistName: string | null, ownerArtistSoundHandle: string | null, ownerUserId: string, ownerReleaseNftCount: number, ownerUsername: string, commentMessage: string }> };

export type TopTrendingPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopTrendingPostsQuery = { topTrendingPosts: Array<(
    { __typename: 'ActivityFeedGroupBackingPost', id: string, createdAt: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TopPostInfo_ActivityFeedGroupBackingPost_Fragment': TopPostInfo_ActivityFeedGroupBackingPost_Fragment;'FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment': FeedPostActionsInfo_ActivityFeedGroupBackingPost_Fragment;'PostGroupItem_ActivityFeedGroupBackingPost_Fragment': PostGroupItem_ActivityFeedGroupBackingPost_Fragment;'OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment': OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { __typename: 'ArtistDropPost', id: string, createdAt: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TopPostInfo_ArtistDropPost_Fragment': TopPostInfo_ArtistDropPost_Fragment;'TopArtistDropPostFragment': TopArtistDropPostFragment;'FeedPostActionsInfo_ArtistDropPost_Fragment': FeedPostActionsInfo_ArtistDropPost_Fragment;'PostGroupItem_ArtistDropPost_Fragment': PostGroupItem_ArtistDropPost_Fragment;'OriginalPostInfo_ArtistDropPost_Fragment': OriginalPostInfo_ArtistDropPost_Fragment } }
  ) | (
    { __typename: 'PlaylistPost', id: string, createdAt: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TopPostInfo_PlaylistPost_Fragment': TopPostInfo_PlaylistPost_Fragment;'TopPlaylistPostFragment': TopPlaylistPostFragment;'FeedPostActionsInfo_PlaylistPost_Fragment': FeedPostActionsInfo_PlaylistPost_Fragment;'PostGroupItem_PlaylistPost_Fragment': PostGroupItem_PlaylistPost_Fragment;'OriginalPostInfo_PlaylistPost_Fragment': OriginalPostInfo_PlaylistPost_Fragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, createdAt: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TopPostInfo_ReleasePost_Fragment': TopPostInfo_ReleasePost_Fragment;'TopReleasePostFragment': TopReleasePostFragment;'FeedPostActionsInfo_ReleasePost_Fragment': FeedPostActionsInfo_ReleasePost_Fragment;'PostGroupItem_ReleasePost_Fragment': PostGroupItem_ReleasePost_Fragment;'OriginalPostInfo_ReleasePost_Fragment': OriginalPostInfo_ReleasePost_Fragment } }
  ) | (
    { __typename: 'Repost', id: string, createdAt: string, webappUri: string, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'TopPostInfo_Repost_Fragment': TopPostInfo_Repost_Fragment;'FeedPostActionsInfo_Repost_Fragment': FeedPostActionsInfo_Repost_Fragment;'PostGroupItem_Repost_Fragment': PostGroupItem_Repost_Fragment;'TopPostRepostFragment': TopPostRepostFragment;'OriginalPostInfo_Repost_Fragment': OriginalPostInfo_Repost_Fragment } }
  )> };

export type TopPostRepostFragment = (
  { creator: { id: string, username: string, webappUri: string }, originalPost: (
    { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_ActivityFeedGroupBackingPost_Fragment': PostGroupItem_ActivityFeedGroupBackingPost_Fragment;'OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment': OriginalPostInfo_ActivityFeedGroupBackingPost_Fragment } }
  ) | (
    { __typename: 'ArtistDropPost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_ArtistDropPost_Fragment': PostGroupItem_ArtistDropPost_Fragment;'OriginalPostInfo_ArtistDropPost_Fragment': OriginalPostInfo_ArtistDropPost_Fragment } }
  ) | (
    { __typename: 'PlaylistPost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_PlaylistPost_Fragment': PostGroupItem_PlaylistPost_Fragment;'OriginalPostInfo_PlaylistPost_Fragment': OriginalPostInfo_PlaylistPost_Fragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_ReleasePost_Fragment': PostGroupItem_ReleasePost_Fragment;'OriginalPostInfo_ReleasePost_Fragment': OriginalPostInfo_ReleasePost_Fragment } }
  ) | (
    { __typename: 'Repost', id: string, webappUri: string, createdAt: string, commentCount: number, creator: (
      { id: string }
      & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'PostGroupItem_Repost_Fragment': PostGroupItem_Repost_Fragment;'OriginalPostInfo_Repost_Fragment': OriginalPostInfo_Repost_Fragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'ActionButtonsRepostSourceFragment': ActionButtonsRepostSourceFragment;'RepostSourceFragment': RepostSourceFragment;'PostItemRepostSourceFragment': PostItemRepostSourceFragment } }
) & { ' $fragmentName'?: 'TopPostRepostFragment' };

type TopPostInfo_ActivityFeedGroupBackingPost_Fragment = { id: string, content: string, lexicalContent: unknown | null, commentCount: number, upvoteCount: number, webappUri: string, createdAt: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'TopPostInfo_ActivityFeedGroupBackingPost_Fragment' };

type TopPostInfo_ArtistDropPost_Fragment = { id: string, content: string, lexicalContent: unknown | null, commentCount: number, upvoteCount: number, webappUri: string, createdAt: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'TopPostInfo_ArtistDropPost_Fragment' };

type TopPostInfo_PlaylistPost_Fragment = { id: string, content: string, lexicalContent: unknown | null, commentCount: number, upvoteCount: number, webappUri: string, createdAt: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'TopPostInfo_PlaylistPost_Fragment' };

type TopPostInfo_ReleasePost_Fragment = { id: string, content: string, lexicalContent: unknown | null, commentCount: number, upvoteCount: number, webappUri: string, createdAt: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'TopPostInfo_ReleasePost_Fragment' };

type TopPostInfo_Repost_Fragment = { id: string, content: string, lexicalContent: unknown | null, commentCount: number, upvoteCount: number, webappUri: string, createdAt: string, creator: (
    { id: string }
    & { ' $fragmentRefs'?: { 'FeedActivityItemUserInfoFragment': FeedActivityItemUserInfoFragment } }
  ) } & { ' $fragmentName'?: 'TopPostInfo_Repost_Fragment' };

export type TopPostInfoFragment = TopPostInfo_ActivityFeedGroupBackingPost_Fragment | TopPostInfo_ArtistDropPost_Fragment | TopPostInfo_PlaylistPost_Fragment | TopPostInfo_ReleasePost_Fragment | TopPostInfo_Repost_Fragment;

export type TopPlaylistPostFragment = { optionalShelf: { id: string, name: string } | null } & { ' $fragmentName'?: 'TopPlaylistPostFragment' };

export type TopReleasePostFragment = { optionalRelease: { id: string, title: string, listeningParty: number | null, artist: { id: string, name: string }, track: { id: string } } | null } & { ' $fragmentName'?: 'TopReleasePostFragment' };

export type TopArtistDropPostFragment = { release: (
    { id: string, title: string, listeningParty: number | null, artist: { id: string, name: string }, track: { id: string } }
    & { ' $fragmentRefs'?: { 'ArtistDropReleaseFragment': ArtistDropReleaseFragment } }
  ) } & { ' $fragmentName'?: 'TopArtistDropPostFragment' };

export type ReleaseTrackAudioInfoFragment = (
  { id: string, title: string, webappUri: string, type: ReleaseType, mintStartTimestamp: number, listeningParty: number | null, spotifyTrackId: string | null, artist: { id: string, name: string, webappUri: string, user: { id: string, username: string } }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null, animatedCoverImage: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'FeedPostModalMainSoundFragment': FeedPostModalMainSoundFragment } }
) & { ' $fragmentName'?: 'ReleaseTrackAudioInfoFragment' };

export type TrackAudioInfoFragment = { id: string, audio: { audio128k: { id: string, url: string } | null, audioHls: { id: string, url: string } | null, audioOriginal: { id: string, url: string } } } & { ' $fragmentName'?: 'TrackAudioInfoFragment' };

export type UpcomingDropsPageQueryVariables = Exact<{
  pagination?: InputMaybe<ReleasesCursorConnectionArgs>;
  filter?: InputMaybe<ReleasesCursorFilterArgs>;
}>;


export type UpcomingDropsPageQuery = { releases: { edges: Array<{ node: (
        { id: string, mintStartTime: number, track: { id: string } }
        & { ' $fragmentRefs'?: { 'UpcomingDropCardFragment': UpcomingDropCardFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type ArtistProfileNewQueryVariables = Exact<{
  soundHandle: Scalars['String'];
}>;


export type ArtistProfileNewQuery = { artistByHandle: (
    { id: string, name: string, webappUri: string, numReleases: number, bannerImage: { id: string, url: string } | null, pickedRelease: { id: string } | null }
    & { ' $fragmentRefs'?: { 'ArtistHeroFragment': ArtistHeroFragment;'CollectorSectionFragment': CollectorSectionFragment;'SectionExpandedArtistInfoFragment': SectionExpandedArtistInfoFragment } }
  ) | null, userByArtistHandle: (
    { id: string, description: string | null, publicAddress: string, twitterHandle: string | null, avatar: { id: string, url: string } | null, artist: { id: string, soundHandle: string } | null }
    & { ' $fragmentRefs'?: { 'UserInfoSectionFragment': UserInfoSectionFragment;'UserSoundCollectionFragment': UserSoundCollectionFragment;'SectionExpandedUserInfoFragment': SectionExpandedUserInfoFragment;'AboutSectionFragment': AboutSectionFragment;'ArtistActionBarFragment': ArtistActionBarFragment } }
  ) | null };

export type TrendingReleasesQueryVariables = Exact<{
  timePeriod: TimePeriodAggEnum;
  sort: TrendingReleasesSortEnum;
}>;


export type TrendingReleasesQuery = { topReleases: Array<{ totalSales: string, totalSalesUsd: number, nftsSold: number, uniqueCollectors: number, release: { id: string, title: string, webappUri: string, staticCoverImage: { id: string, url: string } | null, coverImage: { id: string, url: string }, artist: { id: string, name: string, webappUri: string } } }> };

export type TrendingArtistInfoQueryVariables = Exact<{
  input: TopArtistsInput;
}>;


export type TrendingArtistInfoQuery = { topArtistsV2: Array<{ totalSales: string, totalSalesUsd: number, uniqueCollectors: number, nftsSold: number, artist: { id: string, soundHandle: string, name: string, webappUri: string, user: { id: string, publicAddress: string, twitterHandle: string | null, username: string, avatar: { id: string, url: string } | null } } | null }> };

export type TrendingCollectorsQueryVariables = Exact<{
  timePeriod: TopChartTimePeriodEnum;
  sort: TrendingCollectorsSortEnum;
}>;


export type TrendingCollectorsQuery = { topCollectorsV2: Array<{ nftsBought: number, totalSpent: string, creatorsSupported: number, user: { id: string, publicAddress: string, twitterHandle: string | null, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string, name: string, webappUri: string, soundHandle: string } | null } | null }> };

export type TrendingCuratorsQueryVariables = Exact<{
  input: TopAffiliateCuratorsInput;
}>;


export type TrendingCuratorsQuery = { topAffiliateCurators: Array<{ soundsReferred: number, mintsQuantity: number, totalVolume: string, user: { id: string, publicAddress: string, twitterHandle: string | null, username: string, webappUri: string, avatar: { id: string, url: string } | null, artist: { id: string, name: string, webappUri: string, soundHandle: string } | null } | null }> };

export type UserProfileFragment = (
  { id: string, username: string, description: string | null, publicAddress: string, ens: string | null, twitterHandle: string | null, avatar: { id: string, url: string } | null, artist: { id: string, webappUri: string, soundHandle: string } | null, featuredReleases: Array<(
    { id: string, release: { id: string, webappUri: string } }
    & { ' $fragmentRefs'?: { 'CollectorFeaturedReleaseFragment': CollectorFeaturedReleaseFragment } }
  )> | null, collectedReleases: { edges: Array<{ node: { id: string } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } }, shelves: { edges: Array<{ node: (
        { id: string }
        & { ' $fragmentRefs'?: { 'ShelfFragment': ShelfFragment } }
      ) }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } }
  & { ' $fragmentRefs'?: { 'UserSoundCollectionFragment': UserSoundCollectionFragment;'BackedArtistSectionFragment': BackedArtistSectionFragment;'SectionExpandedUserInfoFragment': SectionExpandedUserInfoFragment;'AboutSectionFragment': AboutSectionFragment;'UserInfoSectionFragment': UserInfoSectionFragment;'CollectorHeroFragment': CollectorHeroFragment } }
) & { ' $fragmentName'?: 'UserProfileFragment' };

export type GetUserProfileByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetUserProfileByIdQuery = { user: (
    { id: string, ens: string | null, publicAddress: string }
    & { ' $fragmentRefs'?: { 'UserProfileFragment': UserProfileFragment } }
  ) | null };

export type GetUserProfileNewQueryVariables = Exact<{
  publicAddress?: InputMaybe<Scalars['Address']>;
  ens?: InputMaybe<Scalars['ENS']>;
}>;


export type GetUserProfileNewQuery = { userByAddress: (
    { id: string, ens: string | null, publicAddress: string, featuredReleases: Array<{ ' $fragmentRefs'?: { 'CollectorFeaturedReleaseFragment': CollectorFeaturedReleaseFragment } }> | null }
    & { ' $fragmentRefs'?: { 'UserProfileFragment': UserProfileFragment } }
  ) | null };

export type ReleasePageContentFragment = (
  { id: string, title: string, titleSlug: string, type: ReleaseType, externalUrl: string | null, behindTheMusic: string, webappUri: string, numSold: number, contractAddress: string, isFirstPhaseCompleted: boolean, artist: { id: string, name: string, soundHandle: string, user: { id: string, twitterHandle: string | null, publicAddress: string } }, track: { id: string }, coverImage: { id: string, url: string }, staticCoverImage: { id: string, url: string } | null }
  & { ' $fragmentRefs'?: { 'SongViewFragment': SongViewFragment;'CollectModalFragment': CollectModalFragment } }
) & { ' $fragmentName'?: 'ReleasePageContentFragment' };

export type ReleasePageQueryVariables = Exact<{
  soundHandle: Scalars['String'];
  releaseSlug: Scalars['String'];
}>;


export type ReleasePageQuery = { mintedRelease: (
    { id: string }
    & { ' $fragmentRefs'?: { 'ReleasePageContentFragment': ReleasePageContentFragment;'WaveformCommentsReleaseInfoFragment': WaveformCommentsReleaseInfoFragment } }
  ) | null };

export type GetArtistForLikedSoundsQueryVariables = Exact<{
  soundHandle: Scalars['String'];
}>;


export type GetArtistForLikedSoundsQuery = { artistByHandle: { id: string, user: (
      { id: string, username: string, publicAddress: string, webappUri: string, avatar: { id: string, url: string } | null, likedSounds: { id: string, webappUri: string } | null }
      & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
    ) } | null };

export type PostPagePostQueryVariables = Exact<{
  postId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type PostPagePostQuery = { post: (
    { __typename: 'ActivityFeedGroupBackingPost', id: string, content: string, createdAt: string, webappUri: string, channel: { ' $fragmentRefs'?: { 'FeedActivityHeaderChannelInfoFragment': FeedActivityHeaderChannelInfoFragment } } | null, creator: (
      { id: string, username: string, twitterHandle: string | null, avatar: { id: string, url: string } | null, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'FeedActivityFeedGroupBackingPostFragment': FeedActivityFeedGroupBackingPostFragment } }
  ) | { __typename: 'ArtistDropPost', id: string, content: string, createdAt: string, webappUri: string, channel: { ' $fragmentRefs'?: { 'FeedActivityHeaderChannelInfoFragment': FeedActivityHeaderChannelInfoFragment } } | null, creator: (
      { id: string, username: string, twitterHandle: string | null, avatar: { id: string, url: string } | null, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
    ) } | (
    { __typename: 'PlaylistPost', id: string, content: string, createdAt: string, webappUri: string, channel: { ' $fragmentRefs'?: { 'FeedActivityHeaderChannelInfoFragment': FeedActivityHeaderChannelInfoFragment } } | null, creator: (
      { id: string, username: string, twitterHandle: string | null, avatar: { id: string, url: string } | null, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'FeedPlaylistPostFragment': FeedPlaylistPostFragment } }
  ) | (
    { __typename: 'ReleasePost', id: string, content: string, createdAt: string, webappUri: string, channel: { ' $fragmentRefs'?: { 'FeedActivityHeaderChannelInfoFragment': FeedActivityHeaderChannelInfoFragment } } | null, creator: (
      { id: string, username: string, twitterHandle: string | null, avatar: { id: string, url: string } | null, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'FeedReleasePostFragment': FeedReleasePostFragment } }
  ) | { __typename: 'Repost', id: string, content: string, createdAt: string, webappUri: string, originalPost: { __typename: 'ActivityFeedGroupBackingPost', id: string, webappUri: string } | { __typename: 'ArtistDropPost', id: string, webappUri: string } | { __typename: 'PlaylistPost', id: string, webappUri: string } | { __typename: 'ReleasePost', id: string, webappUri: string } | { __typename: 'Repost', id: string, webappUri: string } | null, channel: { ' $fragmentRefs'?: { 'FeedActivityHeaderChannelInfoFragment': FeedActivityHeaderChannelInfoFragment } } | null, creator: (
      { id: string, username: string, twitterHandle: string | null, avatar: { id: string, url: string } | null, artist: { id: string } | null }
      & { ' $fragmentRefs'?: { 'UserActivityDetailFragment': UserActivityDetailFragment } }
    ) } | null };

export type GetAdminStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminStatsQuery = { stats: { totalUsers: number, totalUniqueCollectors: number, totalArtists: number } };

export type AdminUserProfileQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type AdminUserProfileQuery = { user: (
    { id: string, publicAddress: string, avatar: { id: string, url: string, key: string } | null }
    & { ' $fragmentRefs'?: { 'UserDashboardInfoFragment': UserDashboardInfoFragment } }
  ) | null };

export type AdminUserProfileByAddressQueryVariables = Exact<{
  publicAddress: Scalars['Address'];
}>;


export type AdminUserProfileByAddressQuery = { userByAddress: (
    { id: string, publicAddress: string, avatar: { id: string, url: string, key: string } | null }
    & { ' $fragmentRefs'?: { 'UserDashboardInfoFragment': UserDashboardInfoFragment } }
  ) | null };

export type AdminUserNftCommentsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  pagination?: InputMaybe<NftCommentCursorConnectionArgs>;
}>;


export type AdminUserNftCommentsQuery = { adminUserNftComments: { edges: Array<{ node: { __typename: 'Comment', id: string, message: string, createdAt: string } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } };

export type AdminUserPostsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  pagination?: InputMaybe<PostCursorConnectionArgs>;
}>;


export type AdminUserPostsQuery = { adminUserPosts: { edges: Array<{ node: { __typename: 'ActivityFeedGroupBackingPost', id: string, content: string, lexicalContent: unknown | null, createdAt: string } | { __typename: 'ArtistDropPost', id: string, content: string, lexicalContent: unknown | null, createdAt: string } | { __typename: 'PlaylistPost', id: string, content: string, lexicalContent: unknown | null, createdAt: string } | { __typename: 'ReleasePost', id: string, content: string, lexicalContent: unknown | null, createdAt: string } | { __typename: 'Repost', id: string, content: string, lexicalContent: unknown | null, createdAt: string } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } };

export type AdminUserPostCommentsQueryVariables = Exact<{
  userId: Scalars['UUID'];
  pagination?: InputMaybe<PostCommentCursorConnectionArgs>;
}>;


export type AdminUserPostCommentsQuery = { adminUserPostCommentsWithoutNFTComments: { edges: Array<{ node: { __typename: 'PostComment', id: string, content: string, lexicalContent: unknown | null, createdAt: string, parentComment: { id: string } | null } }>, pageInfo: { endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null } } };

export type AdminDisallowUserToPostMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type AdminDisallowUserToPostMutation = { adminDisallowUserToPost: { __typename: 'MutationAdminDisallowUserToPostSuccess' } | { __typename: 'NotFoundError' } };

export type AdminAllowUserToPostMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type AdminAllowUserToPostMutation = { adminAllowUserToPost: { __typename: 'MutationAdminAllowUserToPostSuccess' } | { __typename: 'NotFoundError' } };

export type AdminUserBlockStatusQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type AdminUserBlockStatusQuery = { adminUserBlockStatus: { __typename: 'NotFoundError' } | { __typename: 'QueryAdminUserBlockStatusSuccess', data: boolean } };

export type AdminDeleteAllUserContentMutationVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type AdminDeleteAllUserContentMutation = { adminDeleteAllUserContent: { __typename: 'MutationAdminDeleteAllUserContentSuccess', data: boolean } | { __typename: 'NotFoundError' } };

export type ChannelPageQueryVariables = Exact<{
  channelSlug: Scalars['String'];
}>;


export type ChannelPageQuery = { channelBySlug: (
    { id: string, nameSlug: string, webappUri: string, name: string, description: string | null, published: boolean, staticProfileImage: { id: string, url: string } | null, profileImage: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'ChannelHeroFragment': ChannelHeroFragment;'ChannelInfoFragment': ChannelInfoFragment;'ChannelAboutFragment': ChannelAboutFragment } }
  ) | null };

export type PlaylistChartQueryQueryVariables = Exact<{
  pagination: PlaylistChartRankCursorConnectionArgs;
}>;


export type PlaylistChartQueryQuery = { currentPlaylistChart: { id: string, lastDayOfChartInclusive: string, chartRanks: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PlaylistChartCardFragment': PlaylistChartCardFragment } }
        ) }> } } };

export type ReleaseChartQueryQueryVariables = Exact<{
  pagination: ReleaseChartRankCursorConnectionArgs;
}>;


export type ReleaseChartQueryQuery = { currentReleaseChart: { id: string, lastDayOfChartInclusive: string, chartRanks: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
          { id: string, release: { id: string, title: string, artist: { id: string, name: string }, track: { id: string } } }
          & { ' $fragmentRefs'?: { 'FullSizeChartCardFragment': FullSizeChartCardFragment } }
        ) }> } } };

export type CoinbaseQuestReleaseQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type CoinbaseQuestReleaseQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'CoinbaseSoundBarReleaseFragment': CoinbaseSoundBarReleaseFragment } }
  ) | null };

export type SoundFromContractQueryVariables = Exact<{
  contractAddress: Scalars['Address'];
}>;


export type SoundFromContractQuery = { releaseFromContract: { id: string, webappUri: string } | null };

export type HeroHighlightedReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type HeroHighlightedReleasesQuery = { highlightedReleases: Array<(
    { id: string, track: { id: string } }
    & { ' $fragmentRefs'?: { 'LandingHeroBackgroundFragment': LandingHeroBackgroundFragment;'LandingHeroSlideFragment': LandingHeroSlideFragment } }
  )> };

export type PlaylistEditBasicInfoQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
}>;


export type PlaylistEditBasicInfoQuery = { playlistV2: { id: string, type: ShelfType, webappUri: string, user: { id: string } } | null };

export type SpotifyConnectionModalReleaseQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type SpotifyConnectionModalReleaseQuery = { release: (
    { id: string }
    & { ' $fragmentRefs'?: { 'SpotifyConnectionReleaseInfoFragment': SpotifyConnectionReleaseInfoFragment } }
  ) | null };

export type SpotifyConnectionReleaseInfoFragment = (
  { id: string, title: string, webappUri: string, coverImage: { id: string, url: string }, gaCoverImage: { id: string, url: string } | null, artist: { id: string, name: string, user: { id: string, twitterHandle: string | null } } }
  & { ' $fragmentRefs'?: { 'ReleaseReferrableInfoFragment': ReleaseReferrableInfoFragment } }
) & { ' $fragmentName'?: 'SpotifyConnectionReleaseInfoFragment' };

export type PlaylistViralQueryQueryVariables = Exact<{
  pagination: PlaylistChartRankCursorConnectionArgs;
}>;


export type PlaylistViralQueryQuery = { currentPlaylistChart: { id: string, lastDayOfChartInclusive: string, chartRanks: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
          { id: string }
          & { ' $fragmentRefs'?: { 'PlaylistChartCardFragment': PlaylistChartCardFragment } }
        ) }> } } };

export type ReleaseViralQueryQueryVariables = Exact<{
  pagination: ReleaseChartRankCursorConnectionArgs;
}>;


export type ReleaseViralQueryQuery = { currentReleaseChart: { id: string, lastDayOfChartInclusive: string, chartRanks: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: (
          { id: string, release: { id: string, title: string, artist: { id: string, name: string }, track: { id: string } } }
          & { ' $fragmentRefs'?: { 'FullSizeChartCardFragment': FullSizeChartCardFragment } }
        ) }> } } };

export type GetUserProfileForLikedSoundsQueryVariables = Exact<{
  publicAddress?: InputMaybe<Scalars['Address']>;
  ens?: InputMaybe<Scalars['ENS']>;
}>;


export type GetUserProfileForLikedSoundsQuery = { userByAddress: (
    { id: string, username: string, publicAddress: string, webappUri: string, likedSounds: { id: string, webappUri: string } | null, avatar: { id: string, url: string } | null }
    & { ' $fragmentRefs'?: { 'MinimalUserFragment': MinimalUserFragment } }
  ) | null };

export type VerifyNotificationEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyNotificationEmailMutation = { verifyNotificationEmail: { __typename: 'MutationVerifyNotificationEmailSuccess', data: boolean } | { __typename: 'NotificationEmailAlreadyClaimedError', message: string } | { __typename: 'NotificationEmailTokenExpiredOrInvalidError', message: string } | { __typename: 'NotificationEmailTokenInvalidForUserError', message: string } };

export type ReportPlayStoppedAnalyticsMutationVariables = Exact<{
  input: ReportPlayStoppedInput;
}>;


export type ReportPlayStoppedAnalyticsMutation = { reportPlayStopped: null | null };

export type GetPlaylistQueryVariables = Exact<{
  input: PlaylistInput;
}>;


export type GetPlaylistQuery = { playlist: { id: string, tracks: Array<{ id: string, releaseId: string, artistId: string }> } | { id: string, tracks: Array<{ id: string, releaseId: string, artistId: string }> } | { id: string, tracks: Array<{ id: string, releaseId: string, artistId: string }> } | null };

export type GetPlaylistTrackIdsQueryVariables = Exact<{
  playlistId: Scalars['UUID'];
}>;


export type GetPlaylistTrackIdsQuery = { playlistV2: { id: string, trackIds: Array<string>, releaseIds: Array<string> } | null };

export type NftCommentTypeFragment = { id: string, serialNumber: number, updatedAt: string, songSlot: number | null, isGoldenEgg: boolean, owner: { id: string, publicAddress: string, username: string, webappUri: string, artist: { id: string } | null, avatar: { id: string, url: string } | null }, comment: { id: string, message: string } | null } & { ' $fragmentName'?: 'NftCommentTypeFragment' };

export type ReleaseCommentTypeFragment = { id: string, track: { id: string, duration: number } } & { ' $fragmentName'?: 'ReleaseCommentTypeFragment' };

export type MerkleProofQueryVariables = Exact<{
  root: Scalars['String'];
  unhashedLeaf: Scalars['String'];
}>;


export type MerkleProofQuery = { merkleTreeProof: { proof: Array<string> } | null };

export type SignedUploadParamsQueryVariables = Exact<{
  uploadRequest: UploadRequest;
}>;


export type SignedUploadParamsQuery = { signedUploadParams: { uploadKey: string, url: string, fields: unknown } };

export type CreateMultipartUploadMutationVariables = Exact<{
  input: MultipartUploadRequest;
}>;


export type CreateMultipartUploadMutation = { createMultipartUpload: { __typename: 'AwsRequestError', requestId: string, message: string } | { __typename: 'MutationCreateMultipartUploadSuccess', data: { uploadId: string, uploadKey: string, signedUrls: Array<{ partNumber: number, url: string }> } } };

export type AbortMultipartUploadMutationVariables = Exact<{
  input: AbortMultipartUploadRequest;
}>;


export type AbortMultipartUploadMutation = { abortMultipartUpload: { __typename: 'AwsRequestError', requestId: string, message: string } | { __typename: 'MutationAbortMultipartUploadSuccess', data: { __typename: 'AbortMultipartUploadOutput', uploadKey: string } } };

export type CompleteMultipartUploadMutationVariables = Exact<{
  input: CompleteMultipartUploadRequest;
}>;


export type CompleteMultipartUploadMutation = { completeMultipartUpload: { __typename: 'AwsRequestError', requestId: string, message: string } | { __typename: 'MutationCompleteMultipartUploadSuccess', data: { uploadKey: string } } };
